// Generated from context/domino sources for runtime-local domino scene data.
// Do not edit manually; regenerate from the compiled domino references if needed.

export const DOMINO_RENDER_SCENES_DATA = [
  {
    "slug": "straight-line",
    "top_extract": {
      "blocks": [
        {
          "x": 1724,
          "y": 567.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1884.5,
          "y": 567.5,
          "w": 53,
          "h": 19,
          "angle": -90
        },
        {
          "x": 26.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 58.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 90.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 122.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 154.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 187.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 219.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 251.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 283.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 315.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 347.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 379.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 411.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 443.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 475.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 507.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 539.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 571.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 603.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 635.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 667.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 699.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 731.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 763.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 795.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 827.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 859.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 891.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 923.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 955.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 987.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1019.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1051.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1083.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1115.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1147.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1180,
          "y": 568,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1211.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1243.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1275.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1307.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1339.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1371.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1404,
          "y": 568,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1436,
          "y": 568,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1468,
          "y": 568,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1499.5,
          "y": 568,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1532,
          "y": 568,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1564,
          "y": 568,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1596,
          "y": 568,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1628,
          "y": 568,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1660,
          "y": 568,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1692,
          "y": 568,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1756,
          "y": 568,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1788.5,
          "y": 568,
          "w": 52,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1820.5,
          "y": 568,
          "w": 52,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1852.5,
          "y": 568,
          "w": 52,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1913,
          "y": 568,
          "w": 52,
          "h": 12,
          "angle": -90
        }
      ]
    },
    "connection_blocks": [
      "min_x",
      "max_x"
    ]
  },
  {
    "slug": "straight-double-line",
    "top_extract": {
      "blocks": [
        {
          "x": 533,
          "y": 497.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 20.5,
          "y": 517,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 52.5,
          "y": 517,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 84.5,
          "y": 517,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 116.5,
          "y": 517,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 148.5,
          "y": 517,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 181,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 213,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 244.5,
          "y": 517,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 277,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 308.5,
          "y": 517,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 341,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 372.5,
          "y": 517,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 404.5,
          "y": 517,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 437,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 468.5,
          "y": 517,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 501,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 565,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 597,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 629,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 660.5,
          "y": 517,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 693,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 725,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 757,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 789,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 821,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 853,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 885,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 917,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 949,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 981,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1013,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1045,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1077,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1109,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1141,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1173,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1205,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1236.5,
          "y": 517,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1269,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1301,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1333,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1365,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1397,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1429,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1461,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1493,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1525,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1557,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1589,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1621,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1653,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1685,
          "y": 517,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1716,
          "y": 517,
          "w": 52,
          "h": 22,
          "angle": -90
        },
        {
          "x": 1749.5,
          "y": 517.5,
          "w": 53,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1785,
          "y": 517.5,
          "w": 53,
          "h": 24,
          "angle": -90
        },
        {
          "x": 1817,
          "y": 517.5,
          "w": 53,
          "h": 28,
          "angle": -90
        },
        {
          "x": 1849,
          "y": 517.5,
          "w": 53,
          "h": 28,
          "angle": -90
        },
        {
          "x": 1881,
          "y": 517.5,
          "w": 53,
          "h": 28,
          "angle": -90
        },
        {
          "x": 1908.5,
          "y": 517.5,
          "w": 53,
          "h": 21,
          "angle": -90
        },
        {
          "x": 533,
          "y": 550.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1749.5,
          "y": 583.5,
          "w": 53,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1786,
          "y": 583.5,
          "w": 53,
          "h": 26,
          "angle": -90
        },
        {
          "x": 1849,
          "y": 583.5,
          "w": 53,
          "h": 28,
          "angle": -90
        },
        {
          "x": 1893,
          "y": 583.5,
          "w": 53,
          "h": 52,
          "angle": -90
        },
        {
          "x": 20.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 52.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 84.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 116.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 148.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 181,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 212.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 245,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 276.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 308.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 340.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 373,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 405,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 436.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 468.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 501,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 565,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 597,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 628.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 660.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 693,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 725,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 757,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 789,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 821,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 853,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 885,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 917,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 949,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 981,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1013,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1045,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1077,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1109,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1141,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1173,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1205,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1236.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1269,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1301,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1333,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1365,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1397,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1429,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1461,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1493,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1525,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1557,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1589,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1621,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1653,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1685,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1717.5,
          "y": 584,
          "w": 52,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1817,
          "y": 584,
          "w": 52,
          "h": 28,
          "angle": -90
        },
        {
          "x": 533,
          "y": 603.5,
          "w": 53,
          "h": 18,
          "angle": -90
        }
      ]
    },
    "connection_blocks": [
      1,
      65,
      59,
      64
    ]
  },
  {
    "slug": "curve",
    "top_extract": {
      "blocks": [
        {
          "x": 8.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 40,
          "y": 490,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 72,
          "y": 490,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 104,
          "y": 490,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 136,
          "y": 490,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 168,
          "y": 490,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 200,
          "y": 490,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 232,
          "y": 490,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 265.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 297.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 329.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 361.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 393.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 425.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 457.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 489.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 521.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 553.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 585.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 617.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 649.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 681.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 714.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 746.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 780.1,
          "y": 493,
          "w": 53.2,
          "h": 18.2,
          "angle": -81.9
        },
        {
          "x": 813.3,
          "y": 500.1,
          "w": 53,
          "h": 18.3,
          "angle": -73.7
        },
        {
          "x": 845.3,
          "y": 512.1,
          "w": 53.1,
          "h": 18.5,
          "angle": -65.6
        },
        {
          "x": 875.1,
          "y": 528.4,
          "w": 53.2,
          "h": 18.4,
          "angle": -56.9
        },
        {
          "x": 902.6,
          "y": 549,
          "w": 53.2,
          "h": 19,
          "angle": -49
        },
        {
          "x": 926.4,
          "y": 572.7,
          "w": 53,
          "h": 19.1,
          "angle": -40.6
        },
        {
          "x": 946.8,
          "y": 600.2,
          "w": 53.1,
          "h": 18.6,
          "angle": -32.7
        },
        {
          "x": 963.2,
          "y": 630,
          "w": 53.2,
          "h": 18.5,
          "angle": -24.1
        },
        {
          "x": 975.2,
          "y": 661.8,
          "w": 53.4,
          "h": 18.4,
          "angle": -16.5
        },
        {
          "x": 982.3,
          "y": 695.1,
          "w": 53.2,
          "h": 18.3,
          "angle": -8.5
        },
        {
          "x": 985,
          "y": 729,
          "w": 52,
          "h": 18,
          "angle": 0
        },
        {
          "x": 985,
          "y": 759.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 985,
          "y": 791.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 985,
          "y": 823.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 985,
          "y": 855.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 985,
          "y": 887.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 985,
          "y": 919.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 985,
          "y": 951.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 985,
          "y": 983.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 985,
          "y": 1015.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 985,
          "y": 1047.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 985,
          "y": 1075,
          "w": 52,
          "h": 8,
          "angle": 0
        }
      ]
    }
  },
  {
    "slug": "double-curve",
    "top_extract": {
      "blocks": [
        {
          "x": 681.5,
          "y": 403.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 649.5,
          "y": 422.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 8.5,
          "y": 423,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 40,
          "y": 423,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 72,
          "y": 423,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 104,
          "y": 423,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 136,
          "y": 423,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 168,
          "y": 423,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 200,
          "y": 423,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 232,
          "y": 423,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 265.5,
          "y": 423,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 297.5,
          "y": 423,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 329.5,
          "y": 423,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 361.5,
          "y": 423,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 393.5,
          "y": 423,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 425.5,
          "y": 423,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 457.5,
          "y": 423,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 489.5,
          "y": 423,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 521.5,
          "y": 423,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 553.5,
          "y": 423,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 585.5,
          "y": 423,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 617.5,
          "y": 423,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 714.5,
          "y": 423,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 746.5,
          "y": 423,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 778.3,
          "y": 425.1,
          "w": 53.3,
          "h": 18.4,
          "angle": -84.1
        },
        {
          "x": 809.8,
          "y": 430.2,
          "w": 53.2,
          "h": 18.3,
          "angle": -77.9
        },
        {
          "x": 840.8,
          "y": 438.3,
          "w": 53.2,
          "h": 18.5,
          "angle": -72.1
        },
        {
          "x": 870.5,
          "y": 449.8,
          "w": 53.5,
          "h": 19,
          "angle": -65.6
        },
        {
          "x": 681.5,
          "y": 456.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 899.1,
          "y": 464.5,
          "w": 53.4,
          "h": 19,
          "angle": -60.9
        },
        {
          "x": 925.9,
          "y": 481.9,
          "w": 53.4,
          "h": 18.6,
          "angle": -54.2
        },
        {
          "x": 8.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 40,
          "y": 490,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 72,
          "y": 490,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 104,
          "y": 490,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 136,
          "y": 490,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 168,
          "y": 490,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 200,
          "y": 490,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 232,
          "y": 490,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 265.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 297.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 329.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 361.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 393.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 425.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 457.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 489.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 521.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 553.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 585.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 617.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 649.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 714.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 746.5,
          "y": 490,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 780.1,
          "y": 492.9,
          "w": 53.5,
          "h": 18.5,
          "angle": -81.9
        },
        {
          "x": 813.4,
          "y": 500,
          "w": 53.3,
          "h": 18.7,
          "angle": -73.6
        },
        {
          "x": 950.7,
          "y": 502,
          "w": 53.8,
          "h": 18.7,
          "angle": -47.5
        },
        {
          "x": 681.5,
          "y": 509.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 845.5,
          "y": 512,
          "w": 53.4,
          "h": 18.8,
          "angle": -65.7
        },
        {
          "x": 973.5,
          "y": 524.7,
          "w": 53.3,
          "h": 18.9,
          "angle": -41.6
        },
        {
          "x": 875.2,
          "y": 528.3,
          "w": 53.3,
          "h": 18.8,
          "angle": -57.8
        },
        {
          "x": 902.8,
          "y": 548.8,
          "w": 53.7,
          "h": 19,
          "angle": -49.8
        },
        {
          "x": 993.2,
          "y": 549.4,
          "w": 54.1,
          "h": 19.6,
          "angle": -35.2
        },
        {
          "x": 926.5,
          "y": 572.5,
          "w": 53.6,
          "h": 19,
          "angle": -40.2
        },
        {
          "x": 1010.8,
          "y": 576.2,
          "w": 53.3,
          "h": 19.1,
          "angle": -29.7
        },
        {
          "x": 947,
          "y": 600,
          "w": 53.8,
          "h": 19,
          "angle": -32.3
        },
        {
          "x": 1025.5,
          "y": 604.9,
          "w": 53.7,
          "h": 18.8,
          "angle": -23.5
        },
        {
          "x": 963.3,
          "y": 629.9,
          "w": 53.4,
          "h": 18.6,
          "angle": -25.2
        },
        {
          "x": 1036.9,
          "y": 634.7,
          "w": 53.1,
          "h": 19,
          "angle": -18.4
        },
        {
          "x": 975.1,
          "y": 661.7,
          "w": 53.4,
          "h": 18.5,
          "angle": -15.9
        },
        {
          "x": 1045.1,
          "y": 665.4,
          "w": 53.3,
          "h": 19.2,
          "angle": -13.6
        },
        {
          "x": 982.4,
          "y": 695.1,
          "w": 53.2,
          "h": 18.4,
          "angle": -8.4
        },
        {
          "x": 1050.1,
          "y": 697.2,
          "w": 53.4,
          "h": 18.7,
          "angle": -6
        },
        {
          "x": 985,
          "y": 729,
          "w": 52,
          "h": 18,
          "angle": 0
        },
        {
          "x": 1052,
          "y": 729,
          "w": 52,
          "h": 18,
          "angle": 0
        },
        {
          "x": 985,
          "y": 759.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1052,
          "y": 759.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 965.5,
          "y": 791.5,
          "w": 53,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1018.5,
          "y": 791.5,
          "w": 53,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1071.5,
          "y": 791.5,
          "w": 53,
          "h": 17,
          "angle": 0
        },
        {
          "x": 985,
          "y": 823.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1052,
          "y": 823.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 985,
          "y": 855.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1052,
          "y": 855.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 985,
          "y": 887.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1052,
          "y": 887.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 985,
          "y": 919.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1052,
          "y": 919.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 985,
          "y": 951.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1052,
          "y": 951.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 985,
          "y": 983.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1052,
          "y": 983.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 985,
          "y": 1015.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1052,
          "y": 1015.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 985,
          "y": 1047.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1052,
          "y": 1047.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 985,
          "y": 1075,
          "w": 52,
          "h": 8,
          "angle": 0
        },
        {
          "x": 1052,
          "y": 1075,
          "w": 52,
          "h": 8,
          "angle": 0
        }
      ]
    }
  },
  {
    "slug": "split",
    "top_extract": {
      "blocks": [
        {
          "x": 903,
          "y": 21,
          "w": 52,
          "h": 18,
          "angle": 0
        },
        {
          "x": 903,
          "y": 53,
          "w": 52,
          "h": 18,
          "angle": 0
        },
        {
          "x": 903,
          "y": 85,
          "w": 52,
          "h": 18,
          "angle": 0
        },
        {
          "x": 903,
          "y": 117,
          "w": 52,
          "h": 18,
          "angle": 0
        },
        {
          "x": 903,
          "y": 149,
          "w": 52,
          "h": 18,
          "angle": 0
        },
        {
          "x": 903.5,
          "y": 181,
          "w": 53,
          "h": 18,
          "angle": 0
        },
        {
          "x": 903.5,
          "y": 213,
          "w": 53,
          "h": 18,
          "angle": 0
        },
        {
          "x": 903,
          "y": 244.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 901.1,
          "y": 274.7,
          "w": 53,
          "h": 18.4,
          "angle": 8.1
        },
        {
          "x": 894.7,
          "y": 304.5,
          "w": 53.3,
          "h": 18.7,
          "angle": 17.1
        },
        {
          "x": 884.1,
          "y": 333,
          "w": 53.3,
          "h": 18.8,
          "angle": 25
        },
        {
          "x": 869.5,
          "y": 359.5,
          "w": 53.2,
          "h": 18.9,
          "angle": 31.8
        },
        {
          "x": 851.4,
          "y": 383.6,
          "w": 53.5,
          "h": 18.7,
          "angle": 40.6
        },
        {
          "x": 830.1,
          "y": 405.2,
          "w": 53.2,
          "h": 18.8,
          "angle": 48.8
        },
        {
          "x": 805.4,
          "y": 423.5,
          "w": 53.3,
          "h": 18.8,
          "angle": 57.3
        },
        {
          "x": 778.9,
          "y": 438.1,
          "w": 53.1,
          "h": 18.7,
          "angle": 65.4
        },
        {
          "x": 750.6,
          "y": 448.6,
          "w": 53.2,
          "h": 18.6,
          "angle": 73.3
        },
        {
          "x": 720.8,
          "y": 455.1,
          "w": 53.4,
          "h": 18.4,
          "angle": 82.4
        },
        {
          "x": 658.5,
          "y": 457,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 690.5,
          "y": 457,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 626.5,
          "y": 471.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 594.5,
          "y": 498.2,
          "w": 52.5,
          "h": 17,
          "angle": -90
        },
        {
          "x": 17,
          "y": 524,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 49,
          "y": 524,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 81,
          "y": 524,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 113,
          "y": 524,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 146.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 178.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 210.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 242.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 274.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 306.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 338.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 370.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 402.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 434.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 466.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 498.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 530.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 562.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 690.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 722.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 754.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 786.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 818.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 850.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 882.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 914.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 946.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 978.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1010.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1042.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1074.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1106.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1138.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1170.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1202.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1234.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1266.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1298.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1330.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1362.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1394.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1426.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1458.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1490.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1522.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1554.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1586.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1618.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1650,
          "y": 524,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1682,
          "y": 524,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1714.5,
          "y": 524,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1748,
          "y": 524,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1779.5,
          "y": 524,
          "w": 52,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1811.5,
          "y": 524,
          "w": 52,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1843.5,
          "y": 524,
          "w": 52,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1875.5,
          "y": 524,
          "w": 52,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1907.5,
          "y": 524,
          "w": 52,
          "h": 19,
          "angle": -90
        },
        {
          "x": 626.5,
          "y": 524.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 658.5,
          "y": 524.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 594.5,
          "y": 550.8,
          "w": 52.5,
          "h": 17,
          "angle": -90
        },
        {
          "x": 626.5,
          "y": 577.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 658.5,
          "y": 591,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 690.5,
          "y": 592,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 720.8,
          "y": 594,
          "w": 53.2,
          "h": 18.5,
          "angle": -81.9
        },
        {
          "x": 750.4,
          "y": 600.3,
          "w": 53.2,
          "h": 18.6,
          "angle": -73.7
        },
        {
          "x": 778.8,
          "y": 610.9,
          "w": 53.2,
          "h": 18.6,
          "angle": -65.2
        },
        {
          "x": 805.7,
          "y": 625.6,
          "w": 53.3,
          "h": 18.7,
          "angle": -57.1
        },
        {
          "x": 830,
          "y": 643.9,
          "w": 53.3,
          "h": 18.7,
          "angle": -48.8
        },
        {
          "x": 851.3,
          "y": 665.3,
          "w": 53.2,
          "h": 18.5,
          "angle": -41.2
        },
        {
          "x": 869.5,
          "y": 689.6,
          "w": 53.2,
          "h": 18.7,
          "angle": -32.5
        },
        {
          "x": 884.2,
          "y": 716.3,
          "w": 53.2,
          "h": 18.7,
          "angle": -24.8
        },
        {
          "x": 894.7,
          "y": 744.6,
          "w": 53.1,
          "h": 18.5,
          "angle": -16.3
        },
        {
          "x": 901.2,
          "y": 774.3,
          "w": 53.2,
          "h": 18.4,
          "angle": -8.1
        },
        {
          "x": 903,
          "y": 804.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 903,
          "y": 835.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 903,
          "y": 867.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 903,
          "y": 899.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 903,
          "y": 931.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 903,
          "y": 963.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 903.5,
          "y": 995.5,
          "w": 53,
          "h": 17,
          "angle": 0
        },
        {
          "x": 903.5,
          "y": 1027.5,
          "w": 53,
          "h": 17,
          "angle": 0
        },
        {
          "x": 903.5,
          "y": 1059.5,
          "w": 53,
          "h": 17,
          "angle": 0
        }
      ]
    },
    "connection_blocks": [
      "min_x",
      "max_x",
      "min_y",
      "max_y"
    ]
  },
  {
    "slug": "double-split",
    "top_extract": {
      "blocks": [
        {
          "x": 919,
          "y": 26.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 986,
          "y": 27,
          "w": 52,
          "h": 18,
          "angle": 0
        },
        {
          "x": 919,
          "y": 58.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 986,
          "y": 58.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 919,
          "y": 91,
          "w": 52,
          "h": 18,
          "angle": 0
        },
        {
          "x": 986,
          "y": 91,
          "w": 52,
          "h": 18,
          "angle": 0
        },
        {
          "x": 899,
          "y": 123,
          "w": 54,
          "h": 18,
          "angle": 0
        },
        {
          "x": 953,
          "y": 123,
          "w": 54,
          "h": 18,
          "angle": 0
        },
        {
          "x": 1007,
          "y": 123,
          "w": 54,
          "h": 18,
          "angle": 0
        },
        {
          "x": 918.5,
          "y": 153,
          "w": 53,
          "h": 18,
          "angle": 0
        },
        {
          "x": 985,
          "y": 153.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 986,
          "y": 182.6,
          "w": 53.4,
          "h": 19.2,
          "angle": 5
        },
        {
          "x": 915.8,
          "y": 186,
          "w": 53.5,
          "h": 18.5,
          "angle": 8.1
        },
        {
          "x": 981.3,
          "y": 212.1,
          "w": 53.6,
          "h": 18.9,
          "angle": 11.7
        },
        {
          "x": 909.5,
          "y": 215.9,
          "w": 53.6,
          "h": 18.8,
          "angle": 15.9
        },
        {
          "x": 973.8,
          "y": 240.8,
          "w": 53.1,
          "h": 18.7,
          "angle": 18.4
        },
        {
          "x": 898.9,
          "y": 244.4,
          "w": 53.7,
          "h": 19,
          "angle": 23.6
        },
        {
          "x": 963,
          "y": 268,
          "w": 53.3,
          "h": 18.3,
          "angle": 23.8
        },
        {
          "x": 884.2,
          "y": 270.8,
          "w": 53.8,
          "h": 18.9,
          "angle": 33.7
        },
        {
          "x": 949.8,
          "y": 294.5,
          "w": 53.2,
          "h": 18.6,
          "angle": 30.3
        },
        {
          "x": 866.2,
          "y": 295.3,
          "w": 53.7,
          "h": 19,
          "angle": 40.2
        },
        {
          "x": 844.6,
          "y": 316.6,
          "w": 53.5,
          "h": 18.3,
          "angle": 49.4
        },
        {
          "x": 933.4,
          "y": 319.3,
          "w": 53.4,
          "h": 19.1,
          "angle": 35.2
        },
        {
          "x": 820.4,
          "y": 334.8,
          "w": 53.6,
          "h": 19.1,
          "angle": 58
        },
        {
          "x": 914.8,
          "y": 342.2,
          "w": 53.6,
          "h": 18.6,
          "angle": 41.6
        },
        {
          "x": 793.6,
          "y": 349.6,
          "w": 53.9,
          "h": 19,
          "angle": 66
        },
        {
          "x": 765.1,
          "y": 360,
          "w": 53.4,
          "h": 18.5,
          "angle": 73.7
        },
        {
          "x": 894.1,
          "y": 363.1,
          "w": 53.7,
          "h": 19,
          "angle": 47.6
        },
        {
          "x": 735.6,
          "y": 366.6,
          "w": 53.3,
          "h": 18.5,
          "angle": 81.9
        },
        {
          "x": 705,
          "y": 368.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 673,
          "y": 376.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 871.2,
          "y": 381.7,
          "w": 53.4,
          "h": 19.1,
          "angle": 54.5
        },
        {
          "x": 846.4,
          "y": 397.6,
          "w": 53.7,
          "h": 19,
          "angle": 59.5
        },
        {
          "x": 641.5,
          "y": 403.6,
          "w": 53.2,
          "h": 17,
          "angle": -90
        },
        {
          "x": 820,
          "y": 411.3,
          "w": 53.5,
          "h": 19.2,
          "angle": 66
        },
        {
          "x": 792.3,
          "y": 421.9,
          "w": 53.2,
          "h": 18.8,
          "angle": 72.2
        },
        {
          "x": 673,
          "y": 429.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 763.8,
          "y": 429.6,
          "w": 53.5,
          "h": 18.5,
          "angle": 78.1
        },
        {
          "x": 734.8,
          "y": 434.2,
          "w": 53.3,
          "h": 18.2,
          "angle": 84.4
        },
        {
          "x": 705,
          "y": 435.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 609.5,
          "y": 436,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 577.5,
          "y": 456.6,
          "w": 53.2,
          "h": 17,
          "angle": -90
        },
        {
          "x": 641.5,
          "y": 456.8,
          "w": 53.2,
          "h": 17,
          "angle": -90
        },
        {
          "x": 545.5,
          "y": 483.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 4.5,
          "y": 503,
          "w": 52,
          "h": 9,
          "angle": -90
        },
        {
          "x": 32.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 64.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 96.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 128.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 160.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 193.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 225.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 257.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 289.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 321.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 353.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 385.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 417.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 449.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 481.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 513.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 609.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 673.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 705.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 737.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 769.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 801.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 833.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 865.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 897.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 929.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 961.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 993.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1025.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1057.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1089.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1121.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1153.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1185.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1217.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1249.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1281.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1313.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1345.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1377.5,
          "y": 503,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1409,
          "y": 503,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1441,
          "y": 503,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1473,
          "y": 503,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1537,
          "y": 503,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1505,
          "y": 503.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1569,
          "y": 503.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1601.5,
          "y": 503.5,
          "w": 53,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1633.5,
          "y": 503.5,
          "w": 53,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1665.5,
          "y": 503.5,
          "w": 53,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1697.5,
          "y": 503.5,
          "w": 53,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1729.5,
          "y": 503.5,
          "w": 53,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1762,
          "y": 503.5,
          "w": 53,
          "h": 20,
          "angle": -90
        },
        {
          "x": 1792,
          "y": 503.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1823.5,
          "y": 503.5,
          "w": 53,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1855,
          "y": 503.5,
          "w": 53,
          "h": 20,
          "angle": -90
        },
        {
          "x": 1887,
          "y": 503.5,
          "w": 53,
          "h": 22,
          "angle": -90
        },
        {
          "x": 1914,
          "y": 504,
          "w": 54,
          "h": 10,
          "angle": -90
        },
        {
          "x": 577.5,
          "y": 509.9,
          "w": 53.2,
          "h": 17,
          "angle": -90
        },
        {
          "x": 641.5,
          "y": 509.9,
          "w": 53.2,
          "h": 17,
          "angle": -90
        },
        {
          "x": 545.5,
          "y": 536.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 577.5,
          "y": 563.1,
          "w": 53.2,
          "h": 17,
          "angle": -90
        },
        {
          "x": 641.5,
          "y": 563.1,
          "w": 53.2,
          "h": 17,
          "angle": -90
        },
        {
          "x": 4.5,
          "y": 570,
          "w": 52,
          "h": 9,
          "angle": -90
        },
        {
          "x": 32.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 64.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 96.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 128.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 160.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 193.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 225.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 257.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 289.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 321.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 353.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 385.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 417.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 449.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 481.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 513.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 609.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 673.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 705.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 737.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 769.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 801.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 833.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 865.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 897.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 929.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 961.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 993.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1025.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1057.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1089.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1121.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1153.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1185.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1217.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1249.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1281.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1313.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1345.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1377,
          "y": 570,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1409.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1441.5,
          "y": 570,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1473,
          "y": 570,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1505,
          "y": 570,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1537,
          "y": 570,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1569,
          "y": 570,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1601,
          "y": 570,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1633.5,
          "y": 570,
          "w": 52,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1665.5,
          "y": 570,
          "w": 52,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1697.5,
          "y": 570,
          "w": 52,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1729.5,
          "y": 570,
          "w": 52,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1761.5,
          "y": 570,
          "w": 52,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1792,
          "y": 570,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1823,
          "y": 570,
          "w": 52,
          "h": 20,
          "angle": -90
        },
        {
          "x": 1855.5,
          "y": 570,
          "w": 52,
          "h": 21,
          "angle": -90
        },
        {
          "x": 1887,
          "y": 570,
          "w": 52,
          "h": 20,
          "angle": -90
        },
        {
          "x": 1913.5,
          "y": 570,
          "w": 52,
          "h": 11,
          "angle": -90
        },
        {
          "x": 545.5,
          "y": 589.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 641.5,
          "y": 616.2,
          "w": 53.2,
          "h": 17,
          "angle": -90
        },
        {
          "x": 577.5,
          "y": 616.4,
          "w": 53.2,
          "h": 17,
          "angle": -90
        },
        {
          "x": 735,
          "y": 636.8,
          "w": 53.5,
          "h": 18.2,
          "angle": -84.6
        },
        {
          "x": 609.5,
          "y": 637.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 705.5,
          "y": 637.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 764.1,
          "y": 641.4,
          "w": 53.4,
          "h": 18.8,
          "angle": -78.2
        },
        {
          "x": 673,
          "y": 644.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 792.5,
          "y": 649,
          "w": 53.4,
          "h": 18.7,
          "angle": -71.6
        },
        {
          "x": 820.2,
          "y": 659.6,
          "w": 53.3,
          "h": 19,
          "angle": -65.6
        },
        {
          "x": 641.5,
          "y": 669.4,
          "w": 53.2,
          "h": 17,
          "angle": -90
        },
        {
          "x": 846.6,
          "y": 673.3,
          "w": 53.6,
          "h": 18.9,
          "angle": -59.9
        },
        {
          "x": 871.1,
          "y": 689,
          "w": 53.2,
          "h": 18.8,
          "angle": -54
        },
        {
          "x": 673,
          "y": 697.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 705.5,
          "y": 704.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 738,
          "y": 706.9,
          "w": 53.4,
          "h": 18.6,
          "angle": -81.3
        },
        {
          "x": 894.4,
          "y": 707.9,
          "w": 53.2,
          "h": 19.2,
          "angle": -46.7
        },
        {
          "x": 767.8,
          "y": 713.5,
          "w": 53.4,
          "h": 18.4,
          "angle": -73.7
        },
        {
          "x": 796.1,
          "y": 723.9,
          "w": 53.5,
          "h": 18.9,
          "angle": -65.8
        },
        {
          "x": 915.2,
          "y": 728.8,
          "w": 53.3,
          "h": 19.2,
          "angle": -42.3
        },
        {
          "x": 822.9,
          "y": 738.7,
          "w": 53.6,
          "h": 18.7,
          "angle": -57.4
        },
        {
          "x": 933.9,
          "y": 751.7,
          "w": 53.4,
          "h": 19,
          "angle": -36.9
        },
        {
          "x": 847.2,
          "y": 756.8,
          "w": 53.3,
          "h": 19,
          "angle": -49.8
        },
        {
          "x": 949.9,
          "y": 776.4,
          "w": 53.2,
          "h": 19,
          "angle": -29.7
        },
        {
          "x": 868.7,
          "y": 778.4,
          "w": 53.6,
          "h": 18.9,
          "angle": -40.6
        },
        {
          "x": 886.8,
          "y": 802.4,
          "w": 53.5,
          "h": 18.5,
          "angle": -32.9
        },
        {
          "x": 963.3,
          "y": 802.7,
          "w": 53.5,
          "h": 18.7,
          "angle": -25
        },
        {
          "x": 901.4,
          "y": 829.3,
          "w": 53.2,
          "h": 18.5,
          "angle": -24.4
        },
        {
          "x": 974,
          "y": 830.4,
          "w": 53.4,
          "h": 18.3,
          "angle": -18.4
        },
        {
          "x": 912.1,
          "y": 858,
          "w": 53.4,
          "h": 19.1,
          "angle": -17.1
        },
        {
          "x": 981.5,
          "y": 858.9,
          "w": 53.4,
          "h": 18.6,
          "angle": -12.3
        },
        {
          "x": 918.5,
          "y": 887.4,
          "w": 53.2,
          "h": 18.4,
          "angle": -8.1
        },
        {
          "x": 986.1,
          "y": 888.2,
          "w": 53.3,
          "h": 18.3,
          "angle": -5.7
        },
        {
          "x": 920.5,
          "y": 917.5,
          "w": 53,
          "h": 17,
          "angle": 0
        },
        {
          "x": 987.5,
          "y": 917.5,
          "w": 53,
          "h": 17,
          "angle": 0
        },
        {
          "x": 899,
          "y": 949.5,
          "w": 54,
          "h": 17,
          "angle": 0
        },
        {
          "x": 953,
          "y": 949.5,
          "w": 54,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1007,
          "y": 949.5,
          "w": 54,
          "h": 17,
          "angle": 0
        },
        {
          "x": 920.5,
          "y": 981.5,
          "w": 53,
          "h": 17,
          "angle": 0
        },
        {
          "x": 987.5,
          "y": 981.5,
          "w": 53,
          "h": 17,
          "angle": 0
        },
        {
          "x": 920.5,
          "y": 1013.5,
          "w": 53,
          "h": 17,
          "angle": 0
        },
        {
          "x": 987.5,
          "y": 1013.5,
          "w": 53,
          "h": 17,
          "angle": 0
        },
        {
          "x": 920.5,
          "y": 1045.5,
          "w": 53,
          "h": 17,
          "angle": 0
        },
        {
          "x": 987.5,
          "y": 1045.5,
          "w": 53,
          "h": 17,
          "angle": 0
        },
        {
          "x": 920.5,
          "y": 1074,
          "w": 53,
          "h": 10,
          "angle": 0
        },
        {
          "x": 987.5,
          "y": 1074,
          "w": 53,
          "h": 10,
          "angle": 0
        }
      ]
    },
    "connection_blocks": [
      0,
      1,
      44,
      107,
      101,
      164,
      209,
      210
    ]
  },
  {
    "slug": "field-starter",
    "top_extract": {
      "blocks": [
        {
          "x": 706,
          "y": 50.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 763.5,
          "y": 50.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 850,
          "y": 50.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 907.5,
          "y": 50.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 994,
          "y": 50.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1080.5,
          "y": 50.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1108.5,
          "y": 50.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1138,
          "y": 50.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1167.5,
          "y": 50.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1195.5,
          "y": 50.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1224.5,
          "y": 50.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1253,
          "y": 50.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1282,
          "y": 50.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1311.5,
          "y": 50.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1339.5,
          "y": 50.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1368.5,
          "y": 50.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 532.5,
          "y": 51,
          "w": 46,
          "h": 13,
          "angle": -90
        },
        {
          "x": 562,
          "y": 51,
          "w": 46,
          "h": 16,
          "angle": -90
        },
        {
          "x": 591.5,
          "y": 51,
          "w": 46,
          "h": 13,
          "angle": -90
        },
        {
          "x": 619.5,
          "y": 51,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 648.5,
          "y": 51,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 676.5,
          "y": 51,
          "w": 46,
          "h": 13,
          "angle": -90
        },
        {
          "x": 735.5,
          "y": 51,
          "w": 46,
          "h": 13,
          "angle": -90
        },
        {
          "x": 792.5,
          "y": 51,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 820.5,
          "y": 51,
          "w": 46,
          "h": 13,
          "angle": -90
        },
        {
          "x": 879.5,
          "y": 51,
          "w": 46,
          "h": 13,
          "angle": -90
        },
        {
          "x": 936.5,
          "y": 51,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 964.5,
          "y": 51,
          "w": 46,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1023.5,
          "y": 51,
          "w": 46,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1051.5,
          "y": 51,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 533,
          "y": 110.5,
          "w": 45,
          "h": 14,
          "angle": -90
        },
        {
          "x": 591,
          "y": 110.5,
          "w": 45,
          "h": 14,
          "angle": -90
        },
        {
          "x": 676.5,
          "y": 110.5,
          "w": 45,
          "h": 13,
          "angle": -90
        },
        {
          "x": 706,
          "y": 110.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 735,
          "y": 110.5,
          "w": 45,
          "h": 14,
          "angle": -90
        },
        {
          "x": 763.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 850,
          "y": 110.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 879,
          "y": 110.5,
          "w": 45,
          "h": 14,
          "angle": -90
        },
        {
          "x": 907.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 964.5,
          "y": 110.5,
          "w": 45,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1023,
          "y": 110.5,
          "w": 45,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1108.5,
          "y": 110.5,
          "w": 45,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1195.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1224.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1253,
          "y": 110.5,
          "w": 45,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1310.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 562,
          "y": 111,
          "w": 46,
          "h": 16,
          "angle": -90
        },
        {
          "x": 619.5,
          "y": 111,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 994,
          "y": 111,
          "w": 46,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1166.5,
          "y": 111,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 648.5,
          "y": 111.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 792.5,
          "y": 111.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 821,
          "y": 111.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 936.5,
          "y": 111.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1051.5,
          "y": 111.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1080.5,
          "y": 111.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1138,
          "y": 111.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1282,
          "y": 111.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1339.5,
          "y": 111.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1368.5,
          "y": 111.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 533,
          "y": 171.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 562,
          "y": 171.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 591.5,
          "y": 171.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 619.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 648.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 677,
          "y": 171.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 706,
          "y": 171.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 735,
          "y": 171.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 763.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 792.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 878.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 907.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 936.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 965,
          "y": 171.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 994,
          "y": 171.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1023,
          "y": 171.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1051.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1080.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1195.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1224.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1253,
          "y": 171.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1282,
          "y": 171.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1310.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1339.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1368.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 821,
          "y": 172,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 850,
          "y": 172,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1109,
          "y": 172,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1138,
          "y": 172,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1167,
          "y": 172,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 532.5,
          "y": 232.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 562,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 591.5,
          "y": 232.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 619.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 648.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 676.5,
          "y": 232.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 706,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 735.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 763.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 792.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 821,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 850,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 879,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 907.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 936.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 964.5,
          "y": 232.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 994,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1023,
          "y": 232.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1052,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1080.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1109,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1138,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1167,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1195.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1224.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1253,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1282,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1311.7,
          "y": 232.5,
          "w": 47.3,
          "h": 14.4,
          "angle": -88.7
        },
        {
          "x": 1339.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1368.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 508,
          "y": 284.5,
          "w": 485,
          "h": 28,
          "angle": -90
        },
        {
          "x": 9.5,
          "y": 287.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 38,
          "y": 287.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 67,
          "y": 287.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 95.5,
          "y": 287.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 124,
          "y": 287.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 153,
          "y": 287.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 182,
          "y": 287.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 211,
          "y": 287.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 239.5,
          "y": 287.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 268,
          "y": 287.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 297,
          "y": 287.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 326,
          "y": 287.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 355,
          "y": 287.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 383.5,
          "y": 287.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 412,
          "y": 287.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 441,
          "y": 287.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 469.5,
          "y": 287.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 532.5,
          "y": 292.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 562,
          "y": 292.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 591.5,
          "y": 292.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 619.5,
          "y": 292.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 648.5,
          "y": 292.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 676.5,
          "y": 292.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 706,
          "y": 292.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 763.5,
          "y": 292.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 792.5,
          "y": 292.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 821,
          "y": 292.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 850,
          "y": 292.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 879,
          "y": 292.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 907.5,
          "y": 292.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 936.5,
          "y": 292.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 965,
          "y": 292.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 994,
          "y": 292.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1252,
          "y": 292.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1282,
          "y": 292.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1310.5,
          "y": 292.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1339.5,
          "y": 292.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1368.5,
          "y": 292.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 735,
          "y": 293,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1023,
          "y": 293,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1052,
          "y": 293,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1080.5,
          "y": 293,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1109,
          "y": 293,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1138,
          "y": 293,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1167,
          "y": 293,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1196,
          "y": 293,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1224,
          "y": 293,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1109,
          "y": 353,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1196,
          "y": 353,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1224,
          "y": 353,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 533.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 562,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 591,
          "y": 353.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 619.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 648.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 676.5,
          "y": 353.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 706,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 735,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 763.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 792.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 821,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 850,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 879,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 907.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 936.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 965.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 994,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1023,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1051.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1080.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1138,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1167,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1252.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1282,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1310.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1339.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1368.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 532.5,
          "y": 413.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 562,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 590.5,
          "y": 413.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 619.5,
          "y": 413.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 648.5,
          "y": 413.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 676.5,
          "y": 413.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 706,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 735,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 763.5,
          "y": 413.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 792.5,
          "y": 413.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 821,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 850,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 936,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1023,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1080,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1167,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1253,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1282,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1310.5,
          "y": 413.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1339.5,
          "y": 413.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1368.5,
          "y": 413.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 879,
          "y": 414,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 907.5,
          "y": 414,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 965.5,
          "y": 414,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 994,
          "y": 414,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1051.5,
          "y": 414,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1109,
          "y": 414,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1138,
          "y": 414,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1196,
          "y": 414,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1224,
          "y": 414,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1023,
          "y": 474,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1052,
          "y": 474,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1109,
          "y": 474,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1138,
          "y": 474,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1167,
          "y": 474,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1196,
          "y": 474,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1224,
          "y": 474,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 532.5,
          "y": 474.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 562,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 591,
          "y": 474.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 619.5,
          "y": 474.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 648.5,
          "y": 474.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 677,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 706,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 735,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 763.5,
          "y": 474.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 792.5,
          "y": 474.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 821,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 850,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 879,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 908,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 936,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 965.5,
          "y": 474.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 994,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1080,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1253,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1282,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1311,
          "y": 474.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1339.5,
          "y": 474.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1368.5,
          "y": 474.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 533,
          "y": 534.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 562,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 591.5,
          "y": 534.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 619.5,
          "y": 534.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 648.5,
          "y": 534.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 677,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 706,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 735,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 792.5,
          "y": 534.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 821,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 850,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 879,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 908,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 936,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 965.5,
          "y": 534.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 994,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1080,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1109,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1138,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1311,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1339.5,
          "y": 534.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1368.5,
          "y": 534.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 764,
          "y": 535,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1023,
          "y": 535,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1052,
          "y": 535,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1167,
          "y": 535,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1196,
          "y": 535,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1224.5,
          "y": 535,
          "w": 48,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1253,
          "y": 535,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1282,
          "y": 535,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 879,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 936.5,
          "y": 595,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 994,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1023,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1052,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1080,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1109,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1138,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1167,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1196,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1224,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1253,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1282,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1311,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1339.5,
          "y": 595,
          "w": 48,
          "h": 17,
          "angle": -90
        },
        {
          "x": 532,
          "y": 595.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 562,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 591.5,
          "y": 595.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 619.5,
          "y": 595.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 648.5,
          "y": 595.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 677,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 706,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 735,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 764,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 792,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 821,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 850,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 907.5,
          "y": 595.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 965.5,
          "y": 595.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1368.5,
          "y": 595.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 532.5,
          "y": 655.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 562,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 591,
          "y": 655.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 619.5,
          "y": 655.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 648.5,
          "y": 655.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 677,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 706,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 735,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 763.5,
          "y": 655.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 792,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 821,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 850,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 879,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 908,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 936,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 965.5,
          "y": 655.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 994,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1023,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1052,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1080,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1109,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1138,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1167,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1282,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1311,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1339.5,
          "y": 655.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1368.5,
          "y": 655.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1196,
          "y": 656,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1224.5,
          "y": 656,
          "w": 48,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1253,
          "y": 656,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 648.5,
          "y": 716,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 677,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 706,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 735,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 764,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 792,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 821,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 850,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 879,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 908,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 936,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 965.5,
          "y": 716,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 994,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1023,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1052,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1080,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1109,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1138,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1167,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1195.5,
          "y": 716,
          "w": 48,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1224,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1252.5,
          "y": 716,
          "w": 48,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1282,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1311,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1339.5,
          "y": 716,
          "w": 48,
          "h": 17,
          "angle": -90
        },
        {
          "x": 532,
          "y": 716.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 562,
          "y": 716.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 591.5,
          "y": 716.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 620,
          "y": 716.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1368,
          "y": 716.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 648.5,
          "y": 776.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 735,
          "y": 776.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 764,
          "y": 776.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 821,
          "y": 776.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 879,
          "y": 776.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1080.5,
          "y": 776.5,
          "w": 47,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1167,
          "y": 776.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1195.5,
          "y": 776.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1282,
          "y": 776.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1339.5,
          "y": 776.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1368.5,
          "y": 776.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 619.5,
          "y": 777,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 706,
          "y": 777,
          "w": 46,
          "h": 16,
          "angle": -90
        },
        {
          "x": 792,
          "y": 777,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 850,
          "y": 777,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 908,
          "y": 777,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 936,
          "y": 777,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 965.5,
          "y": 777,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 994,
          "y": 777,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1023,
          "y": 777,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1052,
          "y": 777,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1109,
          "y": 777,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1137.5,
          "y": 777,
          "w": 48,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1311.7,
          "y": 777,
          "w": 46.7,
          "h": 15.5,
          "angle": -87.1
        },
        {
          "x": 532.3,
          "y": 777.5,
          "w": 45.3,
          "h": 14.5,
          "angle": 88.7
        },
        {
          "x": 562,
          "y": 777.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 590.5,
          "y": 777.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 677.5,
          "y": 777.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1224.5,
          "y": 777.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1253,
          "y": 777.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 508,
          "y": 782,
          "w": 480,
          "h": 28,
          "angle": -90
        },
        {
          "x": 8.5,
          "y": 787.5,
          "w": 47,
          "h": 17,
          "angle": -90
        },
        {
          "x": 38,
          "y": 787.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 67,
          "y": 787.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 95.5,
          "y": 787.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 124,
          "y": 787.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 153,
          "y": 787.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 182,
          "y": 787.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 211,
          "y": 787.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 239.5,
          "y": 787.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 268,
          "y": 787.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 297,
          "y": 787.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 326,
          "y": 787.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 355,
          "y": 787.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 383.5,
          "y": 787.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 412,
          "y": 787.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 441,
          "y": 787.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 469.5,
          "y": 787.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 764,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 792,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 821,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 850,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 879,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 908,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 936,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 965.5,
          "y": 837,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 994,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1023,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1052,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1080.5,
          "y": 837,
          "w": 48,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1109,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1137.5,
          "y": 837,
          "w": 48,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1167,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1195.5,
          "y": 837,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 532,
          "y": 837.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 562,
          "y": 837.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 591.5,
          "y": 837.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 619.5,
          "y": 837.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 648.5,
          "y": 837.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 676.5,
          "y": 837.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 706,
          "y": 837.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 736,
          "y": 837.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1224.5,
          "y": 837.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1252,
          "y": 837.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1282,
          "y": 837.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1311.4,
          "y": 837.5,
          "w": 47.6,
          "h": 15.1,
          "angle": -87.7
        },
        {
          "x": 1339.5,
          "y": 837.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1368.5,
          "y": 837.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 792,
          "y": 897.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 821,
          "y": 897.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 850,
          "y": 897.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 879,
          "y": 897.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 936,
          "y": 897.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 965.5,
          "y": 897.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 994,
          "y": 897.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1023,
          "y": 897.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1080,
          "y": 897.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1138,
          "y": 897.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 908,
          "y": 898,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1052,
          "y": 898,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1167,
          "y": 898,
          "w": 46.4,
          "h": 15,
          "angle": -88.6
        },
        {
          "x": 1282,
          "y": 898,
          "w": 46,
          "h": 16,
          "angle": -90
        },
        {
          "x": 532,
          "y": 898.5,
          "w": 45,
          "h": 14,
          "angle": -90
        },
        {
          "x": 562,
          "y": 898.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 591.5,
          "y": 898.5,
          "w": 45,
          "h": 13,
          "angle": -90
        },
        {
          "x": 619.5,
          "y": 898.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 648.5,
          "y": 898.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 676.5,
          "y": 898.5,
          "w": 45,
          "h": 13,
          "angle": -90
        },
        {
          "x": 706,
          "y": 898.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 736,
          "y": 898.5,
          "w": 45,
          "h": 14,
          "angle": -90
        },
        {
          "x": 764,
          "y": 898.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1108,
          "y": 898.5,
          "w": 45,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1195.5,
          "y": 898.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1224.5,
          "y": 898.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1252,
          "y": 898.5,
          "w": 45,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1311,
          "y": 898.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1339.5,
          "y": 898.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1368.5,
          "y": 898.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 764,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 792.5,
          "y": 958,
          "w": 48,
          "h": 17,
          "angle": -90
        },
        {
          "x": 821,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 850,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 879,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 908,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 936.5,
          "y": 958,
          "w": 48,
          "h": 17,
          "angle": -90
        },
        {
          "x": 965.5,
          "y": 958,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 994,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1023,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1051.5,
          "y": 958,
          "w": 48,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1080.5,
          "y": 958,
          "w": 48,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1109,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1138,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1167,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1311,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1368.5,
          "y": 958,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 532.1,
          "y": 958.5,
          "w": 47.3,
          "h": 14.9,
          "angle": 88.7
        },
        {
          "x": 562,
          "y": 958.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 591,
          "y": 958.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 619.5,
          "y": 958.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 648.5,
          "y": 958.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 677,
          "y": 958.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 706,
          "y": 958.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 735,
          "y": 958.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1195.5,
          "y": 958.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1224.5,
          "y": 958.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1253,
          "y": 958.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1282,
          "y": 958.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1339.5,
          "y": 958.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 677,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 706,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 735,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 764,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 792,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 821,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 850,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 879,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 908,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 936.5,
          "y": 1018.5,
          "w": 47,
          "h": 17,
          "angle": -90
        },
        {
          "x": 965.5,
          "y": 1018.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 994,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1023,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1052,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1080.5,
          "y": 1018.5,
          "w": 47,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1109,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1137.5,
          "y": 1018.5,
          "w": 47,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1167,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1196,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1224.5,
          "y": 1018.5,
          "w": 47,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1253,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 532.5,
          "y": 1019.5,
          "w": 45,
          "h": 13,
          "angle": -90
        },
        {
          "x": 562,
          "y": 1019.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 591.5,
          "y": 1019.5,
          "w": 45,
          "h": 13,
          "angle": -90
        },
        {
          "x": 619.5,
          "y": 1019.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 648.5,
          "y": 1019.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1282,
          "y": 1019.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1312,
          "y": 1019.5,
          "w": 45,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1339.5,
          "y": 1019.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1368.5,
          "y": 1019.5,
          "w": 45,
          "h": 15,
          "angle": -90
        }
      ]
    }
  },
  {
    "slug": "triangle",
    "top_extract": {
      "blocks": [
        {
          "x": 853.5,
          "y": 50.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1026.5,
          "y": 50.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1141.5,
          "y": 50.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1170.5,
          "y": 50.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1227.5,
          "y": 50.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1257,
          "y": 50.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1286,
          "y": 50.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1401,
          "y": 50.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1430,
          "y": 50.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1458.5,
          "y": 50.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1487.5,
          "y": 50.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1516,
          "y": 50.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 681,
          "y": 51,
          "w": 46,
          "h": 16,
          "angle": -90
        },
        {
          "x": 709.5,
          "y": 51,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 738.5,
          "y": 51,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 767.5,
          "y": 51,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 795.5,
          "y": 51,
          "w": 46,
          "h": 13,
          "angle": -90
        },
        {
          "x": 825.5,
          "y": 51,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 882.5,
          "y": 51,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 911.5,
          "y": 51,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 939.5,
          "y": 51,
          "w": 46,
          "h": 13,
          "angle": -90
        },
        {
          "x": 969.5,
          "y": 51,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 997.5,
          "y": 51,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1055.5,
          "y": 51,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1083.5,
          "y": 51,
          "w": 46,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1113.5,
          "y": 51,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1199.5,
          "y": 51,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1314.5,
          "y": 51,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1343.5,
          "y": 51,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1371.5,
          "y": 51,
          "w": 46,
          "h": 13,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 61.7,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 623,
          "y": 86.6,
          "w": 47.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 109.1,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 594,
          "y": 110.4,
          "w": 44.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 681,
          "y": 110.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 709.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 738.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 795.5,
          "y": 110.5,
          "w": 45,
          "h": 13,
          "angle": -90
        },
        {
          "x": 825.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 853.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 882.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 911.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 939.5,
          "y": 110.5,
          "w": 45,
          "h": 13,
          "angle": -90
        },
        {
          "x": 997.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1026.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1055.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1083.5,
          "y": 110.5,
          "w": 45,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1141.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1170.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1199.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1227.5,
          "y": 110.5,
          "w": 45,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1257,
          "y": 110.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1314.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1343.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1371.5,
          "y": 110.5,
          "w": 45,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1458.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1487.5,
          "y": 110.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1515.5,
          "y": 110.5,
          "w": 45,
          "h": 13,
          "angle": -90
        },
        {
          "x": 767.5,
          "y": 111,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1113.5,
          "y": 111,
          "w": 46,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1401,
          "y": 111,
          "w": 46,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1430,
          "y": 111,
          "w": 46,
          "h": 16,
          "angle": -90
        },
        {
          "x": 969,
          "y": 111.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1286,
          "y": 111.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 623,
          "y": 133.9,
          "w": 47.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 564.3,
          "y": 136.5,
          "w": 46.9,
          "h": 17,
          "angle": 89.9
        },
        {
          "x": 594,
          "y": 155.1,
          "w": 44.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 156.5,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 537,
          "y": 161.4,
          "w": 46.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 681,
          "y": 171.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 709.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 738.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 767.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 795.5,
          "y": 171.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 825,
          "y": 171.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 853.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 882.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 911.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 940.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 998,
          "y": 171.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1026.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1055.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1083.5,
          "y": 171.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1113.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1141.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1170.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1199.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1227.5,
          "y": 171.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1343.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1371.5,
          "y": 171.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1401,
          "y": 171.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1430,
          "y": 171.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1458.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1487.5,
          "y": 171.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1515.5,
          "y": 171.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 969,
          "y": 172,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1257,
          "y": 172,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1286,
          "y": 172,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1314.5,
          "y": 172,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 623,
          "y": 181.1,
          "w": 47.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 564.4,
          "y": 183.4,
          "w": 46.9,
          "h": 17,
          "angle": 89.9
        },
        {
          "x": 508,
          "y": 186.3,
          "w": 46.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 594,
          "y": 199.9,
          "w": 44.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 203.8,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 537,
          "y": 208.1,
          "w": 46.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 479,
          "y": 211.2,
          "w": 46.3,
          "h": 16,
          "angle": -90
        },
        {
          "x": 623,
          "y": 228.4,
          "w": 47.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 564.5,
          "y": 230.4,
          "w": 46.9,
          "h": 17,
          "angle": 89.9
        },
        {
          "x": 681,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 709.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 738.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 767.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 795.5,
          "y": 232.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 825.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 853.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 882.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 911.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 940,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 969,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 998,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1026.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1055.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1083.5,
          "y": 232.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1113.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1141.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1170.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1199.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1228,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1257,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1286,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1315,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1343.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1371,
          "y": 232.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1401,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1430,
          "y": 232.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1458.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1487.5,
          "y": 232.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1515.5,
          "y": 232.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 508,
          "y": 232.8,
          "w": 46.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 450,
          "y": 236.1,
          "w": 46.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 594,
          "y": 244.6,
          "w": 44.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 251.2,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 537,
          "y": 254.9,
          "w": 46.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 479,
          "y": 257.5,
          "w": 46.3,
          "h": 16,
          "angle": -90
        },
        {
          "x": 421,
          "y": 260.9,
          "w": 45.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 623,
          "y": 275.6,
          "w": 47.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 564.5,
          "y": 277.3,
          "w": 46.9,
          "h": 17,
          "angle": 89.9
        },
        {
          "x": 508,
          "y": 279.4,
          "w": 46.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 450,
          "y": 282.2,
          "w": 46.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 393,
          "y": 284.8,
          "w": 45.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 594,
          "y": 289.4,
          "w": 44.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 681,
          "y": 292.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 709.5,
          "y": 292.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 738.5,
          "y": 292.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 767.5,
          "y": 292.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 795.5,
          "y": 292.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 825.5,
          "y": 292.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 854,
          "y": 292.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 882.5,
          "y": 292.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 940,
          "y": 292.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 969,
          "y": 292.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 998,
          "y": 292.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1027,
          "y": 292.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1055.5,
          "y": 292.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1083,
          "y": 292.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1113.5,
          "y": 292.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1142,
          "y": 292.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1228,
          "y": 292.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1372,
          "y": 292.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1401,
          "y": 292.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1430,
          "y": 292.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1458.5,
          "y": 292.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1487.5,
          "y": 292.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1515.5,
          "y": 292.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 911.5,
          "y": 293,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1171,
          "y": 293,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1199.5,
          "y": 293,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1257,
          "y": 293,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1286,
          "y": 293,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1315,
          "y": 293,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1343.5,
          "y": 293,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 298.6,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 537,
          "y": 301.7,
          "w": 46.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 479,
          "y": 303.8,
          "w": 46.3,
          "h": 16,
          "angle": -90
        },
        {
          "x": 421,
          "y": 306.8,
          "w": 45.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 364,
          "y": 309.6,
          "w": 45.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 623,
          "y": 322.9,
          "w": 47.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 564.6,
          "y": 324.3,
          "w": 46.9,
          "h": 17,
          "angle": 89.9
        },
        {
          "x": 508,
          "y": 326,
          "w": 46.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 450,
          "y": 328.4,
          "w": 46.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 393,
          "y": 330.4,
          "w": 45.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 594,
          "y": 334.1,
          "w": 44.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 335,
          "y": 334.4,
          "w": 44.7,
          "h": 16,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 346,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 537,
          "y": 348.4,
          "w": 46.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 479,
          "y": 350.2,
          "w": 46.3,
          "h": 16,
          "angle": -90
        },
        {
          "x": 421,
          "y": 352.6,
          "w": 45.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1286,
          "y": 353,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1343.5,
          "y": 353,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 681,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 709.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 738.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 767.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 795.5,
          "y": 353.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 825,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 854,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 882.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 911.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 940,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 969,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 998,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1026.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1055.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1084,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1113,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1142,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1171,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1199.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1228,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1257,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1315,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1372,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1401,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1430,
          "y": 353.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1458.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1487.5,
          "y": 353.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1515.5,
          "y": 353.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 364,
          "y": 354.8,
          "w": 45.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 306,
          "y": 359.1,
          "w": 44.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 623,
          "y": 370.1,
          "w": 47.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 564.7,
          "y": 371.2,
          "w": 46.9,
          "h": 17,
          "angle": 89.9
        },
        {
          "x": 508,
          "y": 372.5,
          "w": 46.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 450,
          "y": 374.5,
          "w": 46.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 393,
          "y": 376,
          "w": 45.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 594,
          "y": 378.9,
          "w": 44.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 335,
          "y": 379,
          "w": 44.7,
          "h": 16,
          "angle": -90
        },
        {
          "x": 277,
          "y": 386.8,
          "w": 49.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 393.4,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 537,
          "y": 395.2,
          "w": 46.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 479,
          "y": 396.5,
          "w": 46.3,
          "h": 16,
          "angle": -90
        },
        {
          "x": 421,
          "y": 398.5,
          "w": 45.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 364,
          "y": 400,
          "w": 45.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 306,
          "y": 403.2,
          "w": 44.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 249,
          "y": 411.8,
          "w": 49.5,
          "h": 16,
          "angle": -90
        },
        {
          "x": 681,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 709.5,
          "y": 413.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 738.5,
          "y": 413.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 767.5,
          "y": 413.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 795.5,
          "y": 413.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 825,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 854,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 883,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 911.5,
          "y": 413.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 940,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 969,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 998,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1027,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1055.5,
          "y": 413.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1084,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1113,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1171,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1199.5,
          "y": 413.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1286,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1343.5,
          "y": 413.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1401,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1430,
          "y": 413.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1458.5,
          "y": 413.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1487.5,
          "y": 413.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1515.5,
          "y": 413.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1142,
          "y": 414,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1228,
          "y": 414,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1257,
          "y": 414,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1315,
          "y": 414,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1372,
          "y": 414,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 623,
          "y": 417.4,
          "w": 47.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 564.8,
          "y": 418.1,
          "w": 46.9,
          "h": 17,
          "angle": 89.9
        },
        {
          "x": 508,
          "y": 419.1,
          "w": 46.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 450,
          "y": 420.6,
          "w": 46.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 393,
          "y": 421.5,
          "w": 45.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 594,
          "y": 423.6,
          "w": 44.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 335,
          "y": 423.8,
          "w": 44.7,
          "h": 16,
          "angle": -90
        },
        {
          "x": 277,
          "y": 436.4,
          "w": 49.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 220,
          "y": 436.7,
          "w": 49.4,
          "h": 16,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 440.7,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 537,
          "y": 442,
          "w": 46.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 479,
          "y": 442.8,
          "w": 46.3,
          "h": 16,
          "angle": -90
        },
        {
          "x": 421,
          "y": 444.3,
          "w": 45.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 364,
          "y": 445.1,
          "w": 45.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 306,
          "y": 447.3,
          "w": 44.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 249,
          "y": 461.2,
          "w": 49.5,
          "h": 16,
          "angle": -90
        },
        {
          "x": 191,
          "y": 461.6,
          "w": 49.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 623,
          "y": 464.6,
          "w": 47.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 564.9,
          "y": 465.1,
          "w": 46.9,
          "h": 17,
          "angle": 89.9
        },
        {
          "x": 508,
          "y": 465.7,
          "w": 46.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 450,
          "y": 466.8,
          "w": 46.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 393,
          "y": 467.1,
          "w": 45.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 335,
          "y": 468.4,
          "w": 44.7,
          "h": 16,
          "angle": -90
        },
        {
          "x": 594,
          "y": 468.4,
          "w": 44.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1199.5,
          "y": 474,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1343.5,
          "y": 474,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1372,
          "y": 474,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 681,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 709.5,
          "y": 474.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 738.5,
          "y": 474.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 767.5,
          "y": 474.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 795.5,
          "y": 474.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 825,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 854,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 882.5,
          "y": 474.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 911.5,
          "y": 474.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 940,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 969,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 998,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1027,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1055.5,
          "y": 474.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1084,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1113,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1142,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1171,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1228,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1257,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1286,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1315,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1401,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1430,
          "y": 474.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1458.5,
          "y": 474.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1487.5,
          "y": 474.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1515.5,
          "y": 474.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 277,
          "y": 485.9,
          "w": 49.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 220,
          "y": 486.1,
          "w": 49.4,
          "h": 16,
          "angle": -90
        },
        {
          "x": 162.5,
          "y": 486.5,
          "w": 49,
          "h": 15,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 488.1,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 537,
          "y": 488.7,
          "w": 46.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 479,
          "y": 489.2,
          "w": 46.3,
          "h": 16,
          "angle": -90
        },
        {
          "x": 421,
          "y": 490.2,
          "w": 45.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 364,
          "y": 490.3,
          "w": 45.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 306,
          "y": 491.4,
          "w": 44.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 249,
          "y": 510.8,
          "w": 49.5,
          "h": 16,
          "angle": -90
        },
        {
          "x": 191,
          "y": 510.9,
          "w": 49.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 133.5,
          "y": 511.2,
          "w": 48.5,
          "h": 15,
          "angle": -90
        },
        {
          "x": 623,
          "y": 511.9,
          "w": 47.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 565,
          "y": 512,
          "w": 46.9,
          "h": 17,
          "angle": 89.9
        },
        {
          "x": 508,
          "y": 512.2,
          "w": 46.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 393,
          "y": 512.7,
          "w": 45.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 450,
          "y": 512.9,
          "w": 46.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 335,
          "y": 513.1,
          "w": 44.7,
          "h": 16,
          "angle": -90
        },
        {
          "x": 594,
          "y": 513.1,
          "w": 44.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 681,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 709.5,
          "y": 534.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 738.5,
          "y": 534.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 767.5,
          "y": 534.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 795.5,
          "y": 534.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 825,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 854,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 883,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 911.5,
          "y": 534.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 940,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 969,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 998,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1027,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1055.5,
          "y": 534.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1084,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1113,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1142,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1171,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1199.5,
          "y": 534.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1228,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1257,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1286,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1315,
          "y": 534.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1343.5,
          "y": 534.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1458.5,
          "y": 534.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1487.5,
          "y": 534.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1515.5,
          "y": 534.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1372,
          "y": 535,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1401,
          "y": 535,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1430,
          "y": 535,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 18,
          "y": 535.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 47,
          "y": 535.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 76,
          "y": 535.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 105,
          "y": 535.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 162.5,
          "y": 535.5,
          "w": 49,
          "h": 15,
          "angle": -90
        },
        {
          "x": 220,
          "y": 535.5,
          "w": 49.4,
          "h": 16,
          "angle": -90
        },
        {
          "x": 277,
          "y": 535.5,
          "w": 49.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 306,
          "y": 535.5,
          "w": 44.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 364,
          "y": 535.5,
          "w": 45.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 479,
          "y": 535.5,
          "w": 46.3,
          "h": 16,
          "angle": -90
        },
        {
          "x": 537,
          "y": 535.5,
          "w": 46.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 535.5,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 421,
          "y": 536,
          "w": 45.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 335,
          "y": 557.9,
          "w": 44.7,
          "h": 16,
          "angle": -90
        },
        {
          "x": 594,
          "y": 557.9,
          "w": 44.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 393,
          "y": 558.3,
          "w": 45.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 508,
          "y": 558.8,
          "w": 46.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 565,
          "y": 559,
          "w": 46.9,
          "h": 17,
          "angle": 89.9
        },
        {
          "x": 450,
          "y": 559.1,
          "w": 46.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 623,
          "y": 559.1,
          "w": 47.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 133.5,
          "y": 559.8,
          "w": 48.5,
          "h": 15,
          "angle": -90
        },
        {
          "x": 191,
          "y": 560.1,
          "w": 49.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 249,
          "y": 560.2,
          "w": 49.5,
          "h": 16,
          "angle": -90
        },
        {
          "x": 306,
          "y": 579.6,
          "w": 44.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 364,
          "y": 580.7,
          "w": 45.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 421,
          "y": 581.8,
          "w": 45.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 479,
          "y": 581.8,
          "w": 46.3,
          "h": 16,
          "angle": -90
        },
        {
          "x": 537,
          "y": 582.3,
          "w": 46.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 582.9,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 162.5,
          "y": 584.5,
          "w": 49,
          "h": 15,
          "angle": -90
        },
        {
          "x": 220,
          "y": 584.9,
          "w": 49.4,
          "h": 16,
          "angle": -90
        },
        {
          "x": 277,
          "y": 585.1,
          "w": 49.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 883,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 911.5,
          "y": 595,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1171,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1199.5,
          "y": 595,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1257,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1315,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1343.5,
          "y": 595,
          "w": 48,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1372.5,
          "y": 595,
          "w": 48,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1401,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1430,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1459,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1487,
          "y": 595,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 681,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 709.5,
          "y": 595.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 738.5,
          "y": 595.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 767.5,
          "y": 595.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 796,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 825,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 854,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 940,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 969,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 998,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1027,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1055.5,
          "y": 595.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1084,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1113,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1142,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1228,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1286,
          "y": 595.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1515,
          "y": 595.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 335,
          "y": 602.5,
          "w": 44.7,
          "h": 16,
          "angle": -90
        },
        {
          "x": 594,
          "y": 602.6,
          "w": 44.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 393,
          "y": 603.9,
          "w": 45.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 450,
          "y": 605.2,
          "w": 46.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 508,
          "y": 605.3,
          "w": 46.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 565.1,
          "y": 605.9,
          "w": 46.9,
          "h": 17,
          "angle": 89.9
        },
        {
          "x": 623,
          "y": 606.4,
          "w": 47.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 191,
          "y": 609.4,
          "w": 49.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 249,
          "y": 609.8,
          "w": 49.5,
          "h": 16,
          "angle": -90
        },
        {
          "x": 306,
          "y": 623.7,
          "w": 44.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 364,
          "y": 625.9,
          "w": 45.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 421,
          "y": 627.7,
          "w": 45.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 479,
          "y": 628.2,
          "w": 46.3,
          "h": 16,
          "angle": -90
        },
        {
          "x": 537,
          "y": 629,
          "w": 46.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 630.3,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 220,
          "y": 634.3,
          "w": 49.4,
          "h": 16,
          "angle": -90
        },
        {
          "x": 277,
          "y": 634.6,
          "w": 49.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 335,
          "y": 647.2,
          "w": 44.7,
          "h": 16,
          "angle": -90
        },
        {
          "x": 594,
          "y": 647.4,
          "w": 44.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 393,
          "y": 649.5,
          "w": 45.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 450,
          "y": 651.4,
          "w": 46.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 508,
          "y": 651.9,
          "w": 46.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 565.2,
          "y": 652.9,
          "w": 46.9,
          "h": 17,
          "angle": 89.9
        },
        {
          "x": 623,
          "y": 653.6,
          "w": 47.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 681,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 709.5,
          "y": 655.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 738.5,
          "y": 655.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 767.5,
          "y": 655.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 795.5,
          "y": 655.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 825,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 854,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 883,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 911.5,
          "y": 655.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 940,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 969,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 998,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1027,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1055.5,
          "y": 655.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1084,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1113,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1142,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1171,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1199,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1228,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1257,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1286,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1315,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1343.5,
          "y": 655.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1372,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1401,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1430,
          "y": 655.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1458.5,
          "y": 655.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1487.5,
          "y": 655.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1515.5,
          "y": 655.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 249,
          "y": 659.2,
          "w": 49.5,
          "h": 16,
          "angle": -90
        },
        {
          "x": 306,
          "y": 667.8,
          "w": 44.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 364,
          "y": 671,
          "w": 45.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 421,
          "y": 673.5,
          "w": 45.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 479,
          "y": 674.5,
          "w": 46.3,
          "h": 16,
          "angle": -90
        },
        {
          "x": 537,
          "y": 675.8,
          "w": 46.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 677.6,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 277,
          "y": 684.2,
          "w": 49.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 335,
          "y": 692,
          "w": 44.7,
          "h": 16,
          "angle": -90
        },
        {
          "x": 594,
          "y": 692.1,
          "w": 44.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 393,
          "y": 695,
          "w": 45.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 450,
          "y": 697.5,
          "w": 46.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 508,
          "y": 698.5,
          "w": 46.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 565.3,
          "y": 699.8,
          "w": 46.9,
          "h": 17,
          "angle": 89.9
        },
        {
          "x": 623,
          "y": 700.9,
          "w": 47.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 306,
          "y": 711.9,
          "w": 44.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 825,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 854,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 883,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 911.5,
          "y": 716,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 940,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1027,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1055.5,
          "y": 716,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1084,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1142,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1171,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1199.5,
          "y": 716,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1228,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1257,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1286,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1315,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1343.5,
          "y": 716,
          "w": 48,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1372,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1401,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1430,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1459,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1487,
          "y": 716,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 364,
          "y": 716.2,
          "w": 45.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 681,
          "y": 716.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 709.5,
          "y": 716.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 738.5,
          "y": 716.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 767.5,
          "y": 716.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 796,
          "y": 716.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 969,
          "y": 716.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 998,
          "y": 716.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1113,
          "y": 716.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1515,
          "y": 716.5,
          "w": 47,
          "h": 14,
          "angle": -90
        },
        {
          "x": 421,
          "y": 719.4,
          "w": 45.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 479,
          "y": 720.8,
          "w": 46.3,
          "h": 16,
          "angle": -90
        },
        {
          "x": 537,
          "y": 722.6,
          "w": 46.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 725,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 335,
          "y": 736.6,
          "w": 44.7,
          "h": 16,
          "angle": -90
        },
        {
          "x": 594,
          "y": 736.9,
          "w": 44.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 393,
          "y": 740.6,
          "w": 45.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 450,
          "y": 743.6,
          "w": 46.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 508,
          "y": 745,
          "w": 46.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 565.4,
          "y": 746.7,
          "w": 46.9,
          "h": 17,
          "angle": 89.9
        },
        {
          "x": 623,
          "y": 748.1,
          "w": 47.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 364,
          "y": 761.4,
          "w": 45.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 421,
          "y": 765.2,
          "w": 45.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 479,
          "y": 767.2,
          "w": 46.3,
          "h": 16,
          "angle": -90
        },
        {
          "x": 537,
          "y": 769.3,
          "w": 46.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 772.4,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 883,
          "y": 776.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 911.5,
          "y": 776.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 940,
          "y": 776.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 969,
          "y": 776.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 998,
          "y": 776.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1027,
          "y": 776.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1055.5,
          "y": 776.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1084,
          "y": 776.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1113,
          "y": 776.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1142,
          "y": 776.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1171,
          "y": 776.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1199.5,
          "y": 776.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1315,
          "y": 776.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1343.5,
          "y": 776.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 795.5,
          "y": 777,
          "w": 46,
          "h": 13,
          "angle": -90
        },
        {
          "x": 825,
          "y": 777,
          "w": 46,
          "h": 16,
          "angle": -90
        },
        {
          "x": 854,
          "y": 777,
          "w": 46,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1228,
          "y": 777,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1257,
          "y": 777,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1286,
          "y": 777,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1401,
          "y": 777,
          "w": 46,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1430,
          "y": 777,
          "w": 46,
          "h": 16,
          "angle": -90
        },
        {
          "x": 681,
          "y": 777.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 709.5,
          "y": 777.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 738.5,
          "y": 777.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 767.5,
          "y": 777.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1371,
          "y": 777.5,
          "w": 45,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1458.5,
          "y": 777.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1487.5,
          "y": 777.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1515.5,
          "y": 777.5,
          "w": 45,
          "h": 13,
          "angle": -90
        },
        {
          "x": 594,
          "y": 781.6,
          "w": 44.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 393,
          "y": 786.2,
          "w": 45.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 450,
          "y": 789.8,
          "w": 46.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 508,
          "y": 791.6,
          "w": 46.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 565.5,
          "y": 793.7,
          "w": 46.9,
          "h": 17,
          "angle": 89.9
        },
        {
          "x": 623,
          "y": 795.4,
          "w": 47.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 421,
          "y": 811.1,
          "w": 45.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 479,
          "y": 813.5,
          "w": 46.3,
          "h": 16,
          "angle": -90
        },
        {
          "x": 537,
          "y": 816.1,
          "w": 46.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 819.8,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 594,
          "y": 826.4,
          "w": 44.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 450,
          "y": 835.9,
          "w": 46.1,
          "h": 16,
          "angle": -90
        },
        {
          "x": 911.5,
          "y": 837,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 940,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 969,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 998,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1027,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1055.5,
          "y": 837,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1084,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1113,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1142,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1171,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1199.5,
          "y": 837,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1228,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1257,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1286,
          "y": 837,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1314.5,
          "y": 837,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1343.5,
          "y": 837,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 681,
          "y": 837.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 709.5,
          "y": 837.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 738.5,
          "y": 837.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 767.5,
          "y": 837.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 795.5,
          "y": 837.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 825,
          "y": 837.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 854,
          "y": 837.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 882.5,
          "y": 837.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1371.5,
          "y": 837.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1401,
          "y": 837.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1430,
          "y": 837.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1458.5,
          "y": 837.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1487.5,
          "y": 837.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1515.5,
          "y": 837.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 508,
          "y": 838.2,
          "w": 46.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 565.5,
          "y": 840.6,
          "w": 46.9,
          "h": 17,
          "angle": 89.9
        },
        {
          "x": 623,
          "y": 842.6,
          "w": 47.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 479,
          "y": 859.8,
          "w": 46.3,
          "h": 16,
          "angle": -90
        },
        {
          "x": 537,
          "y": 862.9,
          "w": 46.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 867.2,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 594,
          "y": 871.1,
          "w": 44.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 508,
          "y": 884.7,
          "w": 46.6,
          "h": 16,
          "angle": -90
        },
        {
          "x": 565.6,
          "y": 887.6,
          "w": 46.9,
          "h": 17,
          "angle": 89.9
        },
        {
          "x": 623,
          "y": 889.9,
          "w": 47.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 940,
          "y": 897.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 969,
          "y": 897.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 998,
          "y": 897.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1027,
          "y": 897.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1055.5,
          "y": 897.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1084,
          "y": 897.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1113,
          "y": 897.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1142,
          "y": 897.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1171,
          "y": 897.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1199,
          "y": 897.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1228,
          "y": 897.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 681,
          "y": 898.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 709.5,
          "y": 898.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 738.5,
          "y": 898.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 767.5,
          "y": 898.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 795.5,
          "y": 898.5,
          "w": 45,
          "h": 13,
          "angle": -90
        },
        {
          "x": 825,
          "y": 898.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 853.5,
          "y": 898.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 882.5,
          "y": 898.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 911.5,
          "y": 898.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1257,
          "y": 898.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1286,
          "y": 898.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1314.5,
          "y": 898.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1343.5,
          "y": 898.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1371.5,
          "y": 898.5,
          "w": 45,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1401,
          "y": 898.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1430,
          "y": 898.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1458.5,
          "y": 898.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1487.5,
          "y": 898.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1515.5,
          "y": 898.5,
          "w": 45,
          "h": 13,
          "angle": -90
        },
        {
          "x": 537,
          "y": 909.6,
          "w": 46.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 914.5,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 594,
          "y": 915.9,
          "w": 44.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 565.7,
          "y": 934.5,
          "w": 46.9,
          "h": 17,
          "angle": 89.9
        },
        {
          "x": 623,
          "y": 937.1,
          "w": 47.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 911.5,
          "y": 958,
          "w": 48,
          "h": 15,
          "angle": -90
        },
        {
          "x": 940,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 969,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 998,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1027,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1055,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1084,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1113,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1142,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1171,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1199.5,
          "y": 958,
          "w": 48,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1228,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1257,
          "y": 958,
          "w": 48,
          "h": 16,
          "angle": -90
        },
        {
          "x": 681,
          "y": 958.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 709.5,
          "y": 958.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 738.5,
          "y": 958.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 767.5,
          "y": 958.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 795.5,
          "y": 958.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 825,
          "y": 958.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 854,
          "y": 958.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 883,
          "y": 958.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1286,
          "y": 958.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1314.5,
          "y": 958.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1343.5,
          "y": 958.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1371.5,
          "y": 958.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1401,
          "y": 958.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1430,
          "y": 958.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1458.5,
          "y": 958.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1487.5,
          "y": 958.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1515.5,
          "y": 958.5,
          "w": 47,
          "h": 13,
          "angle": -90
        },
        {
          "x": 594,
          "y": 960.6,
          "w": 44.8,
          "h": 16,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 961.9,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 623,
          "y": 984.4,
          "w": 47.2,
          "h": 16,
          "angle": -90
        },
        {
          "x": 651.5,
          "y": 1009.3,
          "w": 47.4,
          "h": 17,
          "angle": -90
        },
        {
          "x": 825,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 854,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 883,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 911.5,
          "y": 1018.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 940,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 969,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 998,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1027,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1055.5,
          "y": 1018.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1084,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1113,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1142,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1171,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1199.5,
          "y": 1018.5,
          "w": 47,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1228,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1257,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1286,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1315,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1343.5,
          "y": 1018.5,
          "w": 47,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1372,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1401,
          "y": 1018.5,
          "w": 47,
          "h": 16,
          "angle": -90
        },
        {
          "x": 681,
          "y": 1019.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 709.5,
          "y": 1019.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 738.5,
          "y": 1019.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 767.5,
          "y": 1019.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 795.5,
          "y": 1019.5,
          "w": 45,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1430,
          "y": 1019.5,
          "w": 45,
          "h": 16,
          "angle": -90
        },
        {
          "x": 1459.5,
          "y": 1019.5,
          "w": 45,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1487.5,
          "y": 1019.5,
          "w": 45,
          "h": 15,
          "angle": -90
        },
        {
          "x": 1515.5,
          "y": 1019.5,
          "w": 45,
          "h": 13,
          "angle": -90
        }
      ]
    },
    "connection_blocks": [
      "min_x"
    ]
  },
  {
    "slug": "spiral",
    "top_extract": {
      "blocks": [
        {
          "x": 939,
          "y": 51.5,
          "w": 43,
          "h": 14,
          "angle": -90
        },
        {
          "x": 967.1,
          "y": 51.8,
          "w": 43.9,
          "h": 15.4,
          "angle": -86.2
        },
        {
          "x": 910.9,
          "y": 52.9,
          "w": 43.9,
          "h": 15,
          "angle": 87.1
        },
        {
          "x": 994.9,
          "y": 53.8,
          "w": 44,
          "h": 15.5,
          "angle": -82.1
        },
        {
          "x": 883,
          "y": 55.9,
          "w": 43.9,
          "h": 15.4,
          "angle": 84.3
        },
        {
          "x": 1022.5,
          "y": 57.4,
          "w": 43.7,
          "h": 15.4,
          "angle": -79.2
        },
        {
          "x": 855.4,
          "y": 60.6,
          "w": 43.7,
          "h": 15.3,
          "angle": 80.5
        },
        {
          "x": 1050.1,
          "y": 62.8,
          "w": 43.7,
          "h": 15.9,
          "angle": -76.5
        },
        {
          "x": 827.7,
          "y": 67.2,
          "w": 43.9,
          "h": 15.4,
          "angle": 77
        },
        {
          "x": 1076.8,
          "y": 69.6,
          "w": 43.8,
          "h": 15.7,
          "angle": -72.5
        },
        {
          "x": 800.6,
          "y": 75.3,
          "w": 43.7,
          "h": 15.5,
          "angle": 74.1
        },
        {
          "x": 1103.1,
          "y": 78,
          "w": 43.9,
          "h": 15.7,
          "angle": -69
        },
        {
          "x": 774,
          "y": 84.8,
          "w": 43.9,
          "h": 15.8,
          "angle": 70.2
        },
        {
          "x": 1128.9,
          "y": 88.2,
          "w": 43.9,
          "h": 15.6,
          "angle": -66
        },
        {
          "x": 747.8,
          "y": 96.3,
          "w": 43.8,
          "h": 15.9,
          "angle": 67.6
        },
        {
          "x": 1154,
          "y": 99.8,
          "w": 44.4,
          "h": 15.8,
          "angle": -61.9
        },
        {
          "x": 722.3,
          "y": 109.1,
          "w": 43.4,
          "h": 15.7,
          "angle": 63.4
        },
        {
          "x": 1178.2,
          "y": 112.6,
          "w": 43.7,
          "h": 16.1,
          "angle": -59
        },
        {
          "x": 697.9,
          "y": 123.6,
          "w": 44.2,
          "h": 15.9,
          "angle": 59.5
        },
        {
          "x": 1201.5,
          "y": 127,
          "w": 44.1,
          "h": 15.5,
          "angle": -54.8
        },
        {
          "x": 674,
          "y": 139.5,
          "w": 43.5,
          "h": 15.5,
          "angle": 56.3
        },
        {
          "x": 1223.8,
          "y": 142.6,
          "w": 43.9,
          "h": 16.1,
          "angle": -52.1
        },
        {
          "x": 651,
          "y": 156.9,
          "w": 43.8,
          "h": 15.4,
          "angle": 53.1
        },
        {
          "x": 1245.4,
          "y": 159.8,
          "w": 44,
          "h": 15.7,
          "angle": -48.2
        },
        {
          "x": 937,
          "y": 161.5,
          "w": 43,
          "h": 14,
          "angle": -90
        },
        {
          "x": 965.5,
          "y": 161.5,
          "w": 43.7,
          "h": 15.3,
          "angle": -84.8
        },
        {
          "x": 908.2,
          "y": 163.3,
          "w": 43.5,
          "h": 15,
          "angle": 86.4
        },
        {
          "x": 993.9,
          "y": 164,
          "w": 43.8,
          "h": 15.4,
          "angle": -80
        },
        {
          "x": 879.8,
          "y": 167.5,
          "w": 44,
          "h": 15.3,
          "angle": 81.3
        },
        {
          "x": 1021.9,
          "y": 168.7,
          "w": 43.7,
          "h": 15.3,
          "angle": -76
        },
        {
          "x": 851.8,
          "y": 174.2,
          "w": 43.9,
          "h": 15.5,
          "angle": 76
        },
        {
          "x": 629.4,
          "y": 175.6,
          "w": 43.7,
          "h": 15.5,
          "angle": 49.9
        },
        {
          "x": 1049.2,
          "y": 175.8,
          "w": 43.6,
          "h": 15.5,
          "angle": -71.6
        },
        {
          "x": 1265.8,
          "y": 177.8,
          "w": 43.8,
          "h": 14.8,
          "angle": -45
        },
        {
          "x": 824,
          "y": 183,
          "w": 43.6,
          "h": 15.2,
          "angle": 71.6
        },
        {
          "x": 1075.8,
          "y": 184.8,
          "w": 44.1,
          "h": 15.5,
          "angle": -66.4
        },
        {
          "x": 797.1,
          "y": 194.2,
          "w": 43.8,
          "h": 15.3,
          "angle": 67.4
        },
        {
          "x": 608.8,
          "y": 195.8,
          "w": 43.1,
          "h": 15.6,
          "angle": 45
        },
        {
          "x": 1101.6,
          "y": 196.1,
          "w": 44,
          "h": 15.4,
          "angle": -61.7
        },
        {
          "x": 1284.8,
          "y": 197.3,
          "w": 44,
          "h": 15.9,
          "angle": -39.8
        },
        {
          "x": 771.1,
          "y": 207.4,
          "w": 43.9,
          "h": 15.6,
          "angle": 64.3
        },
        {
          "x": 1126.2,
          "y": 209.3,
          "w": 44.1,
          "h": 15.5,
          "angle": -56.3
        },
        {
          "x": 589.2,
          "y": 216.9,
          "w": 43.9,
          "h": 15.7,
          "angle": 42.4
        },
        {
          "x": 1302.6,
          "y": 217.7,
          "w": 44,
          "h": 15.6,
          "angle": -38.7
        },
        {
          "x": 746.1,
          "y": 222.9,
          "w": 43.6,
          "h": 15.5,
          "angle": 58.4
        },
        {
          "x": 1149.8,
          "y": 224.3,
          "w": 44,
          "h": 15.9,
          "angle": -52.4
        },
        {
          "x": 1319,
          "y": 239,
          "w": 43.8,
          "h": 16.6,
          "angle": -33.7
        },
        {
          "x": 571,
          "y": 239.5,
          "w": 43.7,
          "h": 15.5,
          "angle": 38.7
        },
        {
          "x": 722.3,
          "y": 240.5,
          "w": 44,
          "h": 15.4,
          "angle": 53.1
        },
        {
          "x": 1171.8,
          "y": 241.1,
          "w": 44.2,
          "h": 15.8,
          "angle": -48
        },
        {
          "x": 1192.5,
          "y": 259.5,
          "w": 43.8,
          "h": 15.6,
          "angle": -45
        },
        {
          "x": 699.8,
          "y": 259.8,
          "w": 43.9,
          "h": 15.6,
          "angle": 48
        },
        {
          "x": 1334.4,
          "y": 261.6,
          "w": 43.6,
          "h": 16.1,
          "angle": -31
        },
        {
          "x": 554,
          "y": 263.2,
          "w": 43.7,
          "h": 15.8,
          "angle": 35.5
        },
        {
          "x": 949.9,
          "y": 270.5,
          "w": 43.9,
          "h": 15.4,
          "angle": -86.4
        },
        {
          "x": 922.5,
          "y": 271.5,
          "w": 43,
          "h": 15,
          "angle": -90
        },
        {
          "x": 976.9,
          "y": 272.2,
          "w": 43.9,
          "h": 15.4,
          "angle": -80
        },
        {
          "x": 895.2,
          "y": 276.2,
          "w": 43.7,
          "h": 15.4,
          "angle": 81
        },
        {
          "x": 1003.7,
          "y": 276.8,
          "w": 43.9,
          "h": 15.7,
          "angle": -72.9
        },
        {
          "x": 1211.3,
          "y": 279.3,
          "w": 44.1,
          "h": 15.4,
          "angle": -38.3
        },
        {
          "x": 679.3,
          "y": 280.8,
          "w": 43.8,
          "h": 14.8,
          "angle": 45
        },
        {
          "x": 868.2,
          "y": 283.6,
          "w": 43.8,
          "h": 15.7,
          "angle": 74.1
        },
        {
          "x": 1029.3,
          "y": 284.3,
          "w": 44,
          "h": 15.4,
          "angle": -67.8
        },
        {
          "x": 1348.2,
          "y": 284.5,
          "w": 43.7,
          "h": 15.6,
          "angle": -27.8
        },
        {
          "x": 538.6,
          "y": 287.7,
          "w": 43.9,
          "h": 15.5,
          "angle": 31.8
        },
        {
          "x": 842.3,
          "y": 293.9,
          "w": 43.8,
          "h": 15.4,
          "angle": 68.2
        },
        {
          "x": 1053.9,
          "y": 294.5,
          "w": 43.9,
          "h": 15.8,
          "angle": -60.5
        },
        {
          "x": 1228.2,
          "y": 300.5,
          "w": 43.5,
          "h": 15.5,
          "angle": -33.7
        },
        {
          "x": 659.7,
          "y": 303.7,
          "w": 43.8,
          "h": 15.2,
          "angle": 39.8
        },
        {
          "x": 817.4,
          "y": 307.2,
          "w": 43.8,
          "h": 15.5,
          "angle": 62.1
        },
        {
          "x": 1076.9,
          "y": 307.3,
          "w": 44.1,
          "h": 15.5,
          "angle": -53.7
        },
        {
          "x": 1360.6,
          "y": 308.5,
          "w": 44.1,
          "h": 15.5,
          "angle": -24.1
        },
        {
          "x": 524.6,
          "y": 313.3,
          "w": 44.1,
          "h": 15.4,
          "angle": 28.6
        },
        {
          "x": 793.8,
          "y": 323.2,
          "w": 43.8,
          "h": 15.4,
          "angle": 55.7
        },
        {
          "x": 1243.8,
          "y": 323.2,
          "w": 43.9,
          "h": 15.6,
          "angle": -29.4
        },
        {
          "x": 1100.2,
          "y": 324,
          "w": 43.9,
          "h": 15.7,
          "angle": -47.3
        },
        {
          "x": 644.6,
          "y": 325,
          "w": 43.7,
          "h": 15.5,
          "angle": 35.8
        },
        {
          "x": 1371.7,
          "y": 333,
          "w": 43.7,
          "h": 16.1,
          "angle": -22.2
        },
        {
          "x": 512.2,
          "y": 339.7,
          "w": 43.5,
          "h": 15.2,
          "angle": 24.9
        },
        {
          "x": 772.1,
          "y": 342,
          "w": 44,
          "h": 15.3,
          "angle": 49.4
        },
        {
          "x": 1121,
          "y": 343,
          "w": 43.8,
          "h": 15.4,
          "angle": -40.9
        },
        {
          "x": 1257.3,
          "y": 346.6,
          "w": 43.9,
          "h": 15.3,
          "angle": -25.7
        },
        {
          "x": 630.8,
          "y": 347.3,
          "w": 43.8,
          "h": 15.4,
          "angle": 32.7
        },
        {
          "x": 1380.8,
          "y": 358.2,
          "w": 43.8,
          "h": 15.5,
          "angle": -16.3
        },
        {
          "x": 754,
          "y": 361,
          "w": 43.8,
          "h": 15.6,
          "angle": 45
        },
        {
          "x": 1139.2,
          "y": 364.3,
          "w": 43.8,
          "h": 15.8,
          "angle": -33.7
        },
        {
          "x": 501.4,
          "y": 367,
          "w": 43.8,
          "h": 15.2,
          "angle": 21.8
        },
        {
          "x": 618.4,
          "y": 370.8,
          "w": 43.6,
          "h": 15.5,
          "angle": 28.1
        },
        {
          "x": 1268.7,
          "y": 371.2,
          "w": 43.9,
          "h": 15.5,
          "angle": -20.2
        },
        {
          "x": 961.8,
          "y": 380.3,
          "w": 44,
          "h": 15.4,
          "angle": -78.2
        },
        {
          "x": 935,
          "y": 380.5,
          "w": 43,
          "h": 14,
          "angle": -90
        },
        {
          "x": 738.1,
          "y": 382.1,
          "w": 43.8,
          "h": 15.7,
          "angle": 37.4
        },
        {
          "x": 1388.7,
          "y": 383.5,
          "w": 43.9,
          "h": 15.4,
          "angle": -13.4
        },
        {
          "x": 908.3,
          "y": 385.3,
          "w": 43.6,
          "h": 15,
          "angle": 79.1
        },
        {
          "x": 988.7,
          "y": 385.9,
          "w": 43.8,
          "h": 15.5,
          "angle": -66
        },
        {
          "x": 1154.6,
          "y": 387.3,
          "w": 43.9,
          "h": 15.5,
          "angle": -27.3
        },
        {
          "x": 492.1,
          "y": 394.7,
          "w": 43.7,
          "h": 15.6,
          "angle": 17.9
        },
        {
          "x": 608,
          "y": 394.8,
          "w": 43.7,
          "h": 15.5,
          "angle": 23.6
        },
        {
          "x": 884,
          "y": 395.1,
          "w": 43.6,
          "h": 15.6,
          "angle": 68.2
        },
        {
          "x": 1278,
          "y": 396.3,
          "w": 43.8,
          "h": 15.5,
          "angle": -15.9
        },
        {
          "x": 1013.3,
          "y": 396.5,
          "w": 43.8,
          "h": 15.9,
          "angle": -55.3
        },
        {
          "x": 724,
          "y": 404.8,
          "w": 43.8,
          "h": 15.3,
          "angle": 31.8
        },
        {
          "x": 1395,
          "y": 409.4,
          "w": 43.9,
          "h": 15.6,
          "angle": -9.8
        },
        {
          "x": 861.2,
          "y": 409.5,
          "w": 43.9,
          "h": 15.9,
          "angle": 59
        },
        {
          "x": 1167,
          "y": 411.7,
          "w": 43.9,
          "h": 15.7,
          "angle": -20
        },
        {
          "x": 1035.3,
          "y": 412,
          "w": 43.9,
          "h": 15.6,
          "angle": -42.7
        },
        {
          "x": 599.1,
          "y": 419.7,
          "w": 43.6,
          "h": 15.8,
          "angle": 18.4
        },
        {
          "x": 1285.6,
          "y": 422.3,
          "w": 43.7,
          "h": 15.7,
          "angle": -11.3
        },
        {
          "x": 484.5,
          "y": 423.1,
          "w": 43.7,
          "h": 15.2,
          "angle": 14.6
        },
        {
          "x": 840.8,
          "y": 427.9,
          "w": 43.7,
          "h": 15.5,
          "angle": 47.7
        },
        {
          "x": 712.4,
          "y": 428.7,
          "w": 43.4,
          "h": 15.2,
          "angle": 26.6
        },
        {
          "x": 1053.1,
          "y": 431.5,
          "w": 44,
          "h": 15.7,
          "angle": -30.1
        },
        {
          "x": 1399.7,
          "y": 435.5,
          "w": 43.9,
          "h": 15.4,
          "angle": -6.7
        },
        {
          "x": 1176.3,
          "y": 437.6,
          "w": 43.8,
          "h": 15.4,
          "angle": -12.8
        },
        {
          "x": 591.8,
          "y": 445.5,
          "w": 43.7,
          "h": 15.4,
          "angle": 15.9
        },
        {
          "x": 1290.9,
          "y": 448.3,
          "w": 43.8,
          "h": 15.5,
          "angle": -6.3
        },
        {
          "x": 824.6,
          "y": 449.2,
          "w": 43.7,
          "h": 15.8,
          "angle": 37.7
        },
        {
          "x": 478.7,
          "y": 452,
          "w": 43.7,
          "h": 15.1,
          "angle": 11.3
        },
        {
          "x": 703,
          "y": 454.2,
          "w": 43.7,
          "h": 15.5,
          "angle": 19.7
        },
        {
          "x": 1066.7,
          "y": 454.9,
          "w": 44.3,
          "h": 15.6,
          "angle": -16.7
        },
        {
          "x": 1402.6,
          "y": 461.9,
          "w": 43.6,
          "h": 15.5,
          "angle": -3.6
        },
        {
          "x": 1182.4,
          "y": 463.9,
          "w": 43.8,
          "h": 15.3,
          "angle": -6
        },
        {
          "x": 586.6,
          "y": 471.7,
          "w": 43.7,
          "h": 15.3,
          "angle": 11.3
        },
        {
          "x": 812.4,
          "y": 473,
          "w": 43.9,
          "h": 15.4,
          "angle": 27.6
        },
        {
          "x": 1293.5,
          "y": 474.5,
          "w": 43,
          "h": 15,
          "angle": 0
        },
        {
          "x": 696.4,
          "y": 480.4,
          "w": 43.7,
          "h": 15.3,
          "angle": 14.6
        },
        {
          "x": 1074.6,
          "y": 480.8,
          "w": 43.6,
          "h": 15.3,
          "angle": -3.4
        },
        {
          "x": 474.6,
          "y": 481.3,
          "w": 43.7,
          "h": 15.1,
          "angle": 8.1
        },
        {
          "x": 1404.5,
          "y": 488.5,
          "w": 43,
          "h": 15,
          "angle": 0
        },
        {
          "x": 1185.5,
          "y": 490.5,
          "w": 43,
          "h": 15,
          "angle": 0
        },
        {
          "x": 582.9,
          "y": 498.2,
          "w": 43.7,
          "h": 15.3,
          "angle": 7.6
        },
        {
          "x": 804,
          "y": 499.2,
          "w": 43.7,
          "h": 15.5,
          "angle": 17.4
        },
        {
          "x": 1294.6,
          "y": 501.2,
          "w": 43.4,
          "h": 15.4,
          "angle": 2.5
        },
        {
          "x": 1076.3,
          "y": 507,
          "w": 43.8,
          "h": 15.5,
          "angle": 10.8
        },
        {
          "x": 692,
          "y": 507.5,
          "w": 43.7,
          "h": 15.4,
          "angle": 9
        },
        {
          "x": 472.3,
          "y": 510.7,
          "w": 43.7,
          "h": 15.2,
          "angle": 4.1
        },
        {
          "x": 1404.2,
          "y": 514.8,
          "w": 43.8,
          "h": 15.8,
          "angle": 3.8
        },
        {
          "x": 1184.8,
          "y": 517,
          "w": 43.7,
          "h": 15.6,
          "angle": 8.1
        },
        {
          "x": 581.3,
          "y": 525.1,
          "w": 43.6,
          "h": 15.2,
          "angle": 3.6
        },
        {
          "x": 800.2,
          "y": 525.3,
          "w": 43.8,
          "h": 15.3,
          "angle": 8.1
        },
        {
          "x": 1293.8,
          "y": 527.5,
          "w": 43.9,
          "h": 15.3,
          "angle": 7.1
        },
        {
          "x": 1071.4,
          "y": 533.1,
          "w": 43.8,
          "h": 15.6,
          "angle": 25.2
        },
        {
          "x": 690.6,
          "y": 534.9,
          "w": 43.5,
          "h": 15.2,
          "angle": 2.9
        },
        {
          "x": 471.5,
          "y": 540.5,
          "w": 43,
          "h": 15,
          "angle": 0
        },
        {
          "x": 1402.5,
          "y": 540.9,
          "w": 43.9,
          "h": 15.5,
          "angle": 6.7
        },
        {
          "x": 1181.4,
          "y": 542.9,
          "w": 43.9,
          "h": 15.8,
          "angle": 14.9
        },
        {
          "x": 581.5,
          "y": 552,
          "w": 43,
          "h": 14,
          "angle": 0
        },
        {
          "x": 800.5,
          "y": 552,
          "w": 43,
          "h": 14,
          "angle": 0
        },
        {
          "x": 910.9,
          "y": 552.8,
          "w": 43.8,
          "h": 15.1,
          "angle": -4.8
        },
        {
          "x": 1290.6,
          "y": 553.5,
          "w": 43.9,
          "h": 15.6,
          "angle": 12.3
        },
        {
          "x": 1060.4,
          "y": 557.3,
          "w": 44,
          "h": 15.5,
          "angle": 39.8
        },
        {
          "x": 692,
          "y": 562.5,
          "w": 44,
          "h": 15,
          "angle": 0
        },
        {
          "x": 1399.4,
          "y": 566.9,
          "w": 43.9,
          "h": 15.5,
          "angle": 10.6
        },
        {
          "x": 472.6,
          "y": 570.2,
          "w": 43.3,
          "h": 15.2,
          "angle": -2
        },
        {
          "x": 1174,
          "y": 570.3,
          "w": 43.6,
          "h": 15.8,
          "angle": 21.8
        },
        {
          "x": 923.9,
          "y": 575.9,
          "w": 43.9,
          "h": 15.4,
          "angle": -29.1
        },
        {
          "x": 1043.5,
          "y": 577.6,
          "w": 43.9,
          "h": 15.4,
          "angle": 55.3
        },
        {
          "x": 805.8,
          "y": 578.8,
          "w": 43.7,
          "h": 15.3,
          "angle": -10.6
        },
        {
          "x": 583.7,
          "y": 579,
          "w": 43.8,
          "h": 15.2,
          "angle": -4.4
        },
        {
          "x": 1284.4,
          "y": 582.4,
          "w": 44,
          "h": 15.4,
          "angle": 17.1
        },
        {
          "x": 696.1,
          "y": 590,
          "w": 43.8,
          "h": 15.3,
          "angle": -8.1
        },
        {
          "x": 944.6,
          "y": 592.3,
          "w": 44,
          "h": 15.5,
          "angle": -50.7
        },
        {
          "x": 1021.8,
          "y": 592.4,
          "w": 43.7,
          "h": 15.4,
          "angle": 72.1
        },
        {
          "x": 1163.3,
          "y": 596.1,
          "w": 43.9,
          "h": 15.6,
          "angle": 30.6
        },
        {
          "x": 1393.7,
          "y": 597,
          "w": 43.8,
          "h": 15.5,
          "angle": 15.3
        },
        {
          "x": 475.8,
          "y": 599.7,
          "w": 43.7,
          "h": 15.2,
          "angle": -5.2
        },
        {
          "x": 996.5,
          "y": 600.5,
          "w": 43,
          "h": 15,
          "angle": -90
        },
        {
          "x": 970.4,
          "y": 601,
          "w": 44,
          "h": 15.8,
          "angle": -72.3
        },
        {
          "x": 815.2,
          "y": 604.9,
          "w": 43.7,
          "h": 15.5,
          "angle": -20.2
        },
        {
          "x": 587.7,
          "y": 605.8,
          "w": 43.8,
          "h": 15.3,
          "angle": -8.1
        },
        {
          "x": 1275.9,
          "y": 610.4,
          "w": 44.1,
          "h": 16.1,
          "angle": 20.9
        },
        {
          "x": 703,
          "y": 617.1,
          "w": 43.7,
          "h": 15.3,
          "angle": -14
        },
        {
          "x": 1149.5,
          "y": 620,
          "w": 43.9,
          "h": 15.5,
          "angle": 38.2
        },
        {
          "x": 1385.9,
          "y": 626.3,
          "w": 44.3,
          "h": 15.8,
          "angle": 18.4
        },
        {
          "x": 827.8,
          "y": 628.1,
          "w": 43.9,
          "h": 15.4,
          "angle": -29.1
        },
        {
          "x": 480.7,
          "y": 629.1,
          "w": 43.7,
          "h": 15.1,
          "angle": -9.2
        },
        {
          "x": 593.6,
          "y": 632.3,
          "w": 43.6,
          "h": 15.4,
          "angle": -12.3
        },
        {
          "x": 1264.8,
          "y": 637.4,
          "w": 43.8,
          "h": 15.2,
          "angle": 26.6
        },
        {
          "x": 1132.5,
          "y": 641.5,
          "w": 43.8,
          "h": 15.6,
          "angle": 45
        },
        {
          "x": 712.7,
          "y": 643.6,
          "w": 44,
          "h": 15.6,
          "angle": -19.8
        },
        {
          "x": 844,
          "y": 649.2,
          "w": 43.8,
          "h": 15.6,
          "angle": -36.9
        },
        {
          "x": 1376.3,
          "y": 655.1,
          "w": 43.7,
          "h": 15.9,
          "angle": 22.2
        },
        {
          "x": 487.1,
          "y": 658.3,
          "w": 43.7,
          "h": 15.2,
          "angle": -12.7
        },
        {
          "x": 601.5,
          "y": 658.6,
          "w": 43.9,
          "h": 15.4,
          "angle": -16.7
        },
        {
          "x": 1113.9,
          "y": 660.7,
          "w": 43.8,
          "h": 15.4,
          "angle": 53.1
        },
        {
          "x": 1251.5,
          "y": 662.7,
          "w": 43.9,
          "h": 15.9,
          "angle": 32.7
        },
        {
          "x": 864,
          "y": 668,
          "w": 43.8,
          "h": 15.6,
          "angle": -45
        },
        {
          "x": 725,
          "y": 669,
          "w": 43.8,
          "h": 15.2,
          "angle": -26.6
        },
        {
          "x": 1092.6,
          "y": 676.9,
          "w": 43.8,
          "h": 15.7,
          "angle": 59.9
        },
        {
          "x": 1364.2,
          "y": 683.1,
          "w": 43.4,
          "h": 15.2,
          "angle": 26.6
        },
        {
          "x": 886,
          "y": 684.1,
          "w": 43.8,
          "h": 15.4,
          "angle": -55
        },
        {
          "x": 611,
          "y": 684.2,
          "w": 43.6,
          "h": 15.3,
          "angle": -20.8
        },
        {
          "x": 495.4,
          "y": 686.9,
          "w": 43.7,
          "h": 15.4,
          "angle": -15.6
        },
        {
          "x": 1235.9,
          "y": 687.2,
          "w": 43.8,
          "h": 15.5,
          "angle": 37.6
        },
        {
          "x": 1069.7,
          "y": 690.1,
          "w": 43.9,
          "h": 15.5,
          "angle": 67.6
        },
        {
          "x": 739.9,
          "y": 693.4,
          "w": 43.8,
          "h": 15.6,
          "angle": -32
        },
        {
          "x": 910.7,
          "y": 696.6,
          "w": 43.4,
          "h": 15.2,
          "angle": -63.4
        },
        {
          "x": 1043.7,
          "y": 700.8,
          "w": 43.7,
          "h": 15.5,
          "angle": 76
        },
        {
          "x": 936.3,
          "y": 704.6,
          "w": 44,
          "h": 15.5,
          "angle": -71.6
        },
        {
          "x": 1016.8,
          "y": 707.5,
          "w": 43.7,
          "h": 15.3,
          "angle": 83.7
        },
        {
          "x": 622.4,
          "y": 709.2,
          "w": 43.5,
          "h": 15.5,
          "angle": -24.6
        },
        {
          "x": 962.4,
          "y": 709.4,
          "w": 43.8,
          "h": 15.3,
          "angle": -80
        },
        {
          "x": 1218.4,
          "y": 710.1,
          "w": 43.4,
          "h": 15.6,
          "angle": 43.6
        },
        {
          "x": 1350.8,
          "y": 710.1,
          "w": 44.1,
          "h": 15.3,
          "angle": 31.3
        },
        {
          "x": 989.5,
          "y": 710.5,
          "w": 43,
          "h": 15,
          "angle": -90
        },
        {
          "x": 505.5,
          "y": 715.3,
          "w": 43.5,
          "h": 15.3,
          "angle": -19.7
        },
        {
          "x": 757.4,
          "y": 716.2,
          "w": 44,
          "h": 15.5,
          "angle": -37.6
        },
        {
          "x": 1198.9,
          "y": 730.9,
          "w": 43.8,
          "h": 15.8,
          "angle": 48.4
        },
        {
          "x": 635.6,
          "y": 733.2,
          "w": 43.7,
          "h": 15.3,
          "angle": -28.6
        },
        {
          "x": 1335.1,
          "y": 736,
          "w": 43.7,
          "h": 15.7,
          "angle": 35.5
        },
        {
          "x": 777.2,
          "y": 737.4,
          "w": 43.8,
          "h": 15.5,
          "angle": -42.3
        },
        {
          "x": 517.1,
          "y": 742.9,
          "w": 43.6,
          "h": 15.6,
          "angle": -22.6
        },
        {
          "x": 1177.8,
          "y": 749.9,
          "w": 44,
          "h": 15.8,
          "angle": 53.1
        },
        {
          "x": 798.9,
          "y": 756.5,
          "w": 43.8,
          "h": 15.5,
          "angle": -49.4
        },
        {
          "x": 650.6,
          "y": 756.6,
          "w": 43.5,
          "h": 15.5,
          "angle": -33.7
        },
        {
          "x": 1318.1,
          "y": 760.5,
          "w": 43.9,
          "h": 15.5,
          "angle": 39
        },
        {
          "x": 1155.1,
          "y": 766.6,
          "w": 43.6,
          "h": 15.8,
          "angle": 58
        },
        {
          "x": 530.8,
          "y": 770.1,
          "w": 43.4,
          "h": 15.2,
          "angle": -26.6
        },
        {
          "x": 820.5,
          "y": 771.9,
          "w": 43.9,
          "h": 15.3,
          "angle": -54.5
        },
        {
          "x": 667,
          "y": 778.9,
          "w": 43.8,
          "h": 15.4,
          "angle": -36.9
        },
        {
          "x": 1131.2,
          "y": 781.4,
          "w": 43.8,
          "h": 15.2,
          "angle": 63.4
        },
        {
          "x": 1299.3,
          "y": 783.8,
          "w": 43.8,
          "h": 15.3,
          "angle": 43
        },
        {
          "x": 1434.4,
          "y": 783.9,
          "w": 43.8,
          "h": 15.2,
          "angle": 33.2
        },
        {
          "x": 843.1,
          "y": 785.4,
          "w": 43.7,
          "h": 15.3,
          "angle": -59
        },
        {
          "x": 1106.2,
          "y": 793.8,
          "w": 43.8,
          "h": 15.5,
          "angle": 68.7
        },
        {
          "x": 545.7,
          "y": 796.3,
          "w": 43.6,
          "h": 15.4,
          "angle": -29.1
        },
        {
          "x": 867.2,
          "y": 796.6,
          "w": 43.8,
          "h": 15.3,
          "angle": -64.5
        },
        {
          "x": 685.1,
          "y": 800,
          "w": 43.6,
          "h": 15.4,
          "angle": -40.2
        },
        {
          "x": 1080.2,
          "y": 804,
          "w": 43.5,
          "h": 15.4,
          "angle": 74.1
        },
        {
          "x": 892.1,
          "y": 805.9,
          "w": 43.8,
          "h": 15.6,
          "angle": -69.4
        },
        {
          "x": 1279,
          "y": 806,
          "w": 43.8,
          "h": 15.6,
          "angle": 45
        },
        {
          "x": 1420,
          "y": 806.6,
          "w": 44,
          "h": 15.4,
          "angle": 36
        },
        {
          "x": 1053.4,
          "y": 811.6,
          "w": 43.7,
          "h": 15.4,
          "angle": 79.4
        },
        {
          "x": 918.2,
          "y": 812.9,
          "w": 43.6,
          "h": 15.3,
          "angle": -74.7
        },
        {
          "x": 1026.5,
          "y": 816.8,
          "w": 43.8,
          "h": 15.3,
          "angle": 84.3
        },
        {
          "x": 944.8,
          "y": 817.5,
          "w": 43.8,
          "h": 15.4,
          "angle": -80
        },
        {
          "x": 999,
          "y": 819.5,
          "w": 43,
          "h": 14,
          "angle": -90
        },
        {
          "x": 971.8,
          "y": 819.7,
          "w": 43.7,
          "h": 15.3,
          "angle": -85.6
        },
        {
          "x": 704.8,
          "y": 819.8,
          "w": 43.8,
          "h": 14.8,
          "angle": -45
        },
        {
          "x": 562.2,
          "y": 821.5,
          "w": 43.5,
          "h": 15.5,
          "angle": -33.7
        },
        {
          "x": 1257.2,
          "y": 826,
          "w": 43.9,
          "h": 15.3,
          "angle": 51.3
        },
        {
          "x": 1404.3,
          "y": 828.2,
          "w": 44,
          "h": 16,
          "angle": 39.5
        },
        {
          "x": 725.9,
          "y": 838.2,
          "w": 43.9,
          "h": 15.5,
          "angle": -48.4
        },
        {
          "x": 1234.1,
          "y": 844.9,
          "w": 43.8,
          "h": 15.8,
          "angle": 56.3
        },
        {
          "x": 580.4,
          "y": 845.8,
          "w": 43.6,
          "h": 15.4,
          "angle": -36.9
        },
        {
          "x": 1387.3,
          "y": 849.5,
          "w": 43.9,
          "h": 15.7,
          "angle": 42
        },
        {
          "x": 748.4,
          "y": 855.5,
          "w": 44,
          "h": 15.9,
          "angle": -52.4
        },
        {
          "x": 1209.9,
          "y": 861.9,
          "w": 43.9,
          "h": 15.8,
          "angle": 59
        },
        {
          "x": 600,
          "y": 869,
          "w": 43.7,
          "h": 15.6,
          "angle": -39.8
        },
        {
          "x": 1370,
          "y": 869.5,
          "w": 43.1,
          "h": 16.3,
          "angle": 45
        },
        {
          "x": 771.7,
          "y": 870.7,
          "w": 43.5,
          "h": 15.3,
          "angle": -56.3
        },
        {
          "x": 1184.6,
          "y": 877.2,
          "w": 43.8,
          "h": 15.2,
          "angle": 63.4
        },
        {
          "x": 796.3,
          "y": 884.5,
          "w": 43.7,
          "h": 15.7,
          "angle": -60.6
        },
        {
          "x": 1350.8,
          "y": 888.7,
          "w": 44.5,
          "h": 15.8,
          "angle": 47
        },
        {
          "x": 1158.4,
          "y": 890.3,
          "w": 44.1,
          "h": 15.4,
          "angle": 67.1
        },
        {
          "x": 621.1,
          "y": 891.2,
          "w": 43.8,
          "h": 15.3,
          "angle": -43.5
        },
        {
          "x": 821.9,
          "y": 896.6,
          "w": 43.8,
          "h": 15.5,
          "angle": -65.1
        },
        {
          "x": 1131.5,
          "y": 901.9,
          "w": 43.6,
          "h": 15.5,
          "angle": 71.6
        },
        {
          "x": 1331.5,
          "y": 906.7,
          "w": 43.8,
          "h": 15.7,
          "angle": 50.2
        },
        {
          "x": 848.4,
          "y": 906.9,
          "w": 43.7,
          "h": 15.5,
          "angle": -68.6
        },
        {
          "x": 1103.7,
          "y": 911.5,
          "w": 43.9,
          "h": 15.5,
          "angle": 75.4
        },
        {
          "x": 643.4,
          "y": 911.9,
          "w": 43.5,
          "h": 15.5,
          "angle": -47
        },
        {
          "x": 875.7,
          "y": 915.4,
          "w": 44,
          "h": 15.5,
          "angle": -71.6
        },
        {
          "x": 1075.5,
          "y": 918.9,
          "w": 44,
          "h": 15.6,
          "angle": 78.3
        },
        {
          "x": 903.6,
          "y": 921.7,
          "w": 43.7,
          "h": 15.2,
          "angle": -77.2
        },
        {
          "x": 1310.9,
          "y": 924,
          "w": 43.9,
          "h": 15.6,
          "angle": 53.6
        },
        {
          "x": 1047,
          "y": 924.4,
          "w": 43.8,
          "h": 15.3,
          "angle": 82.9
        },
        {
          "x": 931.8,
          "y": 926.3,
          "w": 43.7,
          "h": 15.5,
          "angle": -80.5
        },
        {
          "x": 1018.3,
          "y": 928,
          "w": 43.8,
          "h": 15.3,
          "angle": 87.3
        },
        {
          "x": 960.5,
          "y": 928.8,
          "w": 43.6,
          "h": 15.2,
          "angle": -85
        },
        {
          "x": 989.5,
          "y": 929.5,
          "w": 43,
          "h": 15,
          "angle": -90
        },
        {
          "x": 667.1,
          "y": 931.6,
          "w": 43.8,
          "h": 15.7,
          "angle": -50.2
        },
        {
          "x": 1289.8,
          "y": 940,
          "w": 44.1,
          "h": 15.8,
          "angle": 56.3
        },
        {
          "x": 691.7,
          "y": 949.4,
          "w": 43.8,
          "h": 15.5,
          "angle": -53.6
        },
        {
          "x": 1267.5,
          "y": 955.1,
          "w": 43.9,
          "h": 15.9,
          "angle": 59
        },
        {
          "x": 717.7,
          "y": 966,
          "w": 43.7,
          "h": 15.4,
          "angle": -57.4
        },
        {
          "x": 1245.2,
          "y": 968.7,
          "w": 44.1,
          "h": 15.6,
          "angle": 61.4
        },
        {
          "x": 744.2,
          "y": 980.9,
          "w": 43.8,
          "h": 15.6,
          "angle": -61.4
        },
        {
          "x": 1221.5,
          "y": 981.5,
          "w": 43.6,
          "h": 15.8,
          "angle": 65
        },
        {
          "x": 1197.7,
          "y": 993,
          "w": 44,
          "h": 15.8,
          "angle": 68.2
        },
        {
          "x": 772.3,
          "y": 994.5,
          "w": 43.8,
          "h": 15.6,
          "angle": -64.7
        },
        {
          "x": 1173.5,
          "y": 1002.9,
          "w": 44.2,
          "h": 15.9,
          "angle": 69.8
        },
        {
          "x": 801,
          "y": 1006.2,
          "w": 43.8,
          "h": 15.6,
          "angle": -67.8
        },
        {
          "x": 1148.6,
          "y": 1012.1,
          "w": 43.7,
          "h": 15.6,
          "angle": 72.6
        },
        {
          "x": 830,
          "y": 1016,
          "w": 43.6,
          "h": 15.2,
          "angle": -71.6
        },
        {
          "x": 1123.3,
          "y": 1019.8,
          "w": 43.9,
          "h": 15.3,
          "angle": 76
        },
        {
          "x": 860,
          "y": 1024.3,
          "w": 43.8,
          "h": 15.2,
          "angle": -74.1
        },
        {
          "x": 1097.8,
          "y": 1026.2,
          "w": 43.9,
          "h": 15.5,
          "angle": 78.7
        },
        {
          "x": 890.4,
          "y": 1030.8,
          "w": 43.8,
          "h": 15.2,
          "angle": -78.1
        },
        {
          "x": 1072.2,
          "y": 1031.3,
          "w": 44,
          "h": 15.6,
          "angle": 81.9
        },
        {
          "x": 1046.2,
          "y": 1035.2,
          "w": 43.8,
          "h": 15.3,
          "angle": 84.3
        },
        {
          "x": 921.3,
          "y": 1035.4,
          "w": 43.6,
          "h": 15.1,
          "angle": -81.3
        },
        {
          "x": 952.3,
          "y": 1038.2,
          "w": 43.7,
          "h": 15.2,
          "angle": -84.8
        },
        {
          "x": 1014.9,
          "y": 1038.3,
          "w": 43.2,
          "h": 15.2,
          "angle": 88.2
        },
        {
          "x": 983.5,
          "y": 1039.5,
          "w": 43,
          "h": 15,
          "angle": -90
        }
      ]
    },
    "connection_blocks": [
      148,
      222
    ]
  },
  {
    "slug": "double-spiral",
    "top_extract": {
      "blocks": [
        {
          "x": 909,
          "y": 37,
          "w": 18,
          "h": 6,
          "angle": -90
        },
        {
          "x": 924,
          "y": 37,
          "w": 18,
          "h": 6,
          "angle": -90
        },
        {
          "x": 894,
          "y": 37.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 940,
          "y": 37.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 954.6,
          "y": 38,
          "w": 18.4,
          "h": 6.7,
          "angle": -83.7
        },
        {
          "x": 878.7,
          "y": 38.5,
          "w": 17.4,
          "h": 6.7,
          "angle": 85.6
        },
        {
          "x": 969.5,
          "y": 39.5,
          "w": 17,
          "h": 7,
          "angle": -90
        },
        {
          "x": 863.5,
          "y": 40.1,
          "w": 18.2,
          "h": 6.7,
          "angle": 83.7
        },
        {
          "x": 984.6,
          "y": 41,
          "w": 18.2,
          "h": 6.6,
          "angle": -81.9
        },
        {
          "x": 848.3,
          "y": 42.2,
          "w": 18.2,
          "h": 6.8,
          "angle": 81.9
        },
        {
          "x": 999.7,
          "y": 43.2,
          "w": 18.2,
          "h": 6.9,
          "angle": -78.7
        },
        {
          "x": 833.2,
          "y": 44.6,
          "w": 17.9,
          "h": 6.8,
          "angle": 81.3
        },
        {
          "x": 1014.3,
          "y": 45.7,
          "w": 18,
          "h": 6.7,
          "angle": -78.7
        },
        {
          "x": 817.9,
          "y": 47.4,
          "w": 18,
          "h": 6.7,
          "angle": 79.7
        },
        {
          "x": 1028.9,
          "y": 48.9,
          "w": 18.2,
          "h": 6.5,
          "angle": -76
        },
        {
          "x": 802.9,
          "y": 50.8,
          "w": 17.9,
          "h": 6.8,
          "angle": 76
        },
        {
          "x": 1043.5,
          "y": 52.2,
          "w": 18.3,
          "h": 6.6,
          "angle": -74.1
        },
        {
          "x": 788,
          "y": 54.4,
          "w": 18.2,
          "h": 6.5,
          "angle": 76
        },
        {
          "x": 1057.9,
          "y": 56,
          "w": 18.4,
          "h": 6.7,
          "angle": -73.3
        },
        {
          "x": 773,
          "y": 58.9,
          "w": 18.3,
          "h": 6.7,
          "angle": 74.1
        },
        {
          "x": 1072.3,
          "y": 60.6,
          "w": 18,
          "h": 6.6,
          "angle": -71.6
        },
        {
          "x": 758.3,
          "y": 63.4,
          "w": 18,
          "h": 6.6,
          "angle": 71.6
        },
        {
          "x": 1086.3,
          "y": 65.2,
          "w": 18,
          "h": 6.8,
          "angle": -69.4
        },
        {
          "x": 743.6,
          "y": 68.7,
          "w": 18,
          "h": 6.7,
          "angle": 70
        },
        {
          "x": 1100.1,
          "y": 70.3,
          "w": 18.4,
          "h": 6.7,
          "angle": -68.2
        },
        {
          "x": 729.1,
          "y": 74.3,
          "w": 17.8,
          "h": 6.6,
          "angle": 69.4
        },
        {
          "x": 1113.8,
          "y": 75.9,
          "w": 17.9,
          "h": 6.7,
          "angle": -63.4
        },
        {
          "x": 714.8,
          "y": 80.4,
          "w": 18.4,
          "h": 6.7,
          "angle": 68.2
        },
        {
          "x": 1127.4,
          "y": 81.7,
          "w": 17.9,
          "h": 6.7,
          "angle": -63.4
        },
        {
          "x": 700.4,
          "y": 87,
          "w": 18.4,
          "h": 6.7,
          "angle": 66
        },
        {
          "x": 1140.6,
          "y": 88.3,
          "w": 17.9,
          "h": 6.7,
          "angle": -63.4
        },
        {
          "x": 686.4,
          "y": 93.8,
          "w": 17.9,
          "h": 6.3,
          "angle": 63.4
        },
        {
          "x": 1153.8,
          "y": 94.9,
          "w": 17.9,
          "h": 6.7,
          "angle": -63.4
        },
        {
          "x": 672.4,
          "y": 101.3,
          "w": 17.9,
          "h": 6.7,
          "angle": 63.4
        },
        {
          "x": 1166.5,
          "y": 102,
          "w": 18.4,
          "h": 6.7,
          "angle": -59
        },
        {
          "x": 658.9,
          "y": 109.1,
          "w": 18.1,
          "h": 6.7,
          "angle": 60.3
        },
        {
          "x": 1179.2,
          "y": 109.3,
          "w": 18,
          "h": 6.7,
          "angle": -56.3
        },
        {
          "x": 1191.3,
          "y": 117.2,
          "w": 18.3,
          "h": 6.9,
          "angle": -56.3
        },
        {
          "x": 645.3,
          "y": 117.4,
          "w": 18.2,
          "h": 6.7,
          "angle": 59
        },
        {
          "x": 1203.5,
          "y": 125.3,
          "w": 17.8,
          "h": 6.8,
          "angle": -53.1
        },
        {
          "x": 632.3,
          "y": 126,
          "w": 18,
          "h": 6.7,
          "angle": 56.3
        },
        {
          "x": 1215.3,
          "y": 133.9,
          "w": 18.2,
          "h": 6.8,
          "angle": -53.1
        },
        {
          "x": 619.3,
          "y": 135,
          "w": 18,
          "h": 6.8,
          "angle": 55
        },
        {
          "x": 1226.6,
          "y": 142.7,
          "w": 18.1,
          "h": 6.9,
          "angle": -51.3
        },
        {
          "x": 606.6,
          "y": 144.4,
          "w": 18.1,
          "h": 7.1,
          "angle": 54.5
        },
        {
          "x": 911,
          "y": 148.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 923,
          "y": 148.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 934.6,
          "y": 148.5,
          "w": 17.4,
          "h": 6.5,
          "angle": -85.9
        },
        {
          "x": 899,
          "y": 149,
          "w": 18,
          "h": 6,
          "angle": -90
        },
        {
          "x": 887,
          "y": 149.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 946.4,
          "y": 149.5,
          "w": 17.6,
          "h": 6.7,
          "angle": -84.8
        },
        {
          "x": 958.2,
          "y": 150.4,
          "w": 17.6,
          "h": 6.6,
          "angle": -83.7
        },
        {
          "x": 875.2,
          "y": 150.9,
          "w": 18.2,
          "h": 6.8,
          "angle": 83.7
        },
        {
          "x": 969.9,
          "y": 151.4,
          "w": 17.9,
          "h": 6.7,
          "angle": -80.5
        },
        {
          "x": 1237.9,
          "y": 151.9,
          "w": 18.2,
          "h": 6.8,
          "angle": -48.8
        },
        {
          "x": 863.3,
          "y": 152.5,
          "w": 17.8,
          "h": 6.6,
          "angle": 81.9
        },
        {
          "x": 981.5,
          "y": 153.1,
          "w": 18.1,
          "h": 6.6,
          "angle": -80.5
        },
        {
          "x": 594.1,
          "y": 154.5,
          "w": 18,
          "h": 6.7,
          "angle": 51.3
        },
        {
          "x": 851.4,
          "y": 154.5,
          "w": 17.9,
          "h": 6.6,
          "angle": 80.5
        },
        {
          "x": 993,
          "y": 155.1,
          "w": 18.2,
          "h": 6.7,
          "angle": -78.7
        },
        {
          "x": 839.5,
          "y": 156.7,
          "w": 18,
          "h": 6.7,
          "angle": 78.7
        },
        {
          "x": 1004.4,
          "y": 157.5,
          "w": 18.2,
          "h": 6.8,
          "angle": -76
        },
        {
          "x": 827.7,
          "y": 159.4,
          "w": 18.2,
          "h": 6.5,
          "angle": 76
        },
        {
          "x": 1015.9,
          "y": 160.1,
          "w": 18.2,
          "h": 6.5,
          "angle": -76
        },
        {
          "x": 1248.8,
          "y": 161.2,
          "w": 17.7,
          "h": 7.1,
          "angle": -45
        },
        {
          "x": 816,
          "y": 162.4,
          "w": 18.2,
          "h": 6.5,
          "angle": 76
        },
        {
          "x": 1027,
          "y": 163.2,
          "w": 18,
          "h": 6.8,
          "angle": -72.9
        },
        {
          "x": 581.8,
          "y": 164.7,
          "w": 17.9,
          "h": 6.6,
          "angle": 48.4
        },
        {
          "x": 804.3,
          "y": 165.8,
          "w": 17.9,
          "h": 6.8,
          "angle": 73.3
        },
        {
          "x": 1038,
          "y": 166.5,
          "w": 18,
          "h": 6.6,
          "angle": -71.6
        },
        {
          "x": 792.7,
          "y": 169.6,
          "w": 18,
          "h": 6.6,
          "angle": 71.6
        },
        {
          "x": 1048.9,
          "y": 170.2,
          "w": 18.1,
          "h": 6.7,
          "angle": -70
        },
        {
          "x": 1259.5,
          "y": 171,
          "w": 17.7,
          "h": 6.4,
          "angle": -45
        },
        {
          "x": 781.2,
          "y": 173.6,
          "w": 17.8,
          "h": 6.6,
          "angle": 70
        },
        {
          "x": 1059.8,
          "y": 174.1,
          "w": 18.2,
          "h": 6.7,
          "angle": -68.2
        },
        {
          "x": 570,
          "y": 175.5,
          "w": 17.7,
          "h": 6.4,
          "angle": 45
        },
        {
          "x": 769.6,
          "y": 178.1,
          "w": 18.4,
          "h": 6.7,
          "angle": 68.2
        },
        {
          "x": 1070.4,
          "y": 178.5,
          "w": 18.3,
          "h": 6.6,
          "angle": -66.8
        },
        {
          "x": 1269.8,
          "y": 181.2,
          "w": 17.7,
          "h": 7.1,
          "angle": -45
        },
        {
          "x": 758.4,
          "y": 182.8,
          "w": 17.9,
          "h": 6.6,
          "angle": 66.8
        },
        {
          "x": 1080.8,
          "y": 182.9,
          "w": 17.9,
          "h": 6.7,
          "angle": -63.4
        },
        {
          "x": 747.3,
          "y": 188.1,
          "w": 18.3,
          "h": 6.7,
          "angle": 63.4
        },
        {
          "x": 1091.2,
          "y": 188.1,
          "w": 17.9,
          "h": 6.7,
          "angle": -63.4
        },
        {
          "x": 1279.6,
          "y": 191.6,
          "w": 18.3,
          "h": 6.8,
          "angle": -42
        },
        {
          "x": 1101.4,
          "y": 193.2,
          "w": 18.1,
          "h": 6.9,
          "angle": -60.9
        },
        {
          "x": 736.1,
          "y": 193.7,
          "w": 18.3,
          "h": 6.7,
          "angle": 63.4
        },
        {
          "x": 1111.1,
          "y": 198.6,
          "w": 18,
          "h": 6.7,
          "angle": -59
        },
        {
          "x": 725.2,
          "y": 199.4,
          "w": 17.9,
          "h": 6.3,
          "angle": 63.4
        },
        {
          "x": 1289.1,
          "y": 202.2,
          "w": 18.2,
          "h": 6.6,
          "angle": -39.3
        },
        {
          "x": 1120.9,
          "y": 204.4,
          "w": 18,
          "h": 6.8,
          "angle": -58
        },
        {
          "x": 714.6,
          "y": 205.8,
          "w": 18,
          "h": 6.7,
          "angle": 59
        },
        {
          "x": 1130.4,
          "y": 210.4,
          "w": 18,
          "h": 6.7,
          "angle": -56.3
        },
        {
          "x": 703.8,
          "y": 212.3,
          "w": 18,
          "h": 6.7,
          "angle": 56.3
        },
        {
          "x": 1298.5,
          "y": 213.1,
          "w": 18,
          "h": 6.7,
          "angle": -38.7
        },
        {
          "x": 1139.7,
          "y": 216.7,
          "w": 18.2,
          "h": 6.8,
          "angle": -53.1
        },
        {
          "x": 693.5,
          "y": 219.2,
          "w": 18,
          "h": 6.7,
          "angle": 56.3
        },
        {
          "x": 1148.8,
          "y": 223.3,
          "w": 18,
          "h": 6.8,
          "angle": -53.1
        },
        {
          "x": 1307.3,
          "y": 224.3,
          "w": 18.2,
          "h": 6.8,
          "angle": -36.9
        },
        {
          "x": 683.2,
          "y": 226.4,
          "w": 18,
          "h": 6.6,
          "angle": 54.5
        },
        {
          "x": 1157.7,
          "y": 230.1,
          "w": 18.2,
          "h": 6.8,
          "angle": -53.1
        },
        {
          "x": 673.3,
          "y": 233.9,
          "w": 17.8,
          "h": 6.6,
          "angle": 53.1
        },
        {
          "x": 1315.9,
          "y": 235.5,
          "w": 18,
          "h": 6.7,
          "angle": -35.5
        },
        {
          "x": 1166.4,
          "y": 237,
          "w": 17.9,
          "h": 6.8,
          "angle": -50.2
        },
        {
          "x": 663.6,
          "y": 242,
          "w": 18.1,
          "h": 6.6,
          "angle": 51.3
        },
        {
          "x": 1174.7,
          "y": 244.5,
          "w": 18.4,
          "h": 6.9,
          "angle": -48.4
        },
        {
          "x": 1323.9,
          "y": 247.2,
          "w": 18,
          "h": 7.2,
          "angle": -35.5
        },
        {
          "x": 653.7,
          "y": 249.8,
          "w": 17.8,
          "h": 6.7,
          "angle": 50.2
        },
        {
          "x": 1182.5,
          "y": 252,
          "w": 17.7,
          "h": 6.4,
          "angle": -45
        },
        {
          "x": 644.4,
          "y": 258.5,
          "w": 18.4,
          "h": 6.5,
          "angle": 47.7
        },
        {
          "x": 1331.8,
          "y": 258.9,
          "w": 18,
          "h": 6.9,
          "angle": -31
        },
        {
          "x": 909,
          "y": 259.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 920,
          "y": 259.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 932,
          "y": 259.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 1190.8,
          "y": 259.7,
          "w": 18.4,
          "h": 6.4,
          "angle": -45
        },
        {
          "x": 897.5,
          "y": 260.5,
          "w": 17.5,
          "h": 6.6,
          "angle": 84.8
        },
        {
          "x": 943.1,
          "y": 260.5,
          "w": 17.6,
          "h": 6.5,
          "angle": -84.3
        },
        {
          "x": 885.9,
          "y": 261.5,
          "w": 17.5,
          "h": 6.7,
          "angle": 84.3
        },
        {
          "x": 954.3,
          "y": 261.5,
          "w": 17.8,
          "h": 6.6,
          "angle": -81.9
        },
        {
          "x": 965.4,
          "y": 263,
          "w": 18.2,
          "h": 6.7,
          "angle": -80.5
        },
        {
          "x": 874.3,
          "y": 263.1,
          "w": 18.1,
          "h": 6.5,
          "angle": 81.9
        },
        {
          "x": 976.4,
          "y": 265,
          "w": 18.2,
          "h": 6.7,
          "angle": -77
        },
        {
          "x": 862.8,
          "y": 265.4,
          "w": 17.8,
          "h": 6.9,
          "angle": 81.9
        },
        {
          "x": 635.3,
          "y": 267.2,
          "w": 17.7,
          "h": 5.7,
          "angle": 45
        },
        {
          "x": 987.4,
          "y": 267.5,
          "w": 18.2,
          "h": 6.8,
          "angle": -76
        },
        {
          "x": 1198.3,
          "y": 267.8,
          "w": 17.9,
          "h": 6.7,
          "angle": -40.6
        },
        {
          "x": 851.4,
          "y": 268,
          "w": 18.2,
          "h": 6.5,
          "angle": 77.5
        },
        {
          "x": 998.1,
          "y": 270.2,
          "w": 18,
          "h": 6.6,
          "angle": -71.6
        },
        {
          "x": 1339,
          "y": 271,
          "w": 18,
          "h": 6.8,
          "angle": -29.1
        },
        {
          "x": 840.1,
          "y": 271.1,
          "w": 17.7,
          "h": 6.5,
          "angle": 76
        },
        {
          "x": 1008.7,
          "y": 273.6,
          "w": 17.7,
          "h": 6.6,
          "angle": -71.6
        },
        {
          "x": 828.7,
          "y": 274.6,
          "w": 18,
          "h": 6.6,
          "angle": 71.6
        },
        {
          "x": 626.5,
          "y": 276,
          "w": 17.7,
          "h": 6.4,
          "angle": 45
        },
        {
          "x": 1205.6,
          "y": 276,
          "w": 17.8,
          "h": 6.7,
          "angle": -39.8
        },
        {
          "x": 1018.8,
          "y": 277.4,
          "w": 18,
          "h": 6.7,
          "angle": -69.4
        },
        {
          "x": 817.4,
          "y": 278.7,
          "w": 18,
          "h": 6.6,
          "angle": 71.6
        },
        {
          "x": 1028.9,
          "y": 281.4,
          "w": 18,
          "h": 6.6,
          "angle": -66
        },
        {
          "x": 806.4,
          "y": 283.2,
          "w": 17.8,
          "h": 6.7,
          "angle": 70
        },
        {
          "x": 1346.1,
          "y": 283.2,
          "w": 17.9,
          "h": 6.7,
          "angle": -26.6
        },
        {
          "x": 1212.7,
          "y": 284.3,
          "w": 18,
          "h": 6.7,
          "angle": -38.7
        },
        {
          "x": 617.8,
          "y": 285.7,
          "w": 17.8,
          "h": 6.6,
          "angle": 42.3
        },
        {
          "x": 1038.8,
          "y": 285.9,
          "w": 17.9,
          "h": 6.7,
          "angle": -63.4
        },
        {
          "x": 795.6,
          "y": 288.2,
          "w": 17.9,
          "h": 6.3,
          "angle": 63.4
        },
        {
          "x": 1048.4,
          "y": 290.7,
          "w": 17.9,
          "h": 6.7,
          "angle": -63.4
        },
        {
          "x": 1219.5,
          "y": 292.8,
          "w": 17.8,
          "h": 6.6,
          "angle": -36.9
        },
        {
          "x": 784.6,
          "y": 293.7,
          "w": 17.9,
          "h": 6.7,
          "angle": 63.4
        },
        {
          "x": 609.3,
          "y": 295.2,
          "w": 17.9,
          "h": 6.5,
          "angle": 41.6
        },
        {
          "x": 1352.8,
          "y": 295.6,
          "w": 17.9,
          "h": 6.3,
          "angle": -26.6
        },
        {
          "x": 1057.9,
          "y": 295.8,
          "w": 18,
          "h": 6.5,
          "angle": -59
        },
        {
          "x": 774.1,
          "y": 299.5,
          "w": 18,
          "h": 6.5,
          "angle": 60.9
        },
        {
          "x": 1226.2,
          "y": 301.5,
          "w": 18,
          "h": 6.7,
          "angle": -33.7
        },
        {
          "x": 1069.1,
          "y": 302.9,
          "w": 18,
          "h": 6.7,
          "angle": -56.3
        },
        {
          "x": 601.3,
          "y": 305.2,
          "w": 18,
          "h": 6.6,
          "angle": 38.7
        },
        {
          "x": 763.9,
          "y": 306,
          "w": 18,
          "h": 6.7,
          "angle": 59
        },
        {
          "x": 1359.1,
          "y": 308.2,
          "w": 17.9,
          "h": 6.7,
          "angle": -26.6
        },
        {
          "x": 1232.4,
          "y": 310.4,
          "w": 18,
          "h": 6.7,
          "angle": -33.7
        },
        {
          "x": 1080.1,
          "y": 310.5,
          "w": 17.8,
          "h": 6.4,
          "angle": -53.1
        },
        {
          "x": 753.4,
          "y": 312.7,
          "w": 17.7,
          "h": 6.6,
          "angle": 58
        },
        {
          "x": 593.3,
          "y": 315.4,
          "w": 17.8,
          "h": 6.6,
          "angle": 36.9
        },
        {
          "x": 1090.5,
          "y": 318.5,
          "w": 17.2,
          "h": 6.6,
          "angle": -49.4
        },
        {
          "x": 1238.3,
          "y": 319.4,
          "w": 18.2,
          "h": 6.9,
          "angle": -31
        },
        {
          "x": 743.6,
          "y": 320,
          "w": 18,
          "h": 6.6,
          "angle": 53.1
        },
        {
          "x": 1364.8,
          "y": 320.9,
          "w": 18,
          "h": 6.7,
          "angle": -21.8
        },
        {
          "x": 585.9,
          "y": 325.8,
          "w": 18,
          "h": 6.6,
          "angle": 36.9
        },
        {
          "x": 1100.5,
          "y": 327,
          "w": 17.7,
          "h": 6.4,
          "angle": -45
        },
        {
          "x": 733.8,
          "y": 327.6,
          "w": 18,
          "h": 6.5,
          "angle": 52.1
        },
        {
          "x": 1243.9,
          "y": 328.7,
          "w": 18,
          "h": 6.8,
          "angle": -29.7
        },
        {
          "x": 1370.4,
          "y": 333.7,
          "w": 18.1,
          "h": 6.7,
          "angle": -20.6
        },
        {
          "x": 1110,
          "y": 335.5,
          "w": 17.7,
          "h": 6.4,
          "angle": -45
        },
        {
          "x": 724.6,
          "y": 335.9,
          "w": 17.9,
          "h": 6.5,
          "angle": 49.4
        },
        {
          "x": 578.6,
          "y": 336.6,
          "w": 17.8,
          "h": 6.6,
          "angle": 35
        },
        {
          "x": 1249.4,
          "y": 337.9,
          "w": 17.9,
          "h": 6.6,
          "angle": -28.3
        },
        {
          "x": 715.2,
          "y": 344.2,
          "w": 17.7,
          "h": 5.7,
          "angle": 45
        },
        {
          "x": 1118.8,
          "y": 345.3,
          "w": 17.8,
          "h": 6.6,
          "angle": -41.2
        },
        {
          "x": 1375.4,
          "y": 346.5,
          "w": 18,
          "h": 7,
          "angle": -18.4
        },
        {
          "x": 571.7,
          "y": 347.5,
          "w": 18.3,
          "h": 6.7,
          "angle": 33.7
        },
        {
          "x": 1254.3,
          "y": 347.6,
          "w": 17.9,
          "h": 6.7,
          "angle": -26.6
        },
        {
          "x": 706.5,
          "y": 353,
          "w": 17.7,
          "h": 6.4,
          "angle": 45
        },
        {
          "x": 1127.2,
          "y": 354.8,
          "w": 18.2,
          "h": 6.7,
          "angle": -37.9
        },
        {
          "x": 1259,
          "y": 357.1,
          "w": 17.9,
          "h": 6.7,
          "angle": -24
        },
        {
          "x": 565.2,
          "y": 358.7,
          "w": 18.2,
          "h": 6.5,
          "angle": 31
        },
        {
          "x": 1380.1,
          "y": 359.8,
          "w": 18,
          "h": 6.9,
          "angle": -16.7
        },
        {
          "x": 698,
          "y": 362.5,
          "w": 17.7,
          "h": 6.4,
          "angle": 45
        },
        {
          "x": 1135.1,
          "y": 364.9,
          "w": 18,
          "h": 6.9,
          "angle": -35.5
        },
        {
          "x": 1263.5,
          "y": 366.7,
          "w": 18.2,
          "h": 6.9,
          "angle": -21.8
        },
        {
          "x": 914.5,
          "y": 369.5,
          "w": 17,
          "h": 5,
          "angle": -90
        },
        {
          "x": 925,
          "y": 369.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 558.9,
          "y": 370.2,
          "w": 17.9,
          "h": 6.7,
          "angle": 26.6
        },
        {
          "x": 904,
          "y": 370.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 937.6,
          "y": 370.5,
          "w": 17.8,
          "h": 6.5,
          "angle": -81.9
        },
        {
          "x": 892.9,
          "y": 372,
          "w": 18.1,
          "h": 6.6,
          "angle": 81.9
        },
        {
          "x": 949.7,
          "y": 372.2,
          "w": 17.8,
          "h": 6.5,
          "angle": -78.7
        },
        {
          "x": 690.1,
          "y": 372.4,
          "w": 17.8,
          "h": 6.7,
          "angle": 41.2
        },
        {
          "x": 1384.5,
          "y": 372.9,
          "w": 18,
          "h": 6.9,
          "angle": -15.9
        },
        {
          "x": 882,
          "y": 374.1,
          "w": 18.2,
          "h": 6.4,
          "angle": 79.7
        },
        {
          "x": 961.4,
          "y": 374.6,
          "w": 18,
          "h": 6.4,
          "angle": -74.7
        },
        {
          "x": 1142.3,
          "y": 375.2,
          "w": 18,
          "h": 6.5,
          "angle": -32.5
        },
        {
          "x": 871.1,
          "y": 377.1,
          "w": 18.2,
          "h": 6.5,
          "angle": 76
        },
        {
          "x": 972.8,
          "y": 377.7,
          "w": 18.1,
          "h": 6.6,
          "angle": -70
        },
        {
          "x": 1269,
          "y": 379.9,
          "w": 17.8,
          "h": 6.6,
          "angle": -20.6
        },
        {
          "x": 860.4,
          "y": 380.7,
          "w": 18,
          "h": 6.6,
          "angle": 71.6
        },
        {
          "x": 553.1,
          "y": 381.8,
          "w": 17.9,
          "h": 6.7,
          "angle": 26.6
        },
        {
          "x": 983.7,
          "y": 381.9,
          "w": 17.9,
          "h": 6.7,
          "angle": -66.8
        },
        {
          "x": 682.1,
          "y": 382.3,
          "w": 18.2,
          "h": 6.4,
          "angle": 36.9
        },
        {
          "x": 849.8,
          "y": 385,
          "w": 18.4,
          "h": 6.4,
          "angle": 69.4
        },
        {
          "x": 1148.9,
          "y": 385.8,
          "w": 17.9,
          "h": 6.7,
          "angle": -26.6
        },
        {
          "x": 1388.3,
          "y": 386.2,
          "w": 17.9,
          "h": 6.8,
          "angle": -14
        },
        {
          "x": 994.2,
          "y": 386.6,
          "w": 17.9,
          "h": 6.3,
          "angle": -63.4
        },
        {
          "x": 839.4,
          "y": 389.8,
          "w": 17.9,
          "h": 6.3,
          "angle": 63.4
        },
        {
          "x": 1004.2,
          "y": 392,
          "w": 18,
          "h": 6.6,
          "angle": -57.5
        },
        {
          "x": 674.9,
          "y": 392.8,
          "w": 18,
          "h": 6.5,
          "angle": 35.5
        },
        {
          "x": 1273.9,
          "y": 393.2,
          "w": 18,
          "h": 6.6,
          "angle": -18.4
        },
        {
          "x": 547.5,
          "y": 393.4,
          "w": 18.3,
          "h": 6.7,
          "angle": 23.2
        },
        {
          "x": 829,
          "y": 395.5,
          "w": 18,
          "h": 6.6,
          "angle": 60.9
        },
        {
          "x": 1154.9,
          "y": 396.8,
          "w": 17.9,
          "h": 6.7,
          "angle": -26.6
        },
        {
          "x": 1013.4,
          "y": 398.1,
          "w": 18,
          "h": 6.4,
          "angle": -53.1
        },
        {
          "x": 1391.6,
          "y": 399.6,
          "w": 17.9,
          "h": 6.8,
          "angle": -12.5
        },
        {
          "x": 819,
          "y": 401.8,
          "w": 18,
          "h": 6.4,
          "angle": 56.3
        },
        {
          "x": 667.8,
          "y": 403.5,
          "w": 18,
          "h": 6.7,
          "angle": 33.7
        },
        {
          "x": 1022.3,
          "y": 404.7,
          "w": 17.9,
          "h": 6.6,
          "angle": -48.4
        },
        {
          "x": 542.1,
          "y": 405.4,
          "w": 18.4,
          "h": 6.6,
          "angle": 24
        },
        {
          "x": 1278.4,
          "y": 406.5,
          "w": 18,
          "h": 6.7,
          "angle": -15.9
        },
        {
          "x": 1160.4,
          "y": 407.8,
          "w": 18,
          "h": 6.7,
          "angle": -21.8
        },
        {
          "x": 809.4,
          "y": 408.9,
          "w": 18,
          "h": 6.4,
          "angle": 53.1
        },
        {
          "x": 1030.5,
          "y": 412,
          "w": 17.7,
          "h": 6.4,
          "angle": -45
        },
        {
          "x": 1394.6,
          "y": 413.1,
          "w": 17.9,
          "h": 6.9,
          "angle": -9.5
        },
        {
          "x": 661.4,
          "y": 414.5,
          "w": 18,
          "h": 6.7,
          "angle": 31
        },
        {
          "x": 800.1,
          "y": 416.5,
          "w": 17.8,
          "h": 6.5,
          "angle": 50.7
        },
        {
          "x": 537.3,
          "y": 417.5,
          "w": 18,
          "h": 6.7,
          "angle": 20.6
        },
        {
          "x": 1165.4,
          "y": 419.2,
          "w": 17.8,
          "h": 6.7,
          "angle": -20.6
        },
        {
          "x": 1282,
          "y": 419.9,
          "w": 17.9,
          "h": 6.5,
          "angle": -14
        },
        {
          "x": 1038.9,
          "y": 420.4,
          "w": 17.9,
          "h": 6.5,
          "angle": -40.6
        },
        {
          "x": 791.3,
          "y": 424.8,
          "w": 17,
          "h": 6.4,
          "angle": 45
        },
        {
          "x": 655,
          "y": 425.9,
          "w": 18.1,
          "h": 6.6,
          "angle": 29.1
        },
        {
          "x": 1397.5,
          "y": 426.4,
          "w": 17.8,
          "h": 6.6,
          "angle": -8.1
        },
        {
          "x": 1046.3,
          "y": 429.8,
          "w": 18,
          "h": 6.7,
          "angle": -33.7
        },
        {
          "x": 532.8,
          "y": 429.9,
          "w": 18.1,
          "h": 6.6,
          "angle": 20.6
        },
        {
          "x": 1169.5,
          "y": 430.5,
          "w": 17.7,
          "h": 6.6,
          "angle": -16.7
        },
        {
          "x": 1285.4,
          "y": 433.6,
          "w": 17.9,
          "h": 6.6,
          "angle": -9.5
        },
        {
          "x": 782.5,
          "y": 434,
          "w": 17.7,
          "h": 6.4,
          "angle": 45
        },
        {
          "x": 649.4,
          "y": 437.7,
          "w": 17.4,
          "h": 6.3,
          "angle": 26.6
        },
        {
          "x": 1053.1,
          "y": 439.3,
          "w": 18,
          "h": 6.5,
          "angle": -29.1
        },
        {
          "x": 1399.6,
          "y": 440,
          "w": 17.7,
          "h": 6.8,
          "angle": -7.1
        },
        {
          "x": 1173.3,
          "y": 442.1,
          "w": 17.9,
          "h": 6.5,
          "angle": -14
        },
        {
          "x": 528.4,
          "y": 442.5,
          "w": 18,
          "h": 6.6,
          "angle": 16.7
        },
        {
          "x": 774.8,
          "y": 443.5,
          "w": 17.8,
          "h": 6.4,
          "angle": 39.8
        },
        {
          "x": 1288,
          "y": 447.2,
          "w": 18.2,
          "h": 6.6,
          "angle": -8.1
        },
        {
          "x": 1058.7,
          "y": 449.4,
          "w": 17.9,
          "h": 6.7,
          "angle": -26.6
        },
        {
          "x": 644.2,
          "y": 449.6,
          "w": 18,
          "h": 6.7,
          "angle": 24.4
        },
        {
          "x": 1401.5,
          "y": 453.5,
          "w": 17,
          "h": 7,
          "angle": 0
        },
        {
          "x": 767.1,
          "y": 453.6,
          "w": 17.8,
          "h": 6.6,
          "angle": 37.9
        },
        {
          "x": 1176.2,
          "y": 453.8,
          "w": 17.9,
          "h": 6.8,
          "angle": -12.5
        },
        {
          "x": 524.8,
          "y": 455.1,
          "w": 18,
          "h": 6.6,
          "angle": 18.4
        },
        {
          "x": 1063.4,
          "y": 459.6,
          "w": 18.1,
          "h": 6.7,
          "angle": -19.7
        },
        {
          "x": 1290.4,
          "y": 460.7,
          "w": 17.4,
          "h": 6.4,
          "angle": -6.3
        },
        {
          "x": 639.3,
          "y": 461.8,
          "w": 18.2,
          "h": 6.5,
          "angle": 21.8
        },
        {
          "x": 760.4,
          "y": 464.2,
          "w": 18,
          "h": 6.4,
          "angle": 32
        },
        {
          "x": 1178.5,
          "y": 465.4,
          "w": 17.8,
          "h": 6.5,
          "angle": -8.1
        },
        {
          "x": 1402.5,
          "y": 467,
          "w": 17,
          "h": 6,
          "angle": 0
        },
        {
          "x": 521.3,
          "y": 467.7,
          "w": 17.9,
          "h": 6.5,
          "angle": 14
        },
        {
          "x": 1067.2,
          "y": 469.9,
          "w": 18,
          "h": 6.5,
          "angle": -15.9
        },
        {
          "x": 755.2,
          "y": 473.6,
          "w": 17.9,
          "h": 6.3,
          "angle": 26.6
        },
        {
          "x": 635.1,
          "y": 474.4,
          "w": 18,
          "h": 6.3,
          "angle": 18.4
        },
        {
          "x": 1291.5,
          "y": 474.6,
          "w": 17.3,
          "h": 6.4,
          "angle": -4.4
        },
        {
          "x": 922.3,
          "y": 476.5,
          "w": 17.4,
          "h": 6.5,
          "angle": -86.2
        },
        {
          "x": 933.3,
          "y": 476.7,
          "w": 17.7,
          "h": 6.3,
          "angle": -76
        },
        {
          "x": 1180.5,
          "y": 477,
          "w": 17.6,
          "h": 6.7,
          "angle": -5.7
        },
        {
          "x": 911.7,
          "y": 477.4,
          "w": 17.5,
          "h": 6.4,
          "angle": 84.8
        },
        {
          "x": 944.2,
          "y": 479.6,
          "w": 17.9,
          "h": 6.3,
          "angle": -63.4
        },
        {
          "x": 900.7,
          "y": 480.2,
          "w": 17.7,
          "h": 6.5,
          "angle": 76
        },
        {
          "x": 1070,
          "y": 480.3,
          "w": 17.9,
          "h": 6.6,
          "angle": -9.5
        },
        {
          "x": 518.3,
          "y": 480.8,
          "w": 17.9,
          "h": 6.3,
          "angle": 14
        },
        {
          "x": 1403.5,
          "y": 480.8,
          "w": 17.4,
          "h": 6.8,
          "angle": -4.1
        },
        {
          "x": 750.2,
          "y": 483.1,
          "w": 17.4,
          "h": 6.3,
          "angle": 26.6
        },
        {
          "x": 954.4,
          "y": 484,
          "w": 18,
          "h": 6.6,
          "angle": -53.1
        },
        {
          "x": 890.6,
          "y": 484.3,
          "w": 17.8,
          "h": 6.5,
          "angle": 68.2
        },
        {
          "x": 631.3,
          "y": 486.8,
          "w": 18,
          "h": 6.4,
          "angle": 16.7
        },
        {
          "x": 1292.5,
          "y": 488,
          "w": 17,
          "h": 6,
          "angle": 0
        },
        {
          "x": 1181.5,
          "y": 489,
          "w": 17,
          "h": 6,
          "angle": 0
        },
        {
          "x": 880.8,
          "y": 490.3,
          "w": 18,
          "h": 6.5,
          "angle": 59
        },
        {
          "x": 963.1,
          "y": 490.6,
          "w": 17.9,
          "h": 6.4,
          "angle": -39.8
        },
        {
          "x": 1072,
          "y": 492,
          "w": 18,
          "h": 6,
          "angle": 0
        },
        {
          "x": 745.9,
          "y": 493.2,
          "w": 17.9,
          "h": 6.6,
          "angle": 23.2
        },
        {
          "x": 515.5,
          "y": 494,
          "w": 17.8,
          "h": 6.6,
          "angle": 10.3
        },
        {
          "x": 1404,
          "y": 494,
          "w": 18,
          "h": 6,
          "angle": 0
        },
        {
          "x": 872.3,
          "y": 497,
          "w": 18,
          "h": 6.4,
          "angle": 53.1
        },
        {
          "x": 970.1,
          "y": 498.7,
          "w": 18.3,
          "h": 6.7,
          "angle": -26.6
        },
        {
          "x": 628,
          "y": 499.6,
          "w": 18.2,
          "h": 6.5,
          "angle": 14
        },
        {
          "x": 1182,
          "y": 500.5,
          "w": 18,
          "h": 5,
          "angle": 0
        },
        {
          "x": 1293,
          "y": 502,
          "w": 18,
          "h": 6,
          "angle": 0
        },
        {
          "x": 742,
          "y": 503.5,
          "w": 18.1,
          "h": 6.6,
          "angle": 20.6
        },
        {
          "x": 1073,
          "y": 504,
          "w": 18,
          "h": 6,
          "angle": 0
        },
        {
          "x": 864.5,
          "y": 505,
          "w": 17.7,
          "h": 6.4,
          "angle": 45
        },
        {
          "x": 513.3,
          "y": 507.1,
          "w": 17.8,
          "h": 6.6,
          "angle": 9.5
        },
        {
          "x": 1404.5,
          "y": 508,
          "w": 17,
          "h": 6,
          "angle": 0
        },
        {
          "x": 974.5,
          "y": 508.5,
          "w": 17.7,
          "h": 6.6,
          "angle": -6.3
        },
        {
          "x": 1182,
          "y": 512,
          "w": 18,
          "h": 6,
          "angle": 0
        },
        {
          "x": 625.3,
          "y": 512.7,
          "w": 17.7,
          "h": 6.7,
          "angle": 11.3
        },
        {
          "x": 738.7,
          "y": 513.9,
          "w": 17.7,
          "h": 6.5,
          "angle": 17.1
        },
        {
          "x": 857.2,
          "y": 514.4,
          "w": 18,
          "h": 6.4,
          "angle": 36.9
        },
        {
          "x": 1072.6,
          "y": 515,
          "w": 17.7,
          "h": 6.5,
          "angle": 6.3
        },
        {
          "x": 1292.5,
          "y": 515.6,
          "w": 17.4,
          "h": 6.4,
          "angle": 4.4
        },
        {
          "x": 975.5,
          "y": 519,
          "w": 17.9,
          "h": 6.5,
          "angle": 0
        },
        {
          "x": 511.5,
          "y": 520.2,
          "w": 17.8,
          "h": 6.6,
          "angle": 9.5
        },
        {
          "x": 1404,
          "y": 521,
          "w": 18,
          "h": 6,
          "angle": 0
        },
        {
          "x": 1181.5,
          "y": 523.5,
          "w": 17,
          "h": 7,
          "angle": 0
        },
        {
          "x": 851.4,
          "y": 523.8,
          "w": 17.7,
          "h": 6.7,
          "angle": 31
        },
        {
          "x": 735.8,
          "y": 524.8,
          "w": 17.9,
          "h": 6.5,
          "angle": 14
        },
        {
          "x": 622.7,
          "y": 525.9,
          "w": 17.8,
          "h": 6.4,
          "angle": 9.5
        },
        {
          "x": 1071.3,
          "y": 526.1,
          "w": 17.8,
          "h": 6.7,
          "angle": 11.3
        },
        {
          "x": 1292.5,
          "y": 529,
          "w": 17,
          "h": 6,
          "angle": 0
        },
        {
          "x": 973,
          "y": 529.5,
          "w": 17.9,
          "h": 6.5,
          "angle": 45
        },
        {
          "x": 509.5,
          "y": 533.6,
          "w": 17.6,
          "h": 6.5,
          "angle": 6.3
        },
        {
          "x": 846.9,
          "y": 534.1,
          "w": 17.8,
          "h": 6.6,
          "angle": 24
        },
        {
          "x": 1403.5,
          "y": 534.7,
          "w": 17.5,
          "h": 6.7,
          "angle": 4.8
        },
        {
          "x": 1180.4,
          "y": 534.9,
          "w": 17.9,
          "h": 6.6,
          "angle": 9.5
        },
        {
          "x": 733.4,
          "y": 535.8,
          "w": 18,
          "h": 6.5,
          "angle": 11.3
        },
        {
          "x": 965,
          "y": 536.5,
          "w": 18,
          "h": 6.6,
          "angle": 53.1
        },
        {
          "x": 1069,
          "y": 536.5,
          "w": 18,
          "h": 6.6,
          "angle": 18.4
        },
        {
          "x": 621.4,
          "y": 539.3,
          "w": 17.4,
          "h": 6.5,
          "angle": 6.3
        },
        {
          "x": 955.8,
          "y": 541.1,
          "w": 17.9,
          "h": 6.6,
          "angle": 66.8
        },
        {
          "x": 1290.9,
          "y": 542.5,
          "w": 18.1,
          "h": 6.4,
          "angle": 7.1
        },
        {
          "x": 843.1,
          "y": 545.3,
          "w": 18,
          "h": 6.3,
          "angle": 18.4
        },
        {
          "x": 947.3,
          "y": 545.6,
          "w": 17.4,
          "h": 6.3,
          "angle": 63.4
        },
        {
          "x": 1178.5,
          "y": 545.9,
          "w": 18.2,
          "h": 6.7,
          "angle": 11.3
        },
        {
          "x": 731.6,
          "y": 546.9,
          "w": 17.9,
          "h": 6.6,
          "angle": 9.5
        },
        {
          "x": 508.5,
          "y": 547,
          "w": 17,
          "h": 6,
          "angle": 0
        },
        {
          "x": 1065.2,
          "y": 547.6,
          "w": 17.9,
          "h": 6.3,
          "angle": 26.6
        },
        {
          "x": 1402.1,
          "y": 548.2,
          "w": 18.2,
          "h": 6.7,
          "angle": 5.7
        },
        {
          "x": 938.7,
          "y": 552,
          "w": 17.9,
          "h": 6.5,
          "angle": 38.7
        },
        {
          "x": 619.5,
          "y": 552.7,
          "w": 17.5,
          "h": 6.5,
          "angle": 5.2
        },
        {
          "x": 840.8,
          "y": 555.8,
          "w": 17.9,
          "h": 6.6,
          "angle": 12.5
        },
        {
          "x": 1289.4,
          "y": 555.9,
          "w": 17.8,
          "h": 6.6,
          "angle": 9.5
        },
        {
          "x": 1176.3,
          "y": 556.9,
          "w": 17.9,
          "h": 6.5,
          "angle": 14
        },
        {
          "x": 1060.5,
          "y": 557.9,
          "w": 18,
          "h": 6.5,
          "angle": 31
        },
        {
          "x": 730.5,
          "y": 558.3,
          "w": 17.7,
          "h": 6.6,
          "angle": 7.1
        },
        {
          "x": 508.1,
          "y": 560.5,
          "w": 18.2,
          "h": 6.5,
          "angle": 5.2
        },
        {
          "x": 1400.6,
          "y": 561.4,
          "w": 17.7,
          "h": 6.6,
          "angle": 8.1
        },
        {
          "x": 936,
          "y": 562.5,
          "w": 17.9,
          "h": 6.5,
          "angle": 0
        },
        {
          "x": 619.5,
          "y": 566,
          "w": 17,
          "h": 6,
          "angle": 0
        },
        {
          "x": 839.5,
          "y": 566.8,
          "w": 17.7,
          "h": 6.4,
          "angle": 7.1
        },
        {
          "x": 1054.9,
          "y": 567.5,
          "w": 18,
          "h": 6.7,
          "angle": 38.7
        },
        {
          "x": 1173.3,
          "y": 567.6,
          "w": 18,
          "h": 6.6,
          "angle": 18.4
        },
        {
          "x": 1286.9,
          "y": 569.1,
          "w": 18.2,
          "h": 6.5,
          "angle": 14
        },
        {
          "x": 730,
          "y": 570,
          "w": 18,
          "h": 6,
          "angle": 0
        },
        {
          "x": 937.5,
          "y": 573.4,
          "w": 17.6,
          "h": 6.4,
          "angle": -6.3
        },
        {
          "x": 507.5,
          "y": 574,
          "w": 17,
          "h": 6,
          "angle": 0
        },
        {
          "x": 1398.6,
          "y": 574.7,
          "w": 17.9,
          "h": 6.7,
          "angle": 9.5
        },
        {
          "x": 1047.8,
          "y": 576.8,
          "w": 17.7,
          "h": 5.7,
          "angle": 45
        },
        {
          "x": 839.5,
          "y": 578,
          "w": 17,
          "h": 6,
          "angle": 0
        },
        {
          "x": 1170.1,
          "y": 578.3,
          "w": 18.1,
          "h": 6.6,
          "angle": 20.6
        },
        {
          "x": 619,
          "y": 580,
          "w": 18,
          "h": 6,
          "angle": 0
        },
        {
          "x": 730,
          "y": 581,
          "w": 18,
          "h": 6,
          "angle": 0
        },
        {
          "x": 1284.1,
          "y": 582,
          "w": 18.2,
          "h": 6.7,
          "angle": 15.3
        },
        {
          "x": 942,
          "y": 583.1,
          "w": 17.9,
          "h": 6.5,
          "angle": -24
        },
        {
          "x": 1039.8,
          "y": 584.7,
          "w": 18,
          "h": 6.6,
          "angle": 52.1
        },
        {
          "x": 508,
          "y": 587.5,
          "w": 18,
          "h": 5,
          "angle": 0
        },
        {
          "x": 1396.5,
          "y": 587.9,
          "w": 18.2,
          "h": 6.7,
          "angle": 11.3
        },
        {
          "x": 1166.3,
          "y": 588.5,
          "w": 18,
          "h": 6.7,
          "angle": 21.8
        },
        {
          "x": 840,
          "y": 589.6,
          "w": 18.1,
          "h": 6.5,
          "angle": -4.4
        },
        {
          "x": 948.8,
          "y": 591.4,
          "w": 17.9,
          "h": 6.5,
          "angle": -39.8
        },
        {
          "x": 1031.2,
          "y": 591.4,
          "w": 18,
          "h": 6.5,
          "angle": 59
        },
        {
          "x": 730.5,
          "y": 593,
          "w": 17,
          "h": 6,
          "angle": 0
        },
        {
          "x": 619.5,
          "y": 593.5,
          "w": 17,
          "h": 5,
          "angle": 0
        },
        {
          "x": 1280.8,
          "y": 594.9,
          "w": 18,
          "h": 6.8,
          "angle": 16.7
        },
        {
          "x": 1021.4,
          "y": 597.3,
          "w": 18,
          "h": 6.5,
          "angle": 68.2
        },
        {
          "x": 957.6,
          "y": 597.8,
          "w": 17.8,
          "h": 6.4,
          "angle": -53.1
        },
        {
          "x": 1161.8,
          "y": 598.4,
          "w": 17.9,
          "h": 6.3,
          "angle": 26.6
        },
        {
          "x": 508.5,
          "y": 601,
          "w": 17,
          "h": 6,
          "angle": 0
        },
        {
          "x": 1393.9,
          "y": 601,
          "w": 18.2,
          "h": 6.8,
          "angle": 14
        },
        {
          "x": 842.1,
          "y": 601.4,
          "w": 18.1,
          "h": 6.4,
          "angle": -9.5
        },
        {
          "x": 1011.3,
          "y": 601.6,
          "w": 18.2,
          "h": 6.5,
          "angle": 76
        },
        {
          "x": 967.8,
          "y": 602.4,
          "w": 17.9,
          "h": 6.3,
          "angle": -63.4
        },
        {
          "x": 1000.4,
          "y": 604.5,
          "w": 17.6,
          "h": 6.6,
          "angle": 83.7
        },
        {
          "x": 731.6,
          "y": 604.7,
          "w": 17.5,
          "h": 6.5,
          "angle": -5.7
        },
        {
          "x": 978.6,
          "y": 604.7,
          "w": 17.7,
          "h": 6.5,
          "angle": -77.5
        },
        {
          "x": 990,
          "y": 605.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 620.5,
          "y": 607,
          "w": 17,
          "h": 6,
          "angle": 0
        },
        {
          "x": 1277,
          "y": 607.5,
          "w": 18,
          "h": 6.6,
          "angle": 18.4
        },
        {
          "x": 1157,
          "y": 608.1,
          "w": 18.1,
          "h": 6.6,
          "angle": 29.1
        },
        {
          "x": 844.9,
          "y": 611.9,
          "w": 17.7,
          "h": 6.5,
          "angle": -15.3
        },
        {
          "x": 1390.8,
          "y": 613.7,
          "w": 17.9,
          "h": 6.8,
          "angle": 14
        },
        {
          "x": 509.5,
          "y": 614.7,
          "w": 17.4,
          "h": 6.6,
          "angle": -4.8
        },
        {
          "x": 733.5,
          "y": 616.4,
          "w": 17.8,
          "h": 6.5,
          "angle": -8.1
        },
        {
          "x": 1151.8,
          "y": 617.5,
          "w": 18,
          "h": 6.6,
          "angle": 32
        },
        {
          "x": 1272.6,
          "y": 620,
          "w": 17.8,
          "h": 6.7,
          "angle": 21.8
        },
        {
          "x": 622,
          "y": 620.9,
          "w": 18.2,
          "h": 6.5,
          "angle": -6.3
        },
        {
          "x": 848.7,
          "y": 622.1,
          "w": 17.7,
          "h": 6.3,
          "angle": -18.4
        },
        {
          "x": 1387.5,
          "y": 626.7,
          "w": 18.3,
          "h": 6.6,
          "angle": 18.4
        },
        {
          "x": 735.7,
          "y": 628.1,
          "w": 17.8,
          "h": 6.5,
          "angle": -10.3
        },
        {
          "x": 510.9,
          "y": 628.2,
          "w": 18.2,
          "h": 6.5,
          "angle": -5.2
        },
        {
          "x": 1145,
          "y": 628.2,
          "w": 17.8,
          "h": 6.4,
          "angle": 36.9
        },
        {
          "x": 1267.9,
          "y": 632.2,
          "w": 17.9,
          "h": 6.7,
          "angle": 23.2
        },
        {
          "x": 853.2,
          "y": 632.4,
          "w": 17.9,
          "h": 6.3,
          "angle": -26.6
        },
        {
          "x": 624.1,
          "y": 634.6,
          "w": 18.1,
          "h": 6.5,
          "angle": -8.1
        },
        {
          "x": 1137.3,
          "y": 638.2,
          "w": 17.9,
          "h": 6.4,
          "angle": 39.8
        },
        {
          "x": 1383.6,
          "y": 639.4,
          "w": 17.7,
          "h": 6.6,
          "angle": 18.4
        },
        {
          "x": 738.9,
          "y": 639.6,
          "w": 17.9,
          "h": 6.5,
          "angle": -14
        },
        {
          "x": 512.5,
          "y": 641.7,
          "w": 17.7,
          "h": 6.5,
          "angle": -6.3
        },
        {
          "x": 859,
          "y": 642.4,
          "w": 17.7,
          "h": 6.5,
          "angle": -31
        },
        {
          "x": 1262.5,
          "y": 644.1,
          "w": 17.9,
          "h": 6.6,
          "angle": 23.2
        },
        {
          "x": 1129.5,
          "y": 648,
          "w": 17.7,
          "h": 6.4,
          "angle": 45
        },
        {
          "x": 626.6,
          "y": 648.2,
          "w": 17.9,
          "h": 6.6,
          "angle": -9.5
        },
        {
          "x": 742.5,
          "y": 651.4,
          "w": 18.3,
          "h": 6.3,
          "angle": -16.7
        },
        {
          "x": 1379.5,
          "y": 651.9,
          "w": 18,
          "h": 6.7,
          "angle": 20.6
        },
        {
          "x": 865.7,
          "y": 652,
          "w": 17.8,
          "h": 6.4,
          "angle": -33.7
        },
        {
          "x": 514.6,
          "y": 655.3,
          "w": 17.9,
          "h": 6.5,
          "angle": -8.7
        },
        {
          "x": 1257.1,
          "y": 655.8,
          "w": 17.9,
          "h": 6.7,
          "angle": 26.6
        },
        {
          "x": 1121,
          "y": 657,
          "w": 17,
          "h": 5.7,
          "angle": 45
        },
        {
          "x": 873.2,
          "y": 661.2,
          "w": 18.2,
          "h": 6.4,
          "angle": -39.3
        },
        {
          "x": 630,
          "y": 661.9,
          "w": 17.9,
          "h": 6.5,
          "angle": -14
        },
        {
          "x": 746.7,
          "y": 662.7,
          "w": 18,
          "h": 6.6,
          "angle": -20
        },
        {
          "x": 1374.8,
          "y": 664.1,
          "w": 18,
          "h": 6.7,
          "angle": 21.8
        },
        {
          "x": 1112.1,
          "y": 665.3,
          "w": 17.8,
          "h": 6.4,
          "angle": 50.2
        },
        {
          "x": 1250.9,
          "y": 667.2,
          "w": 18.2,
          "h": 6.7,
          "angle": 31
        },
        {
          "x": 517.5,
          "y": 668.8,
          "w": 17.8,
          "h": 6.6,
          "angle": -10.3
        },
        {
          "x": 881.5,
          "y": 670,
          "w": 17.7,
          "h": 6.4,
          "angle": -45
        },
        {
          "x": 1102.7,
          "y": 672.9,
          "w": 18.3,
          "h": 6.6,
          "angle": 54.5
        },
        {
          "x": 751.5,
          "y": 673.9,
          "w": 17.9,
          "h": 6.5,
          "angle": -24
        },
        {
          "x": 633.9,
          "y": 675.3,
          "w": 18,
          "h": 6.5,
          "angle": -15.9
        },
        {
          "x": 1369.9,
          "y": 676.3,
          "w": 17.9,
          "h": 6.6,
          "angle": 24
        },
        {
          "x": 889.8,
          "y": 677.3,
          "w": 17.9,
          "h": 6.6,
          "angle": -48.8
        },
        {
          "x": 1244.3,
          "y": 678.2,
          "w": 18,
          "h": 6.7,
          "angle": 33.7
        },
        {
          "x": 1093,
          "y": 679.9,
          "w": 18,
          "h": 6.5,
          "angle": 59
        },
        {
          "x": 520.4,
          "y": 682.1,
          "w": 18,
          "h": 6.7,
          "angle": -11.3
        },
        {
          "x": 898.6,
          "y": 683.6,
          "w": 18.2,
          "h": 6.4,
          "angle": -53.1
        },
        {
          "x": 757,
          "y": 685,
          "w": 17.9,
          "h": 6.3,
          "angle": -26.6
        },
        {
          "x": 1083.1,
          "y": 686.2,
          "w": 17.6,
          "h": 6.6,
          "angle": 61.4
        },
        {
          "x": 1364.8,
          "y": 688.3,
          "w": 17.9,
          "h": 6.9,
          "angle": 24.4
        },
        {
          "x": 638.1,
          "y": 688.7,
          "w": 18,
          "h": 6.3,
          "angle": -18.4
        },
        {
          "x": 1237.1,
          "y": 689.1,
          "w": 18,
          "h": 6.7,
          "angle": 33.7
        },
        {
          "x": 908,
          "y": 689.7,
          "w": 17.7,
          "h": 6.6,
          "angle": -58
        },
        {
          "x": 1072.8,
          "y": 691.9,
          "w": 17.5,
          "h": 6.5,
          "angle": 65.6
        },
        {
          "x": 918,
          "y": 695,
          "w": 17.9,
          "h": 6.3,
          "angle": -63.4
        },
        {
          "x": 524,
          "y": 695.4,
          "w": 18.2,
          "h": 6.5,
          "angle": -14
        },
        {
          "x": 763,
          "y": 696,
          "w": 18.1,
          "h": 6.4,
          "angle": -30.3
        },
        {
          "x": 1062.2,
          "y": 696.8,
          "w": 18,
          "h": 6.5,
          "angle": 68.2
        },
        {
          "x": 1230,
          "y": 699.5,
          "w": 18.2,
          "h": 6.7,
          "angle": 37.9
        },
        {
          "x": 928.4,
          "y": 699.8,
          "w": 17.9,
          "h": 6.5,
          "angle": -66
        },
        {
          "x": 1359.2,
          "y": 700.1,
          "w": 18.3,
          "h": 6.3,
          "angle": 26.6
        },
        {
          "x": 1051.6,
          "y": 701.2,
          "w": 17.7,
          "h": 6.6,
          "angle": 71.6
        },
        {
          "x": 642.9,
          "y": 702.1,
          "w": 18,
          "h": 6.7,
          "angle": -20
        },
        {
          "x": 939.4,
          "y": 703.8,
          "w": 17.8,
          "h": 6.5,
          "angle": -68.2
        },
        {
          "x": 1040.8,
          "y": 704.8,
          "w": 17.9,
          "h": 6.5,
          "angle": 76
        },
        {
          "x": 769.8,
          "y": 706.5,
          "w": 18,
          "h": 6.7,
          "angle": -33.7
        },
        {
          "x": 950.7,
          "y": 707.1,
          "w": 18,
          "h": 6.6,
          "angle": -74.1
        },
        {
          "x": 1030,
          "y": 707.4,
          "w": 18,
          "h": 6.5,
          "angle": 78.7
        },
        {
          "x": 527.8,
          "y": 708.9,
          "w": 18,
          "h": 6.7,
          "angle": -16.7
        },
        {
          "x": 1222.1,
          "y": 709.5,
          "w": 17.9,
          "h": 6.5,
          "angle": 39.8
        },
        {
          "x": 962.4,
          "y": 709.6,
          "w": 17.8,
          "h": 6.5,
          "angle": -78.7
        },
        {
          "x": 1019.1,
          "y": 709.6,
          "w": 17.7,
          "h": 6.4,
          "angle": 82.9
        },
        {
          "x": 974.4,
          "y": 711.3,
          "w": 17.5,
          "h": 6.5,
          "angle": -81.9
        },
        {
          "x": 997.5,
          "y": 711.5,
          "w": 17,
          "h": 5,
          "angle": -90
        },
        {
          "x": 1008,
          "y": 711.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 1353.3,
          "y": 711.9,
          "w": 18.3,
          "h": 6.7,
          "angle": 26.6
        },
        {
          "x": 987,
          "y": 712,
          "w": 18,
          "h": 6,
          "angle": -90
        },
        {
          "x": 648.5,
          "y": 715.1,
          "w": 18,
          "h": 6.5,
          "angle": -21.8
        },
        {
          "x": 777,
          "y": 717,
          "w": 17.7,
          "h": 6.4,
          "angle": -35.5
        },
        {
          "x": 1214,
          "y": 719.5,
          "w": 17.7,
          "h": 6.4,
          "angle": 45
        },
        {
          "x": 531.9,
          "y": 722,
          "w": 18,
          "h": 6.3,
          "angle": -18.4
        },
        {
          "x": 1346.9,
          "y": 723.1,
          "w": 18.1,
          "h": 6.6,
          "angle": 30.3
        },
        {
          "x": 652.8,
          "y": 724.6,
          "w": 17.9,
          "h": 6.7,
          "angle": -24
        },
        {
          "x": 784.9,
          "y": 726.9,
          "w": 18,
          "h": 6.6,
          "angle": -36.9
        },
        {
          "x": 1206,
          "y": 728.5,
          "w": 17.7,
          "h": 6.4,
          "angle": 45
        },
        {
          "x": 657.7,
          "y": 734.4,
          "w": 17.9,
          "h": 6.7,
          "angle": -26.6
        },
        {
          "x": 1340.3,
          "y": 734.4,
          "w": 18,
          "h": 6.7,
          "angle": 32
        },
        {
          "x": 536.5,
          "y": 735.1,
          "w": 18,
          "h": 6.3,
          "angle": -18.4
        },
        {
          "x": 793.1,
          "y": 736.6,
          "w": 17.9,
          "h": 6.5,
          "angle": -40.6
        },
        {
          "x": 1197,
          "y": 737.5,
          "w": 17.7,
          "h": 6.4,
          "angle": 45
        },
        {
          "x": 662.9,
          "y": 743.8,
          "w": 17.9,
          "h": 6.7,
          "angle": -26.6
        },
        {
          "x": 1333.3,
          "y": 745.2,
          "w": 18,
          "h": 6.7,
          "angle": 33.7
        },
        {
          "x": 1187.5,
          "y": 745.9,
          "w": 17.9,
          "h": 6.6,
          "angle": 49.4
        },
        {
          "x": 802.5,
          "y": 746,
          "w": 17.7,
          "h": 6.4,
          "angle": -45
        },
        {
          "x": 541.6,
          "y": 748.1,
          "w": 17.8,
          "h": 6.5,
          "angle": -21.8
        },
        {
          "x": 668.1,
          "y": 753.2,
          "w": 17.9,
          "h": 6.7,
          "angle": -26.6
        },
        {
          "x": 1178.3,
          "y": 754.1,
          "w": 18.1,
          "h": 6.6,
          "angle": 51.3
        },
        {
          "x": 811.5,
          "y": 755,
          "w": 17.7,
          "h": 6.4,
          "angle": -45
        },
        {
          "x": 1326.2,
          "y": 755.9,
          "w": 18.1,
          "h": 6.7,
          "angle": 35
        },
        {
          "x": 547,
          "y": 760.9,
          "w": 17.9,
          "h": 6.7,
          "angle": -23.2
        },
        {
          "x": 1168.5,
          "y": 761.9,
          "w": 18,
          "h": 6.6,
          "angle": 53.1
        },
        {
          "x": 673.6,
          "y": 762.2,
          "w": 18,
          "h": 6.5,
          "angle": -31
        },
        {
          "x": 821.6,
          "y": 763.3,
          "w": 17.8,
          "h": 6.5,
          "angle": -49.4
        },
        {
          "x": 1318.8,
          "y": 766.5,
          "w": 17.8,
          "h": 6.9,
          "angle": 37.9
        },
        {
          "x": 1158.7,
          "y": 769,
          "w": 18,
          "h": 6.7,
          "angle": 56.3
        },
        {
          "x": 679.7,
          "y": 771.3,
          "w": 18,
          "h": 6.4,
          "angle": -33.7
        },
        {
          "x": 831.8,
          "y": 771.4,
          "w": 18,
          "h": 6.6,
          "angle": -53.1
        },
        {
          "x": 552.8,
          "y": 773.6,
          "w": 17.9,
          "h": 6.6,
          "angle": -24.4
        },
        {
          "x": 1148.4,
          "y": 775.9,
          "w": 18,
          "h": 6.7,
          "angle": 59
        },
        {
          "x": 1310.9,
          "y": 776.6,
          "w": 17.9,
          "h": 6.7,
          "angle": 40.6
        },
        {
          "x": 842.9,
          "y": 778.9,
          "w": 18.3,
          "h": 6.4,
          "angle": -56.3
        },
        {
          "x": 686,
          "y": 780.2,
          "w": 18,
          "h": 6.6,
          "angle": -35.5
        },
        {
          "x": 1137.9,
          "y": 782.1,
          "w": 18,
          "h": 6.6,
          "angle": 60.9
        },
        {
          "x": 854.1,
          "y": 786,
          "w": 18,
          "h": 6.6,
          "angle": -58
        },
        {
          "x": 559.1,
          "y": 786.2,
          "w": 17.9,
          "h": 6.7,
          "angle": -26.6
        },
        {
          "x": 1302.9,
          "y": 786.5,
          "w": 17.9,
          "h": 6.8,
          "angle": 41.2
        },
        {
          "x": 1127.4,
          "y": 788.3,
          "w": 17.9,
          "h": 6.7,
          "angle": 63.4
        },
        {
          "x": 692.4,
          "y": 788.9,
          "w": 18,
          "h": 6.6,
          "angle": -37.9
        },
        {
          "x": 863.8,
          "y": 790.9,
          "w": 17.9,
          "h": 6.7,
          "angle": -63.4
        },
        {
          "x": 1116.7,
          "y": 793.6,
          "w": 18,
          "h": 6.6,
          "angle": 66
        },
        {
          "x": 873.3,
          "y": 795.9,
          "w": 17.4,
          "h": 6.7,
          "angle": -63.4
        },
        {
          "x": 1294.5,
          "y": 796,
          "w": 17.7,
          "h": 6.4,
          "angle": 45
        },
        {
          "x": 699.4,
          "y": 797.4,
          "w": 18.3,
          "h": 6.7,
          "angle": -38.7
        },
        {
          "x": 1105.6,
          "y": 798.6,
          "w": 18.2,
          "h": 6.7,
          "angle": 68.2
        },
        {
          "x": 565.9,
          "y": 798.8,
          "w": 17.9,
          "h": 6.7,
          "angle": -26.6
        },
        {
          "x": 883.1,
          "y": 800.3,
          "w": 17.5,
          "h": 6.4,
          "angle": -66
        },
        {
          "x": 1094.5,
          "y": 803,
          "w": 18,
          "h": 6.6,
          "angle": 71.6
        },
        {
          "x": 893.2,
          "y": 804.4,
          "w": 18.1,
          "h": 6.6,
          "angle": -67.4
        },
        {
          "x": 1285.8,
          "y": 805.3,
          "w": 18.4,
          "h": 6.4,
          "angle": 45
        },
        {
          "x": 706.4,
          "y": 805.8,
          "w": 17.9,
          "h": 6.5,
          "angle": -40.6
        },
        {
          "x": 1083.2,
          "y": 807.1,
          "w": 18,
          "h": 6.6,
          "angle": 71.6
        },
        {
          "x": 903.6,
          "y": 808.2,
          "w": 17.7,
          "h": 6.3,
          "angle": -71.6
        },
        {
          "x": 1072.1,
          "y": 810.7,
          "w": 17.9,
          "h": 6.5,
          "angle": 76
        },
        {
          "x": 572.9,
          "y": 810.8,
          "w": 17.9,
          "h": 6.7,
          "angle": -26.6
        },
        {
          "x": 914,
          "y": 811.4,
          "w": 17.7,
          "h": 6.6,
          "angle": -71.6
        },
        {
          "x": 1060.7,
          "y": 813.8,
          "w": 17.9,
          "h": 6.6,
          "angle": 77.5
        },
        {
          "x": 713.5,
          "y": 814,
          "w": 17.7,
          "h": 6.4,
          "angle": -45
        },
        {
          "x": 924.8,
          "y": 814.2,
          "w": 18,
          "h": 6.5,
          "angle": -74.7
        },
        {
          "x": 1277,
          "y": 814.5,
          "w": 17.7,
          "h": 6.4,
          "angle": 45
        },
        {
          "x": 1049.1,
          "y": 816.5,
          "w": 17.8,
          "h": 6.7,
          "angle": 78.7
        },
        {
          "x": 935.4,
          "y": 816.7,
          "w": 17.7,
          "h": 6.5,
          "angle": -76
        },
        {
          "x": 946.5,
          "y": 818.5,
          "w": 17,
          "h": 7,
          "angle": -90
        },
        {
          "x": 1037.7,
          "y": 818.5,
          "w": 17.9,
          "h": 6.6,
          "angle": 80.5
        },
        {
          "x": 957.7,
          "y": 820.4,
          "w": 17.8,
          "h": 6.6,
          "angle": -81.9
        },
        {
          "x": 1026,
          "y": 820.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 969,
          "y": 821.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 1014.7,
          "y": 821.5,
          "w": 17.5,
          "h": 6.6,
          "angle": 85.6
        },
        {
          "x": 721.5,
          "y": 822,
          "w": 17.7,
          "h": 6.4,
          "angle": -45
        },
        {
          "x": 980,
          "y": 822.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 992,
          "y": 822.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 1003,
          "y": 822.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 580.4,
          "y": 822.8,
          "w": 18,
          "h": 6.5,
          "angle": -31
        },
        {
          "x": 1267.5,
          "y": 823,
          "w": 17.7,
          "h": 6.4,
          "angle": 45
        },
        {
          "x": 729.2,
          "y": 829.8,
          "w": 17.7,
          "h": 5.7,
          "angle": -45
        },
        {
          "x": 1258.4,
          "y": 832,
          "w": 17.9,
          "h": 6.7,
          "angle": 49.4
        },
        {
          "x": 588.2,
          "y": 834.5,
          "w": 18,
          "h": 6.7,
          "angle": -33.7
        },
        {
          "x": 737.5,
          "y": 837,
          "w": 17.7,
          "h": 6.4,
          "angle": -45
        },
        {
          "x": 1248.6,
          "y": 839.9,
          "w": 18.1,
          "h": 6.7,
          "angle": 51.3
        },
        {
          "x": 745.8,
          "y": 844.3,
          "w": 17.9,
          "h": 6.6,
          "angle": -48.4
        },
        {
          "x": 596.3,
          "y": 846.2,
          "w": 18,
          "h": 6.7,
          "angle": -33.7
        },
        {
          "x": 1238.9,
          "y": 847.8,
          "w": 18,
          "h": 6.8,
          "angle": 53.1
        },
        {
          "x": 754.3,
          "y": 851.7,
          "w": 17.9,
          "h": 6.5,
          "angle": -50.2
        },
        {
          "x": 1228.8,
          "y": 855.5,
          "w": 17.8,
          "h": 6.6,
          "angle": 54.5
        },
        {
          "x": 604.8,
          "y": 857.5,
          "w": 17.8,
          "h": 6.6,
          "angle": -36.9
        },
        {
          "x": 763.2,
          "y": 858.5,
          "w": 17.8,
          "h": 6.6,
          "angle": -53.1
        },
        {
          "x": 1218.7,
          "y": 862.5,
          "w": 18.3,
          "h": 6.7,
          "angle": 56.3
        },
        {
          "x": 772.3,
          "y": 865,
          "w": 18,
          "h": 6.4,
          "angle": -53.1
        },
        {
          "x": 613.6,
          "y": 868.7,
          "w": 18.3,
          "h": 6.6,
          "angle": -38.7
        },
        {
          "x": 1208.1,
          "y": 869.5,
          "w": 18,
          "h": 6.9,
          "angle": 59
        },
        {
          "x": 781.7,
          "y": 871.2,
          "w": 18.3,
          "h": 6.4,
          "angle": -56.3
        },
        {
          "x": 1197.6,
          "y": 876.2,
          "w": 18.1,
          "h": 6.7,
          "angle": 60.9
        },
        {
          "x": 791.2,
          "y": 877.3,
          "w": 18,
          "h": 6.7,
          "angle": -56.3
        },
        {
          "x": 623,
          "y": 879.6,
          "w": 17.9,
          "h": 6.5,
          "angle": -39.8
        },
        {
          "x": 1186.8,
          "y": 882.1,
          "w": 17.9,
          "h": 6.7,
          "angle": 63.4
        },
        {
          "x": 800.9,
          "y": 883,
          "w": 18,
          "h": 6.7,
          "angle": -59
        },
        {
          "x": 1175.8,
          "y": 888.1,
          "w": 17.9,
          "h": 6.7,
          "angle": 63.4
        },
        {
          "x": 810.8,
          "y": 888.6,
          "w": 17.6,
          "h": 6.6,
          "angle": -60.9
        },
        {
          "x": 632.5,
          "y": 890,
          "w": 17.7,
          "h": 6.4,
          "angle": -45
        },
        {
          "x": 1164.8,
          "y": 893.6,
          "w": 18,
          "h": 6.6,
          "angle": 65.6
        },
        {
          "x": 820.9,
          "y": 893.7,
          "w": 18.3,
          "h": 6.7,
          "angle": -63.4
        },
        {
          "x": 831.2,
          "y": 898.6,
          "w": 17.9,
          "h": 6.6,
          "angle": -65.2
        },
        {
          "x": 1153.6,
          "y": 898.7,
          "w": 17.9,
          "h": 6.7,
          "angle": 63.4
        },
        {
          "x": 642.2,
          "y": 900.3,
          "w": 18.4,
          "h": 6.4,
          "angle": -45
        },
        {
          "x": 841.7,
          "y": 903.4,
          "w": 18,
          "h": 6.6,
          "angle": -66.8
        },
        {
          "x": 1142.2,
          "y": 903.6,
          "w": 17.8,
          "h": 6.7,
          "angle": 70
        },
        {
          "x": 1342.1,
          "y": 906.4,
          "w": 17.9,
          "h": 6.8,
          "angle": 48.8
        },
        {
          "x": 852.3,
          "y": 907.6,
          "w": 18,
          "h": 6.7,
          "angle": -68.2
        },
        {
          "x": 1130.9,
          "y": 908,
          "w": 18.3,
          "h": 6.6,
          "angle": 69.4
        },
        {
          "x": 653,
          "y": 910.5,
          "w": 17.7,
          "h": 6.4,
          "angle": -45
        },
        {
          "x": 863.2,
          "y": 911.6,
          "w": 18,
          "h": 6.7,
          "angle": -70
        },
        {
          "x": 1119.5,
          "y": 912.4,
          "w": 18,
          "h": 6.3,
          "angle": 71.6
        },
        {
          "x": 874.1,
          "y": 915.2,
          "w": 18,
          "h": 6.6,
          "angle": -71.6
        },
        {
          "x": 1107.8,
          "y": 915.8,
          "w": 18,
          "h": 6.6,
          "angle": 74.1
        },
        {
          "x": 1330.1,
          "y": 917,
          "w": 18.3,
          "h": 7,
          "angle": 51.3
        },
        {
          "x": 885.1,
          "y": 918.4,
          "w": 18.3,
          "h": 6.7,
          "angle": -72.9
        },
        {
          "x": 1096.1,
          "y": 919.2,
          "w": 18,
          "h": 6.7,
          "angle": 74.7
        },
        {
          "x": 663,
          "y": 920.5,
          "w": 17.7,
          "h": 6.4,
          "angle": -45
        },
        {
          "x": 896.3,
          "y": 921.6,
          "w": 18,
          "h": 6.5,
          "angle": -74.7
        },
        {
          "x": 1084.4,
          "y": 922.4,
          "w": 17.9,
          "h": 6.6,
          "angle": 77.5
        },
        {
          "x": 907.6,
          "y": 924.4,
          "w": 17.9,
          "h": 6.7,
          "angle": -77.5
        },
        {
          "x": 1072.5,
          "y": 925,
          "w": 18.2,
          "h": 6.5,
          "angle": 78.7
        },
        {
          "x": 919.1,
          "y": 926.6,
          "w": 18,
          "h": 6.7,
          "angle": -78.7
        },
        {
          "x": 1318.1,
          "y": 927.4,
          "w": 17.9,
          "h": 6.8,
          "angle": 50.2
        },
        {
          "x": 1060.7,
          "y": 927.5,
          "w": 17.8,
          "h": 6.6,
          "angle": 81.9
        },
        {
          "x": 930.6,
          "y": 928.5,
          "w": 17.9,
          "h": 6.6,
          "angle": -80.5
        },
        {
          "x": 1048.8,
          "y": 929.4,
          "w": 17.6,
          "h": 6.7,
          "angle": 82.9
        },
        {
          "x": 674.3,
          "y": 929.8,
          "w": 17.9,
          "h": 6.6,
          "angle": -48.4
        },
        {
          "x": 942.1,
          "y": 930.4,
          "w": 17.8,
          "h": 6.6,
          "angle": -81.9
        },
        {
          "x": 1036.9,
          "y": 930.5,
          "w": 17.5,
          "h": 6.7,
          "angle": 84.8
        },
        {
          "x": 953.9,
          "y": 931.6,
          "w": 17.7,
          "h": 6.7,
          "angle": -82.9
        },
        {
          "x": 1025,
          "y": 932,
          "w": 18,
          "h": 6,
          "angle": -90
        },
        {
          "x": 965.6,
          "y": 932.5,
          "w": 17.5,
          "h": 6.6,
          "angle": -84.8
        },
        {
          "x": 1013,
          "y": 932.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 977.4,
          "y": 933.1,
          "w": 18.2,
          "h": 6.6,
          "angle": -85.2
        },
        {
          "x": 989,
          "y": 933.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 1001,
          "y": 933.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 1305.5,
          "y": 937,
          "w": 18.2,
          "h": 6.8,
          "angle": 53.1
        },
        {
          "x": 685.3,
          "y": 939,
          "w": 17.9,
          "h": 6.5,
          "angle": -50.7
        },
        {
          "x": 1292.9,
          "y": 946.6,
          "w": 18,
          "h": 6.7,
          "angle": 54.5
        },
        {
          "x": 696.9,
          "y": 948,
          "w": 17.8,
          "h": 6.6,
          "angle": -53.1
        },
        {
          "x": 1279.8,
          "y": 955.8,
          "w": 18.3,
          "h": 6.7,
          "angle": 56.3
        },
        {
          "x": 708.7,
          "y": 956.3,
          "w": 18,
          "h": 6.6,
          "angle": -53.1
        },
        {
          "x": 1266.6,
          "y": 964.3,
          "w": 18,
          "h": 6.9,
          "angle": 59
        },
        {
          "x": 720.6,
          "y": 964.6,
          "w": 18,
          "h": 6.7,
          "angle": -56.3
        },
        {
          "x": 733,
          "y": 972.5,
          "w": 18,
          "h": 6.7,
          "angle": -56.3
        },
        {
          "x": 1253,
          "y": 972.5,
          "w": 17.9,
          "h": 6.7,
          "angle": 63.4
        },
        {
          "x": 745.6,
          "y": 979.8,
          "w": 18.1,
          "h": 6.8,
          "angle": -60.9
        },
        {
          "x": 1239.5,
          "y": 980.5,
          "w": 18.3,
          "h": 6.7,
          "angle": 63.4
        },
        {
          "x": 758.3,
          "y": 986.9,
          "w": 17.4,
          "h": 6.7,
          "angle": -63.4
        },
        {
          "x": 1225.6,
          "y": 987.7,
          "w": 17.9,
          "h": 6.7,
          "angle": 63.4
        },
        {
          "x": 771.4,
          "y": 993.7,
          "w": 18,
          "h": 6.5,
          "angle": -60.9
        },
        {
          "x": 1211.6,
          "y": 994.7,
          "w": 17.9,
          "h": 6.7,
          "angle": 63.4
        },
        {
          "x": 784.7,
          "y": 999.9,
          "w": 17.9,
          "h": 6.5,
          "angle": -65.6
        },
        {
          "x": 1197.4,
          "y": 1001.3,
          "w": 18,
          "h": 6.7,
          "angle": 67.4
        },
        {
          "x": 798.3,
          "y": 1005.7,
          "w": 17.8,
          "h": 6.5,
          "angle": -67.4
        },
        {
          "x": 1183.1,
          "y": 1007.5,
          "w": 18,
          "h": 6.7,
          "angle": 69.4
        },
        {
          "x": 811.9,
          "y": 1011.5,
          "w": 18,
          "h": 6.5,
          "angle": -68.2
        },
        {
          "x": 1168.5,
          "y": 1013,
          "w": 18,
          "h": 6.6,
          "angle": 71.6
        },
        {
          "x": 825.9,
          "y": 1016.5,
          "w": 18,
          "h": 6.6,
          "angle": -70
        },
        {
          "x": 1153.9,
          "y": 1018.2,
          "w": 18,
          "h": 6.6,
          "angle": 71.6
        },
        {
          "x": 840.1,
          "y": 1021.2,
          "w": 18,
          "h": 6.6,
          "angle": -71.6
        },
        {
          "x": 1139,
          "y": 1022.8,
          "w": 18,
          "h": 6.7,
          "angle": 74.1
        },
        {
          "x": 854.3,
          "y": 1025.6,
          "w": 18,
          "h": 6.6,
          "angle": -71.6
        },
        {
          "x": 1124.2,
          "y": 1027.2,
          "w": 17.9,
          "h": 6.5,
          "angle": 76
        },
        {
          "x": 868.6,
          "y": 1029.5,
          "w": 18.3,
          "h": 6.6,
          "angle": -74.1
        },
        {
          "x": 1109.1,
          "y": 1031,
          "w": 18,
          "h": 6.5,
          "angle": 78.7
        },
        {
          "x": 883.1,
          "y": 1033,
          "w": 17.9,
          "h": 6.5,
          "angle": -76
        },
        {
          "x": 1094.1,
          "y": 1034.4,
          "w": 18,
          "h": 6.7,
          "angle": 78.7
        },
        {
          "x": 897.8,
          "y": 1036,
          "w": 18,
          "h": 6.7,
          "angle": -78.7
        },
        {
          "x": 1079,
          "y": 1037.4,
          "w": 17.9,
          "h": 6.7,
          "angle": 80.5
        },
        {
          "x": 912.6,
          "y": 1038.5,
          "w": 17.9,
          "h": 6.6,
          "angle": -80.5
        },
        {
          "x": 1063.7,
          "y": 1039.5,
          "w": 17.7,
          "h": 6.6,
          "angle": 82.9
        },
        {
          "x": 927.5,
          "y": 1040.6,
          "w": 17.7,
          "h": 6.5,
          "angle": -81.9
        },
        {
          "x": 1048.6,
          "y": 1041.5,
          "w": 17.7,
          "h": 6.6,
          "angle": 83.7
        },
        {
          "x": 942.4,
          "y": 1042.5,
          "w": 17.7,
          "h": 6.6,
          "angle": -82.9
        },
        {
          "x": 1033.4,
          "y": 1043,
          "w": 18.4,
          "h": 6.7,
          "angle": 84.8
        },
        {
          "x": 957.5,
          "y": 1043.5,
          "w": 17.6,
          "h": 6.6,
          "angle": -84.3
        },
        {
          "x": 1018,
          "y": 1044,
          "w": 18,
          "h": 6,
          "angle": -90
        },
        {
          "x": 972.6,
          "y": 1044.5,
          "w": 17.3,
          "h": 6.5,
          "angle": -85.9
        },
        {
          "x": 988,
          "y": 1044.5,
          "w": 17,
          "h": 6,
          "angle": -90
        },
        {
          "x": 1003,
          "y": 1044.5,
          "w": 17,
          "h": 6,
          "angle": -90
        }
      ]
    },
    "connection_blocks": [
      75,
      563
    ]
  },
  {
    "slug": "elegant-splitting",
    "top_extract": {
      "blocks": [
        {
          "x": 1024,
          "y": 4.5,
          "w": 52,
          "h": 9,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 32.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 64.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 96.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 128.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 160.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 192.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 224.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 256.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 288.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 320.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 352.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 384.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 416.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 11.5,
          "y": 510.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 43,
          "y": 510.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 75,
          "y": 510.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 107,
          "y": 510.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 139,
          "y": 510.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 171,
          "y": 510.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 203,
          "y": 510.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 235,
          "y": 510.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 267,
          "y": 510.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 299,
          "y": 510.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 331,
          "y": 510.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 363,
          "y": 510.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 395,
          "y": 510.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 427,
          "y": 510.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 459,
          "y": 510.5,
          "w": 53,
          "h": 18,
          "angle": -90
        },
        {
          "x": 492.5,
          "y": 510.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 524.5,
          "y": 510.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 556.5,
          "y": 510.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 588.5,
          "y": 510.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 620.5,
          "y": 510.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 652.5,
          "y": 510.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 684.5,
          "y": 510.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 716.5,
          "y": 510.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 748.5,
          "y": 510.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 780.5,
          "y": 510.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 812.5,
          "y": 510.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 844.5,
          "y": 510.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 876.5,
          "y": 510.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 908.5,
          "y": 510.5,
          "w": 53,
          "h": 17,
          "angle": -90
        },
        {
          "x": 990,
          "y": 511,
          "w": 142,
          "h": 120,
          "angle": -90
        },
        {
          "x": 1024,
          "y": 605.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 637.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 669.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 701.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 733.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 765.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 797.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 829.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 861.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 893.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 925.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 957.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 989.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 1021.5,
          "w": 52,
          "h": 17,
          "angle": 0
        },
        {
          "x": 1024,
          "y": 1053.5,
          "w": 52,
          "h": 17,
          "angle": 0
        }
      ]
    }
  },
  {
    "slug": "split-ends",
    "top_extract": {
      "blocks": [
        {
          "x": 1118.5,
          "y": 59.5,
          "w": 21,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1407.5,
          "y": 86.5,
          "w": 91,
          "h": 27,
          "angle": -90
        },
        {
          "x": 547,
          "y": 107,
          "w": 34,
          "h": 18,
          "angle": -90
        },
        {
          "x": 837,
          "y": 107,
          "w": 34,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1121,
          "y": 107,
          "w": 34,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1144.5,
          "y": 107,
          "w": 21,
          "h": 14,
          "angle": 0
        },
        {
          "x": 1177.5,
          "y": 107,
          "w": 21,
          "h": 14,
          "angle": 0
        },
        {
          "x": 1218.5,
          "y": 107,
          "w": 21,
          "h": 14,
          "angle": 0
        },
        {
          "x": 1301.5,
          "y": 107,
          "w": 29,
          "h": 14,
          "angle": 0
        },
        {
          "x": 1342.5,
          "y": 107,
          "w": 29,
          "h": 14,
          "angle": 0
        },
        {
          "x": 1375.5,
          "y": 107,
          "w": 29,
          "h": 14,
          "angle": 0
        },
        {
          "x": 1250.5,
          "y": 108.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 692,
          "y": 109,
          "w": 34,
          "h": 18,
          "angle": 0
        },
        {
          "x": 1271.5,
          "y": 109,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1266.5,
          "y": 140.5,
          "w": 21,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1414,
          "y": 150.5,
          "w": 29,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1266.5,
          "y": 173.5,
          "w": 21,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1266.5,
          "y": 206.5,
          "w": 21,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1262.5,
          "y": 249.2,
          "w": 21,
          "h": 13,
          "angle": -72.6
        },
        {
          "x": 694.8,
          "y": 253.4,
          "w": 33.4,
          "h": 18.7,
          "angle": 88
        },
        {
          "x": 1158.5,
          "y": 253.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1232.5,
          "y": 253.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 958,
          "y": 254.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 983.9,
          "y": 257.5,
          "w": 21,
          "h": 13,
          "angle": -16.4
        },
        {
          "x": 1265,
          "y": 275,
          "w": 21,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1266.5,
          "y": 317.5,
          "w": 21,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1414,
          "y": 336.5,
          "w": 21,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1266.5,
          "y": 350.5,
          "w": 21,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1414,
          "y": 378,
          "w": 21,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1267,
          "y": 391.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1125.5,
          "y": 392,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 696.5,
          "y": 394,
          "w": 21,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1403.6,
          "y": 398.4,
          "w": 21,
          "h": 13,
          "angle": -24.8
        },
        {
          "x": 676.5,
          "y": 399.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 547,
          "y": 400.5,
          "w": 33,
          "h": 18,
          "angle": -90
        },
        {
          "x": 837.5,
          "y": 400.5,
          "w": 33,
          "h": 19,
          "angle": -90
        },
        {
          "x": 1169.5,
          "y": 400.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1244,
          "y": 400.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1289,
          "y": 400.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1363.5,
          "y": 400.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1125.6,
          "y": 408.2,
          "w": 21,
          "h": 13,
          "angle": -6.3
        },
        {
          "x": 1412.3,
          "y": 410.2,
          "w": 21,
          "h": 13,
          "angle": 70.3
        },
        {
          "x": 1414,
          "y": 431.5,
          "w": 21,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1414,
          "y": 464.5,
          "w": 21,
          "h": 14,
          "angle": -90
        },
        {
          "x": 977,
          "y": 540.5,
          "w": 33,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1414,
          "y": 616.5,
          "w": 21,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1414,
          "y": 649.5,
          "w": 21,
          "h": 14,
          "angle": -90
        },
        {
          "x": 545.5,
          "y": 664.5,
          "w": 21,
          "h": 13,
          "angle": -90
        },
        {
          "x": 838,
          "y": 664.5,
          "w": 21,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1407.5,
          "y": 672,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1121,
          "y": 680.5,
          "w": 33,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1177.5,
          "y": 680.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1297.5,
          "y": 680.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1338.5,
          "y": 680.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1371.5,
          "y": 680.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1250.4,
          "y": 680.9,
          "w": 21,
          "h": 13,
          "angle": 7.6
        },
        {
          "x": 692,
          "y": 683,
          "w": 34,
          "h": 18,
          "angle": 0
        },
        {
          "x": 547,
          "y": 685.5,
          "w": 21,
          "h": 13,
          "angle": -90
        },
        {
          "x": 837,
          "y": 685.5,
          "w": 21,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1271,
          "y": 687,
          "w": 21,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1407.5,
          "y": 688,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1414,
          "y": 711.5,
          "w": 21,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1414,
          "y": 744.5,
          "w": 21,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1266.5,
          "y": 759.5,
          "w": 29,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1266.5,
          "y": 796.5,
          "w": 21,
          "h": 13,
          "angle": -90
        },
        {
          "x": 693.9,
          "y": 816.8,
          "w": 21,
          "h": 13,
          "angle": 63.4
        },
        {
          "x": 984.5,
          "y": 825,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 963.5,
          "y": 825.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1051.5,
          "y": 827.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1125.5,
          "y": 827.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1158.5,
          "y": 827.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1199.5,
          "y": 827.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1232.5,
          "y": 827.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1264,
          "y": 827.5,
          "w": 33,
          "h": 18,
          "angle": -90
        },
        {
          "x": 699.6,
          "y": 834.1,
          "w": 21,
          "h": 13,
          "angle": -21.8
        },
        {
          "x": 1266.5,
          "y": 866.5,
          "w": 21,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1266.5,
          "y": 903.5,
          "w": 29,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1414,
          "y": 909.2,
          "w": 18.5,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1119,
          "y": 918.5,
          "w": 21,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1414,
          "y": 927.8,
          "w": 18.5,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1266.5,
          "y": 940.5,
          "w": 21,
          "h": 13,
          "angle": -90
        },
        {
          "x": 838.9,
          "y": 958.1,
          "w": 21,
          "h": 13,
          "angle": -81.9
        },
        {
          "x": 546,
          "y": 958.5,
          "w": 21,
          "h": 13,
          "angle": -90
        },
        {
          "x": 1129.5,
          "y": 970,
          "w": 42,
          "h": 35,
          "angle": -90
        },
        {
          "x": 1262.3,
          "y": 970.5,
          "w": 21,
          "h": 13,
          "angle": -16.4
        },
        {
          "x": 697.5,
          "y": 972,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 676.5,
          "y": 973,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1288,
          "y": 973,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 570.5,
          "y": 974.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 797.5,
          "y": 974.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1169.5,
          "y": 974.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1202.5,
          "y": 974.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1235.5,
          "y": 974.5,
          "w": 21,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1326.5,
          "y": 974.5,
          "w": 29,
          "h": 13,
          "angle": 0
        },
        {
          "x": 1359.5,
          "y": 974.5,
          "w": 29,
          "h": 13,
          "angle": 0
        },
        {
          "x": 837,
          "y": 979.5,
          "w": 21,
          "h": 13,
          "angle": -90
        },
        {
          "x": 548.3,
          "y": 979.7,
          "w": 21,
          "h": 13,
          "angle": -73.6
        },
        {
          "x": 1399.5,
          "y": 986.5,
          "w": 91,
          "h": 43,
          "angle": -90
        },
        {
          "x": 840,
          "y": 1013.5,
          "w": 21,
          "h": 14,
          "angle": -90
        },
        {
          "x": 1119,
          "y": 1013.5,
          "w": 21,
          "h": 14,
          "angle": -90
        }
      ]
    }
  },
  {
    "slug": "small-triangles",
    "top_extract": {
      "blocks": [
        {
          "x": 728.5,
          "y": 489.5,
          "w": 79,
          "h": 69,
          "angle": -90
        },
        {
          "x": 1054,
          "y": 489.5,
          "w": 79,
          "h": 70,
          "angle": -90
        },
        {
          "x": 841,
          "y": 490.5,
          "w": 79,
          "h": 70,
          "angle": -90
        },
        {
          "x": 1166.5,
          "y": 490.5,
          "w": 79,
          "h": 69,
          "angle": -90
        },
        {
          "x": 683,
          "y": 583.5,
          "w": 79,
          "h": 70,
          "angle": -90
        },
        {
          "x": 891.5,
          "y": 583.5,
          "w": 79,
          "h": 69,
          "angle": -90
        },
        {
          "x": 1217,
          "y": 583.5,
          "w": 79,
          "h": 70,
          "angle": -90
        },
        {
          "x": 17,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 48.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 81,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 112.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 144.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 176.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 208.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 240.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 272.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 304.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 336.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 368.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 400.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 432.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 464.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 496.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 528.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 560.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 592.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 624.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1008,
          "y": 584,
          "w": 78,
          "h": 70,
          "angle": -90
        },
        {
          "x": 1273,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1305,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1337,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1369,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1401,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1433,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1465,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1497,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1529,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1561,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1593,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1625,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1657,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1688.5,
          "y": 584,
          "w": 52,
          "h": 17,
          "angle": -90
        },
        {
          "x": 1721,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1753,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1785,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1817,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1849,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1881,
          "y": 584,
          "w": 52,
          "h": 18,
          "angle": -90
        },
        {
          "x": 1911.5,
          "y": 584,
          "w": 52,
          "h": 15,
          "angle": -90
        }
      ]
    }
  },
  {
    "slug": "speed-wall",
    "top_extract": {
      "blocks": [
        {
          "x": 10.5,
          "y": 543.5,
          "w": 47,
          "h": 17,
          "angle": -90
        },
        {
          "x": 40.5,
          "y": 543.5,
          "w": 47,
          "h": 19,
          "angle": -90
        },
        {
          "x": 68.5,
          "y": 543.5,
          "w": 47,
          "h": 19,
          "angle": -90
        },
        {
          "x": 96.5,
          "y": 543.5,
          "w": 47,
          "h": 19,
          "angle": -90
        },
        {
          "x": 127,
          "y": 543.5,
          "w": 47,
          "h": 20,
          "angle": -90
        },
        {
          "x": 970,
          "y": 543.5,
          "w": 1650,
          "h": 47,
          "angle": 0
        }
      ]
    },
    "three_boxes": {
      "manual_boxes": [
        {
          "count": 31,
          "x_cm": -87.286,
          "step_x_cm": 1.444,
          "z_cm": 0,
          "y_cm": 2.4,
          "yaw_deg": 90,
          "pose": "upright",
          "material": "domino"
        },
        {
          "count": 11,
          "x_cm": -42.513,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 2.4,
          "yaw_deg": 90,
          "pose": "upright",
          "material": "domino"
        },
        {
          "count": 11,
          "x_cm": -38.463,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 2.4,
          "yaw_deg": 90,
          "pose": "upright",
          "material": "domino"
        },
        {
          "count": 11,
          "x_cm": -40.488,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 5.175,
          "yaw_deg": 0,
          "pose": "flat",
          "material": "domino"
        },
        {
          "count": 10,
          "x_cm": -38.4642,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 7.951,
          "yaw_deg": 90,
          "pose": "upright",
          "material": "domino"
        },
        {
          "count": 10,
          "x_cm": -34.4142,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 7.951,
          "yaw_deg": 90,
          "pose": "upright",
          "material": "domino"
        },
        {
          "count": 10,
          "x_cm": -36.4392,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 10.726,
          "yaw_deg": 0,
          "pose": "flat",
          "material": "domino"
        },
        {
          "count": 9,
          "x_cm": -34.4154,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 13.502,
          "yaw_deg": 90,
          "pose": "upright",
          "material": "domino"
        },
        {
          "count": 9,
          "x_cm": -30.3654,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 13.502,
          "yaw_deg": 90,
          "pose": "upright",
          "material": "domino"
        },
        {
          "count": 9,
          "x_cm": -32.3904,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 16.277,
          "yaw_deg": 0,
          "pose": "flat",
          "material": "domino"
        },
        {
          "count": 8,
          "x_cm": -30.3666,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 19.053,
          "yaw_deg": 90,
          "pose": "upright",
          "material": "domino"
        },
        {
          "count": 8,
          "x_cm": -26.3166,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 19.053,
          "yaw_deg": 90,
          "pose": "upright",
          "material": "domino"
        },
        {
          "count": 8,
          "x_cm": -28.3416,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 21.828,
          "yaw_deg": 0,
          "pose": "flat",
          "material": "domino"
        },
        {
          "count": 7,
          "x_cm": -26.3178,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 24.604,
          "yaw_deg": 90,
          "pose": "upright",
          "material": "domino"
        },
        {
          "count": 7,
          "x_cm": -22.2678,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 24.604,
          "yaw_deg": 90,
          "pose": "upright",
          "material": "domino"
        },
        {
          "count": 7,
          "x_cm": -24.2928,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 27.379,
          "yaw_deg": 0,
          "pose": "flat",
          "material": "domino"
        },
        {
          "count": 6,
          "x_cm": -22.269,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 30.155,
          "yaw_deg": 90,
          "pose": "upright",
          "material": "domino"
        },
        {
          "count": 6,
          "x_cm": -18.219,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 30.155,
          "yaw_deg": 90,
          "pose": "upright",
          "material": "domino"
        },
        {
          "count": 6,
          "x_cm": -20.244,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 32.93,
          "yaw_deg": 0,
          "pose": "flat",
          "material": "domino"
        },
        {
          "count": 5,
          "x_cm": -18.2202,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 35.706,
          "yaw_deg": 90,
          "pose": "upright",
          "material": "domino"
        },
        {
          "count": 5,
          "x_cm": -14.1702,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 35.706,
          "yaw_deg": 90,
          "pose": "upright",
          "material": "domino"
        },
        {
          "count": 5,
          "x_cm": -16.1952,
          "step_x_cm": 8.0976,
          "z_cm": 0,
          "y_cm": 38.481,
          "yaw_deg": 0,
          "pose": "flat",
          "material": "domino"
        }
      ]
    }
  }
] as const;

export const DOMINO_BLENDER_THREE_BOXES_DATA = {
  "2d-pyramid": [
    [
      -2.458,
      1.2,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      4.05,
      1.2,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      8.1,
      1.2,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      12.15,
      1.2,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      16.2,
      1.2,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      20.25,
      1.2,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      24.3,
      1.2,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      28.35,
      1.2,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      32.4,
      1.2,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      36.45,
      1.2,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      40.5,
      1.2,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      44.55,
      1.2,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      48.6,
      1.2,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      52.65,
      1.2,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      56.7,
      1.2,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      60.75,
      1.2,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      64.8,
      1.2,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      68.85,
      1.2,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      72.9,
      1.2,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      76.95,
      1.2,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      2.025,
      3.601,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      6.075,
      3.601,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      10.125,
      3.601,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      14.175,
      3.601,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      18.225,
      3.601,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      22.275,
      3.601,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      26.325,
      3.601,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      30.375,
      3.601,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      34.425,
      3.601,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      38.475,
      3.601,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      42.525,
      3.601,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      46.575,
      3.601,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      50.625,
      3.601,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      54.675,
      3.601,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      58.725,
      3.601,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      62.775,
      3.601,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      66.825,
      3.601,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      70.875,
      3.601,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      74.925,
      3.601,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      4.05,
      6.002,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      8.1,
      6.002,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      12.15,
      6.002,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      16.2,
      6.002,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      20.25,
      6.002,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      24.3,
      6.002,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      28.35,
      6.002,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      32.4,
      6.002,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      36.45,
      6.002,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      40.5,
      6.002,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      44.55,
      6.002,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      48.6,
      6.002,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      52.65,
      6.002,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      56.7,
      6.002,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      60.75,
      6.002,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      64.8,
      6.002,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      68.85,
      6.002,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      72.9,
      6.002,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      6.075,
      8.403,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      10.125,
      8.403,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      14.175,
      8.403,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      18.225,
      8.403,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      22.275,
      8.403,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      26.325,
      8.403,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      30.375,
      8.403,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      34.425,
      8.403,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      38.475,
      8.403,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      42.525,
      8.403,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      46.575,
      8.403,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      50.625,
      8.403,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      54.675,
      8.403,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      58.725,
      8.403,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      62.775,
      8.403,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      66.825,
      8.403,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      70.875,
      8.403,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      8.1,
      10.804,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      12.15,
      10.804,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      16.2,
      10.804,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      20.25,
      10.804,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      24.3,
      10.804,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      28.35,
      10.804,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      32.4,
      10.804,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      36.45,
      10.804,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      40.5,
      10.804,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      44.55,
      10.804,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      48.6,
      10.804,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      52.65,
      10.804,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      56.7,
      10.804,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      60.75,
      10.804,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      64.8,
      10.804,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      68.85,
      10.804,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      10.125,
      13.205,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      14.175,
      13.205,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      18.225,
      13.205,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      22.275,
      13.205,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      26.325,
      13.205,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      30.375,
      13.205,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      34.425,
      13.205,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      38.475,
      13.205,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      42.525,
      13.205,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      46.575,
      13.205,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      50.625,
      13.205,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      54.675,
      13.205,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      58.725,
      13.205,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      62.775,
      13.205,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      66.825,
      13.205,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      12.15,
      15.606,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      16.2,
      15.606,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      20.25,
      15.606,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      24.3,
      15.606,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      28.35,
      15.606,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      32.4,
      15.606,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      36.45,
      15.606,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      40.5,
      15.606,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      44.55,
      15.606,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      48.6,
      15.606,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      52.65,
      15.606,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      56.7,
      15.606,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      60.75,
      15.606,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      64.8,
      15.606,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      14.175,
      18.007,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      18.225,
      18.007,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      22.275,
      18.007,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      26.325,
      18.007,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      30.375,
      18.007,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      34.425,
      18.007,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      38.475,
      18.007,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      42.525,
      18.007,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      46.575,
      18.007,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      50.625,
      18.007,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      54.675,
      18.007,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      58.725,
      18.007,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      62.775,
      18.007,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      16.2,
      20.408,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      20.25,
      20.408,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      24.3,
      20.408,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      28.35,
      20.408,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      32.4,
      20.408,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      36.45,
      20.408,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      40.5,
      20.408,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      44.55,
      20.408,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      48.6,
      20.408,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      52.65,
      20.408,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      56.7,
      20.408,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      60.75,
      20.408,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      18.225,
      22.809,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      22.275,
      22.809,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      26.325,
      22.809,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      30.375,
      22.809,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      34.425,
      22.809,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      38.475,
      22.809,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      42.525,
      22.809,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      46.575,
      22.809,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      50.625,
      22.809,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      54.675,
      22.809,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      58.725,
      22.809,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      20.25,
      25.21,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      24.3,
      25.21,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      28.35,
      25.21,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      32.4,
      25.21,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      36.45,
      25.21,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      40.5,
      25.21,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      44.55,
      25.21,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      48.6,
      25.21,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      52.65,
      25.21,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      56.7,
      25.21,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      22.275,
      27.611,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      26.325,
      27.611,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      30.375,
      27.611,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      34.425,
      27.611,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      38.475,
      27.611,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      42.525,
      27.611,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      46.575,
      27.611,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      50.625,
      27.611,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      54.675,
      27.611,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      24.3,
      30.012,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      28.35,
      30.012,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      32.4,
      30.012,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      36.45,
      30.012,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      40.5,
      30.012,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      44.55,
      30.012,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      48.6,
      30.012,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      52.65,
      30.012,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      26.325,
      32.413,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      30.375,
      32.413,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      34.425,
      32.413,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      38.475,
      32.413,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      42.525,
      32.413,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      46.575,
      32.413,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      50.625,
      32.413,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      28.35,
      34.814,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      32.4,
      34.814,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      36.45,
      34.814,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      40.5,
      34.814,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      44.55,
      34.814,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      48.6,
      34.814,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      30.375,
      37.215,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      34.425,
      37.215,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      38.475,
      37.215,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      42.525,
      37.215,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      46.575,
      37.215,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      32.4,
      39.616,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      36.45,
      39.616,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      40.5,
      39.616,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      44.55,
      39.616,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      34.425,
      42.017,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      38.475,
      42.017,
      2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      42.525,
      42.017,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      36.45,
      44.418,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      40.5,
      44.418,
      0,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      38.475,
      46.819,
      -2.025,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -2.458,
      2.402,
      -0.45,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -2.458,
      2.402,
      1.05,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -2.458,
      2.402,
      2.55,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -2.458,
      2.402,
      4.05,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -2.458,
      2.402,
      5.55,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -2.458,
      2.402,
      7.05,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -2.458,
      2.402,
      8.55,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -2.458,
      2.402,
      10.05,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -2.458,
      2.402,
      11.55,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -2.458,
      2.402,
      13.05,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -2.458,
      2.402,
      14.55,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -2.458,
      2.402,
      16.05,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -2.458,
      2.402,
      17.55,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -2.458,
      2.402,
      19.05,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -2.458,
      2.402,
      20.55,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -2.458,
      2.402,
      22.05,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -2.458,
      2.402,
      23.55,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -2.458,
      2.402,
      25.05,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -2.458,
      2.402,
      26.55,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -2.458,
      2.402,
      28.05,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -2.458,
      2.402,
      29.55,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ]
  ],
  "3d-pyramid": [
    [
      -75.1672,
      1.2,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -79.2172,
      1.2,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -83.2672,
      1.2,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -87.3172,
      1.2,
      6.2524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -58.9672,
      1.2,
      -13.9976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -63.0172,
      1.2,
      -9.9476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      1.2,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      1.2,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -75.1672,
      1.2,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -79.2172,
      1.2,
      6.2524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -83.2672,
      1.2,
      10.3024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -54.9172,
      1.2,
      -9.9476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -58.9672,
      1.2,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -63.0172,
      1.2,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      1.2,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      1.2,
      6.2524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -75.1672,
      1.2,
      10.3024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -79.2172,
      1.2,
      14.3524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -50.8672,
      1.2,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -54.9172,
      1.2,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -58.9672,
      1.2,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      1.2,
      22.4524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      1.2,
      18.4024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -63.0172,
      1.2,
      14.3524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -58.9672,
      1.2,
      10.3024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -54.9172,
      1.2,
      6.2524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -50.8672,
      1.2,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -46.8172,
      1.2,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -75.1672,
      1.2,
      18.4024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      1.2,
      14.3524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      1.2,
      10.3024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -63.0172,
      1.2,
      6.2524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      1.2,
      -9.9476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      1.2,
      -13.9976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -63.0172,
      1.2,
      -18.0476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -91.3672,
      1.2,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -87.3172,
      1.2,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -83.2672,
      1.2,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -79.2172,
      1.2,
      -9.9476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -75.1672,
      1.2,
      -13.9976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      1.2,
      -18.0476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      1.2,
      -22.0976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -97.4827,
      1.2,
      -3.8768,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -91.3672,
      1.2,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -87.3172,
      1.2,
      -9.9476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -83.2672,
      1.2,
      -13.9976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -79.2172,
      1.2,
      -18.0476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -75.1672,
      1.2,
      -22.0976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      1.2,
      -26.1476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -69.0922,
      3.601,
      20.4274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -65.0422,
      3.601,
      16.3774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -60.9922,
      3.601,
      12.3274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -56.9422,
      3.601,
      8.2774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -52.8922,
      3.601,
      4.2274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -48.8422,
      3.601,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      3.601,
      16.3774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -69.0922,
      3.601,
      12.3274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -65.0422,
      3.601,
      8.2774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -60.9922,
      3.601,
      4.2274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -56.9422,
      3.601,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -52.8922,
      3.601,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -77.1922,
      3.601,
      12.3274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      3.601,
      8.2774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -69.0922,
      3.601,
      4.2274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -65.0422,
      3.601,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -60.9922,
      3.601,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -56.9422,
      3.601,
      -7.9226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -81.2422,
      3.601,
      8.2774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -77.1922,
      3.601,
      4.2274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      3.601,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -69.0922,
      3.601,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -65.0422,
      3.601,
      -7.9226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -60.9922,
      3.601,
      -11.9726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -85.2922,
      3.601,
      4.2274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -81.2422,
      3.601,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -77.1922,
      3.601,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      3.601,
      -7.9226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -69.0922,
      3.601,
      -11.9726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -65.0422,
      3.601,
      -16.0226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -89.3422,
      3.601,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -85.2922,
      3.601,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -81.2422,
      3.601,
      -7.9226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -77.1922,
      3.601,
      -11.9726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      3.601,
      -16.0226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -69.0922,
      3.601,
      -20.0726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -93.3922,
      3.601,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -89.3422,
      3.601,
      -7.9226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -85.2922,
      3.601,
      -11.9726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -81.2422,
      3.601,
      -16.0226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -77.1922,
      3.601,
      -20.0726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      3.601,
      -24.1226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -71.1172,
      6.002,
      18.4024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      6.002,
      14.3524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -63.0172,
      6.002,
      10.3024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -58.9672,
      6.002,
      6.2524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -54.9172,
      6.002,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -50.8672,
      6.002,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -75.1672,
      6.002,
      14.3524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      6.002,
      10.3024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      6.002,
      6.2524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -63.0172,
      6.002,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -58.9672,
      6.002,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -54.9172,
      6.002,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -79.2172,
      6.002,
      10.3024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -75.1672,
      6.002,
      6.2524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      6.002,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      6.002,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -63.0172,
      6.002,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -58.9672,
      6.002,
      -9.9476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -83.2672,
      6.002,
      6.2524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -79.2172,
      6.002,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -75.1672,
      6.002,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      6.002,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      6.002,
      -9.9476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -63.0172,
      6.002,
      -13.9976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -87.3172,
      6.002,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -83.2672,
      6.002,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -79.2172,
      6.002,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -75.1672,
      6.002,
      -9.9476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      6.002,
      -13.9976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      6.002,
      -18.0476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -91.3672,
      6.002,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -87.3172,
      6.002,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -83.2672,
      6.002,
      -9.9476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -79.2172,
      6.002,
      -13.9976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -75.1672,
      6.002,
      -18.0476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      6.002,
      -22.0976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -69.0922,
      8.403,
      16.3774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -65.0422,
      8.403,
      12.3274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -60.9922,
      8.403,
      8.2774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -56.9422,
      8.403,
      4.2274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -52.8922,
      8.403,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      8.403,
      12.3274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -69.0922,
      8.403,
      8.2774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -65.0422,
      8.403,
      4.2274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -60.9922,
      8.403,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -56.9422,
      8.403,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -77.1922,
      8.403,
      8.2774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      8.403,
      4.2274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -69.0922,
      8.403,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -65.0422,
      8.403,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -60.9922,
      8.403,
      -7.9226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -81.2422,
      8.403,
      4.2274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -77.1922,
      8.403,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      8.403,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -69.0922,
      8.403,
      -7.9226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -65.0422,
      8.403,
      -11.9726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -85.2922,
      8.403,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -81.2422,
      8.403,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -77.1922,
      8.403,
      -7.9226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      8.403,
      -11.9726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -69.0922,
      8.403,
      -16.0226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -89.3422,
      8.403,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -85.2922,
      8.403,
      -7.9226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -81.2422,
      8.403,
      -11.9726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -77.1922,
      8.403,
      -16.0226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      8.403,
      -20.0726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -71.1172,
      10.804,
      14.3524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      10.804,
      10.3024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -63.0172,
      10.804,
      6.2524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -58.9672,
      10.804,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -54.9172,
      10.804,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -75.1672,
      10.804,
      10.3024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      10.804,
      6.2524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      10.804,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -63.0172,
      10.804,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -58.9672,
      10.804,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -79.2172,
      10.804,
      6.2524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -75.1672,
      10.804,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      10.804,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      10.804,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -63.0172,
      10.804,
      -9.9476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -83.2672,
      10.804,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -79.2172,
      10.804,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -75.1672,
      10.804,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      10.804,
      -9.9476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      10.804,
      -13.9976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -87.3172,
      10.804,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -83.2672,
      10.804,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -79.2172,
      10.804,
      -9.9476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -75.1672,
      10.804,
      -13.9976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      10.804,
      -18.0476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -69.0922,
      13.205,
      12.3274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -65.0422,
      13.205,
      8.2774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -60.9922,
      13.205,
      4.2274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -56.9422,
      13.205,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      13.205,
      8.2774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -69.0922,
      13.205,
      4.2274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -65.0422,
      13.205,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -60.9922,
      13.205,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -77.1922,
      13.205,
      4.2274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      13.205,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -69.0922,
      13.205,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -65.0422,
      13.205,
      -7.9226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -81.2422,
      13.205,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -77.1922,
      13.205,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      13.205,
      -7.9226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -69.0922,
      13.205,
      -11.9726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -85.2922,
      13.205,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -81.2422,
      13.205,
      -7.9226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -77.1922,
      13.205,
      -11.9726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      13.205,
      -16.0226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -71.1172,
      15.606,
      10.3024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      15.606,
      6.2524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -63.0172,
      15.606,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -58.9672,
      15.606,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -75.1672,
      15.606,
      6.2524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      15.606,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      15.606,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -63.0172,
      15.606,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -79.2172,
      15.606,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -75.1672,
      15.606,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      15.606,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      15.606,
      -9.9476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -83.2672,
      15.606,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -79.2172,
      15.606,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -75.1672,
      15.606,
      -9.9476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      15.606,
      -13.9976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -69.0922,
      18.007,
      8.2774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -65.0422,
      18.007,
      4.2274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -60.9922,
      18.007,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      18.007,
      4.2274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -69.0922,
      18.007,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -65.0422,
      18.007,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -77.1922,
      18.007,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      18.007,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -69.0922,
      18.007,
      -7.9226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -81.2422,
      18.007,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -77.1922,
      18.007,
      -7.9226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      18.007,
      -11.9726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -71.1172,
      20.408,
      6.2524,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      20.408,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -63.0172,
      20.408,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -75.1672,
      20.408,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      20.408,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      20.408,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -79.2172,
      20.408,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -75.1672,
      20.408,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      20.408,
      -9.9476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -69.0922,
      22.809,
      4.2274,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -65.0422,
      22.809,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      22.809,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -69.0922,
      22.809,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -77.1922,
      22.809,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      22.809,
      -7.9226,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -71.1172,
      25.21,
      2.2024,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -67.0672,
      25.21,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -75.1672,
      25.21,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -71.1172,
      25.21,
      -5.8976,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -69.0922,
      27.611,
      0.1774,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -73.1422,
      27.611,
      -3.8726,
      0.75,
      4.8,
      2.4,
      -0.5,
      0.5,
      0.5,
      0.5
    ],
    [
      -71.1172,
      30.012,
      -1.8476,
      0.75,
      4.8,
      2.4,
      -0.707107,
      0,
      0,
      0.707107
    ],
    [
      -97.4827,
      2.402,
      26.1232,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -97.4827,
      2.402,
      24.6232,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -97.4827,
      2.402,
      23.1232,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -97.4827,
      2.402,
      21.6232,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -97.4827,
      2.402,
      20.1232,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -97.4827,
      2.402,
      18.6232,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -97.4827,
      2.402,
      17.1232,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -97.4827,
      2.402,
      15.6232,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -97.4827,
      2.402,
      14.1232,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -97.4827,
      2.402,
      12.6232,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -97.4827,
      2.402,
      11.1232,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -97.4827,
      2.402,
      9.6232,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -97.4827,
      2.402,
      8.1232,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -97.4827,
      2.402,
      6.6232,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -97.4827,
      2.402,
      5.1232,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -97.4827,
      2.402,
      3.6232,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -97.4827,
      2.402,
      2.1232,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -97.4827,
      2.402,
      0.6232,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -97.4827,
      2.402,
      -0.8768,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ],
    [
      -97.4827,
      2.402,
      -2.3768,
      0.75,
      4.8,
      2.4,
      0,
      0.707107,
      0,
      0.707107
    ]
  ]
} as const;
